// src/components/Articles.it.js

import { IM, BM } from './Maths';
import { tex } from '../utils/tex';
import React from "react";
import YouTubeEmbed from "./YouTubeEmbed";
import { trackVideoPlay } from "../hooks/useAnalytics";
import { withUtm } from "../utils/utm";
import MktMacro from "../assets/mkt-macro-it.png";
import MktGeo from "../assets/mkt-geo-it.png";
import MktBonds from "../assets/mkt-bonds-it.png";
import MktSectors from "../assets/mkt-sectors-it.png";
import CoverDerivatiPillar from "../assets/kb-cover-derivati-pillar-it.jpg";
import CoverFutures1 from "../assets/kb-cover-futures1-it.jpg";
import CoverFutures2 from "../assets/kb-cover-futures2-it.jpg";
import CoverCertificati from "../assets/kb-cover-certificati-it.jpg";
import CoverMetriche from "../assets/kb-cover-metriche.jpg";
import CoverMarketUpdate from "../assets/kb-cover-marketupdate-it.jpg";
import CoverEtfRace from "../assets/kb-cover-etfrace.jpg";
import CoverRiskLab from "../assets/kb-cover-risk-lab.png";
// --- in cima al file, dopo gli altri import ---
import EtfCorrHeatmap from "../assets/etf-corr-heatmap.png";
import EtfDendrogram from "../assets/etf-dendrogram.png";
import EtfAnnualHeatmap from "../assets/etf-annual-heatmap.JPG";
import EconomicRegimeClock from "../assets/economic-regime-clock.jpg";
import dlAnnualized from "../assets/dl-annualized.png";
import dlAllocEpochs from "../assets/dl-alloc-epochs.png";
import dlWeightsAvg from "../assets/dl-weights-avg.png";
import fig1 from "../assets/fig1_dl-etf-global-pred-long.png";
import fig2 from "../assets/fig2_dl-etf-global-pred-short.png"; 
import fig3 from "../assets/fig3_dl-etf-global-bull-sim-hist.png"; 
import fig4 from "../assets/fig4_dl-etf-global-bull-sim-movements-hist.png"; 
import fig5 from "../assets/fig5_dl-etf-global-bull-sim-synth.png"; 
import fig6 from "../assets/fig6_dl-etf-global-bull-sim-movements-synth.png"; 
import fig7 from "../assets/fig7_dl-etf-global-covid-sim-hist.png"; 
import fig8 from "../assets/fig8_dl-etf-global-covid-sim-movements-hist.png"; 
import fig9 from "../assets/fig9_dl-etf-global-covid-sim-synth.png";
import fig10 from "../assets/fig10_dl-etf-global-covid-sim-movements-synth.png";
  // --- IMPORT FIGURE (salva i PNG in: src/assets/fx-hedged/) ---
import fxFig1 from "../assets/headgedSP500.png"; // S&P 500: hedged vs unhedged vs perfect hedge
import fxFig2 from "../assets/headgedGlobal.png"; // MSCI World: hedged vs unhedged vs perfect hedge
import fxFig3 from "../assets/headgedTLT.png"; // Treasury 20+ anni: hedged vs unhedged vs perfect hedge
import MTC from "../assets/MontecarloSimulationCover.JPG";
import DLIntroCover from "../assets/DLIntroCover.png";
import EcoClockCover from "../assets/EcoClockCover.png";
import IndFinCover from "../assets/IndFinCover.png";
import EtfClusterCover   from "../assets/EtfClusterCover.png";
import HedgedCover from "../assets/HedgedCover.png";
import FactorCover from "../assets/FactorCover.png";
import PsyCover from "../assets/PsyCover.png";
import HumanCapitalCover from "../assets/HumanCapCover.png";
import DLSyntCover from "../assets/DLSyntCover.png";
import AlphaBetaCover from "../assets/AlphaBetaCover.png";
import AlphaBetaPlot from "../assets/AlphaBetaPlot.png";
import ocfcover from "../assets/ocfcover.png";
// nel file dove usi le formule
import 'katex/dist/katex.min.css';




/**
 * NOTE SEO:
 * - Aggiunti: slug, author, datePublished, dateUpdated, coverImage, canonical
 * - Esporta anche getArticleBySlug(slug)
 */

const DOMAIN = "https://alphaweb-93f02.web.app";// <-- metti il tuo dominio produzione

const articles = [

  // Aggiungi questo oggetto all'array `articles` in src/components/Articles.js
  
  // IT: Simulatore portafoglio ETF — guida metodologica e matematica
  {
    slug: "simulatore-portafoglio-etf-guida-metodologica",
    title: "Simulatore portafoglio ETF: guida metodologica e matematica",
    metaDescription:
      "Simulatore di portafoglio ETF: come funziona, quali metriche usa (Sharpe, Sortino, drawdown), assunzioni e limiti. Scopo educativo per valutare PIC e PAC e la relazione rischio/rendimento.",
    tags: ["quant", "etf", "educazione"],
    readTime: "12 min",
    author: "Redazione",
    datePublished: "2025-08-22",
    dateUpdated: "2025-08-22",
    coverImage: MTC,
    canonical: `${DOMAIN}/kb/simulatore-portafoglio-etf-guida-metodologica`,
    content: (
      <div>
        <h1>Simulatore portafoglio ETF: guida metodologica e matematica</h1>

        <p>
          Questa guida fornisce una disamina completa dei risultati generati dal
          <strong> Simulatore Portafoglio Quantitativo di AlphaFrame</strong> alla luce di un aggiornamento
          del codice e dell’input di versamenti. A differenza della versione precedente, ora il simulatore
          separa chiaramente le metriche calcolate sull’<em>indice del portafoglio</em> (performance senza
          flussi di cassa) da quelle calcolate sulla <em>ricchezza dell’investitore</em> (che include i
          versamenti periodici). In questo studio utilizziamo un capitale iniziale di 10 000 $, un orizzonte
          di 20 anni e, per gli scenari PAC, un versamento mensile di 1 000 $. Gli scenari PIC non prevedono
          versamenti mensili. Per usare il simulatore vai alla pagina{" "}
          <a href={withUtm("https://alphaweb-93f02.web.app/it/tools", { source: "site", medium: "article", campaign: "simulatore-etf" })} target="_blank" rel="noopener noreferrer">
            Tools (versione italiana)
          </a>{" "}
          e guarda anche il video dimostrativo qui sotto, che mostra come configurare gli scenari e leggere gli output.
        </p>

        <YouTubeEmbed
          videoId="misCKs7346o"
          title="Simulatore portafoglio ETF — video dimostrativo"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <YouTubeEmbed
          videoId="OXcoxv6WWD4"
          title="Come simulare un portafoglio: backtest storico e Monte Carlo"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>1. Metodologia e formule</h2>

        <h3>Backtest storico</h3>
        <p>
          <strong>Allineamento EoM</strong> – I prezzi degli ETF sono allineati all’ultimo giorno di ciascun
          mese (End-of-Month), garantendo la comparabilità delle serie temporali. Per ogni ETF selezionato si
          calcola la serie di prezzi di fine mese.
        </p>
        <p>
          <strong>Rendimenti logaritmici</strong> – Per ciascun ETF si calcola il rendimento logaritmico mensile:
        </p>
        <p>
          <BM>{tex`r_t \;=\; \ln\!\left(\frac{p_t}{p_{t-1}}\right)`}</BM>
        </p>
        <p>
          La serie del portafoglio è la media ponderata dei log-rendimenti degli ETF (ribilanciamento mensile implicito).
        </p>
        <p>
          <strong>Indice di portafoglio</strong> – Partendo da 1, l’indice si evolve come:
        </p>
        <p>
          <BM>{tex`I_t \;=\; I_{t-1}\,\exp\!\big(r^{(p)}_t\big), \quad I_0 = 1`}</BM>
        </p>
        <p>
          Questo indice rappresenta la performance del portafoglio senza flussi di cassa.
        </p>
        <p>
          <strong>Ricchezza con versamenti</strong> – Separatamente, si costruisce la serie di ricchezza dell’investitore:
        </p>
        <p>
          <BM>
            {tex`W_t \;=\; \big(W_{t-1} + D\big)\,\exp\!\big(r^{(p)}_t\big), \quad W_0 = \text{capitale iniziale}`}
          </BM>
        </p>
        <p>
          dove <IM>{tex`D`}</IM> è il versamento mensile (0 per PIC, 1 000 $ per PAC). Per gli scenari PAC il capitale
          investito totale dopo 20 anni è{" "}
          <IM>{tex`10{,}000 + 20\times 12\times 1{,}000 = 250{,}000\ \text{USD}`}</IM>; per i PIC rimane 10 000 $.
        </p>

        <p><strong>Metriche sull’indice (Portafoglio)</strong></p>
        <ul>
          <li><strong>CAGR</strong> (tasso annuo composto) del portafoglio.</li>
          <li>
            <strong>Sharpe</strong> e <strong>Sortino</strong> ratio (rendimenti aggiustati per volatilità totale e per
            volatilità al ribasso):
            <BM>
              {tex`\text{Sharpe}_\text{ann} \;=\; \frac{\mu_m}{\sigma_m}\,\sqrt{12}, \qquad \text{Sortino}_\text{ann} \;=\; \frac{\mu_m}{\sigma_{m,\text{down}}}\,\sqrt{12}`}
            </BM>
          </li>
          <li>
            <strong>Max Drawdown (MDD)</strong>, <strong>Ulcer Index</strong> e <em>time under water</em> dell’indice
            (tempo medio e massimo in mesi in cui l’indice resta sotto il massimo precedente).
          </li>
        </ul>

        <p><strong>Metriche sulla ricchezza (Investitore)</strong></p>
        <ul>
          <li>Capitale investito (iniziale più versamenti).</li>
          <li>Capitale finale (ricchezza a fine backtest).</li>
          <li>
            MDD, Ulcer Index e durate sott’acqua sulla serie di ricchezza <IM>{tex`W_t`}</IM> (i versamenti periodici
            mitigano profondità e durata dei drawdown).
          </li>
        </ul>

        <h3>Simulazione Monte Carlo</h3>
        <p>
          Per modellare l’incertezza futura, i rendimenti mensili degli ETF sono campionati da una{" "}
          <em>normale multivariata</em> parametrizzata da medie, deviazioni standard e matrice di correlazione dei
          log-rendimenti storici. Ogni simulazione genera un percorso di 240 mesi (20 anni) e si calcolano:
        </p>
        <ul>
          <li>
            <em>Indice</em>: mediana, 5° e 95° percentile dell’indice finale; CAGR, Sharpe, Sortino, MDD e Ulcer Index
            sulla traiettoria mediana.
          </li>
          <li>
            <em>Investitore</em>: capitale investito (10 000 $ + 20×12×1 000 $ = 250 000 $ per PAC, 10 000 $ per PIC),
            mediana del capitale finale, CAGR, MDD sulla traiettoria mediana e percentili 5°/95° del capitale finale.
          </li>
        </ul>

        <h3>Interpretazione delle metriche e motivazioni</h3>
        <p>
          <strong>CAGR</strong> – misura la media geometrica di crescita dell’indice nel periodo del backtest e penalizza
          implicitamente la volatilità (media geometrica ≤ media aritmetica). Nella MC calcoliamo anche il CAGR della
          ricchezza finale mediana rispetto ai contributi totali.
        </p>
        <p>
          <strong>Sharpe</strong> – rendimento per unità di rischio totale; valori &gt;1 sono eccellenti, ~0,5 moderati,
          &lt;0,2 deboli. Penalizza in modo simmetrico volatilità al rialzo e al ribasso.
        </p>
        <p>
          <strong>Sortino</strong> – sostituisce la volatilità totale con la <em>downside deviation</em> (solo perdite);
          un Sortino &gt; Sharpe indica volatilità prevalentemente positiva.
        </p>
        <p>
          <strong>MDD</strong> – perdita cumulativa massima dall’ultimo picco; avvisa sulla profondità dei cali necessari da sopportare.
        </p>
        <p>
          <strong>Ulcer Index</strong> – radice della media dei drawdown percentuali al quadrato; più sensibile alla
          durata dei periodi di sofferenza che a singoli eventi.
        </p>
        <p>
          <strong>Tempo sott’acqua</strong> – mesi consecutivi sotto il massimo precedente (media e massimo).
        </p>
        <p>
          <strong>Rapporto rischio/rendimento</strong> – usiamo{" "}
          <IM>{tex`\text{CAGR} / \text{MDD}`}</IM> come metrica sintetica (simile al Calmar) per confrontare portafogli.
        </p>

        <h2>2. Scenari e pesi</h2>
        <p>Analizziamo sei combinazioni di asset allocation e versamenti:</p>
        <table>
          <thead>
            <tr>
              <th>Scenario</th>
              <th>ETF selezionati</th>
              <th>Versamento mensile</th>
              <th>Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tech PAC</td>
              <td>Solo Global Tech</td>
              <td>1 000 $</td>
              <td>portafoglio concentrato con versamenti</td>
            </tr>
            <tr>
              <td>Tech PIC</td>
              <td>Solo Global Tech</td>
              <td>0 $</td>
              <td>investimento lump-sum tecnologico</td>
            </tr>
            <tr>
              <td>Utilities PAC</td>
              <td>Solo Global Utilities</td>
              <td>1 000 $</td>
              <td>portafoglio difensivo con versamenti</td>
            </tr>
            <tr>
              <td>Utilities PIC</td>
              <td>Solo Global Utilities</td>
              <td>0 $</td>
              <td>investimento lump-sum difensivo</td>
            </tr>
            <tr>
              <td>Equal PAC</td>
              <td>Dieci ETF equi-pesati</td>
              <td>1 000 $</td>
              <td>portafoglio diversificato con versamenti</td>
            </tr>
            <tr>
              <td>Equal PIC</td>
              <td>Stessi dieci ETF equi-pesati</td>
              <td>0 $</td>
              <td>investimento lump-sum diversificato</td>
            </tr>
          </tbody>
        </table>

        <h2>3. Risultati del backtest</h2>
        <h3>3.1 Portafoglio (indice senza flussi)</h3>
        <table>
          <thead>
            <tr>
              <th>Scenario</th>
              <th>CAGR</th>
              <th>Sharpe</th>
              <th>Sortino</th>
              <th>MDD</th>
              <th>Ulcer Idx</th>
              <th>Avg TUW</th>
              <th>Max TUW</th>
              <th>Rapporto (CAGR/MDD)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tech PAC</td>
              <td>13,93 %</td>
              <td>0,672</td>
              <td>0,623</td>
              <td>52,53 %</td>
              <td>13,82 %</td>
              <td>5,1</td>
              <td>52</td>
              <td>0,29</td>
            </tr>
            <tr>
              <td>Tech PIC</td>
              <td>13,93 %</td>
              <td>0,672</td>
              <td>0,623</td>
              <td>52,53 %</td>
              <td>13,82 %</td>
              <td>5,1</td>
              <td>52</td>
              <td>0,46</td>
            </tr>
            <tr>
              <td>Utilities PAC</td>
              <td>5,19 %</td>
              <td>0,344</td>
              <td>0,302</td>
              <td>43,85 %</td>
              <td>16,21 %</td>
              <td>10,8</td>
              <td>102</td>
              <td>0,12</td>
            </tr>
            <tr>
              <td>Utilities PIC</td>
              <td>5,19 %</td>
              <td>0,344</td>
              <td>0,302</td>
              <td>43,85 %</td>
              <td>16,21 %</td>
              <td>10,8</td>
              <td>102</td>
              <td>0,16</td>
            </tr>
            <tr>
              <td>Equal PAC</td>
              <td>6,80 %</td>
              <td>0,418</td>
              <td>0,375</td>
              <td>51,73 %</td>
              <td>13,27 %</td>
              <td>5,7</td>
              <td>65</td>
              <td>0,18</td>
            </tr>
            <tr>
              <td>Equal PIC</td>
              <td>6,80 %</td>
              <td>0,418</td>
              <td>0,375</td>
              <td>51,73 %</td>
              <td>13,27 %</td>
              <td>5,7</td>
              <td>65</td>
              <td>0,13</td>
            </tr>
          </tbody>
        </table>

        <p>
          <em>Osservazioni</em>: Gli scenari PAC e PIC hanno identiche metriche sull’indice (i versamenti non alterano
          la performance del portafoglio puro), ma influiscono sulla ricchezza e sui drawdown dell’investitore. Il 100 % tech
          mostra il CAGR più alto (~13,9 %) ma anche MDD &gt; 52 %. Utilities è il più difensivo (bassa volatilità e
          rendimento più contenuto). Equal-weight è intermedio, con drawdown simili al tech ma rendimento medio (~6,8 %).
        </p>

        <h3>3.2 Investitore (ricchezza con versamenti)</h3>
        <table>
          <thead>
            <tr>
              <th>Scenario</th>
              <th>Investito tot.</th>
              <th>Capitale finale</th>
              <th>MDD (ricchezza)</th>
              <th>Ulcer Idx</th>
              <th>Avg TUW</th>
              <th>Max TUW</th>
              <th>Rapporto (CAGR/MDD)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tech PAC</td>
              <td>233 000 $</td>
              <td>1 539 124 $</td>
              <td>33,55 %</td>
              <td>7,69 %</td>
              <td>2,74</td>
              <td>18</td>
              <td>0,20</td>
            </tr>
            <tr>
              <td>Tech PIC</td>
              <td>10 000 $</td>
              <td>112 898 $</td>
              <td>52,53 %</td>
              <td>13,82 %</td>
              <td>5,1</td>
              <td>52</td>
              <td>0,46</td>
            </tr>
            <tr>
              <td>Utilities PAC</td>
              <td>233 000 $</td>
              <td>495 284 $</td>
              <td>20,29 %</td>
              <td>4,36 %</td>
              <td>3,06</td>
              <td>12</td>
              <td>0,09</td>
            </tr>
            <tr>
              <td>Utilities PIC</td>
              <td>10 000 $</td>
              <td>25 602 $</td>
              <td>43,85 %</td>
              <td>16,21 %</td>
              <td>10,8</td>
              <td>102</td>
              <td>0,16</td>
            </tr>
            <tr>
              <td>Equal PAC</td>
              <td>233 000 $</td>
              <td>578 743 $</td>
              <td>25,87 %</td>
              <td>5,22 %</td>
              <td>2,81</td>
              <td>15</td>
              <td>0,16</td>
            </tr>
            <tr>
              <td>Equal PIC</td>
              <td>10 000 $</td>
              <td>33 943 $</td>
              <td>51,73 %</td>
              <td>13,27 %</td>
              <td>5,7</td>
              <td>65</td>
              <td>0,13</td>
            </tr>
          </tbody>
        </table>

        <p>
          <em>Osservazioni</em>: I versamenti mensili mitigano i drawdown e accorciano le durate sott’acqua (es. Tech PAC:
          Max TUW 18 mesi vs 52 dell’indice). Il capitale finale del Tech PAC (≈1,54 M $) è quasi triplo dell’equal-weight
          PAC. Il rapporto CAGR/MDD sulla ricchezza scende nel Tech PAC (0,20) rispetto al Tech PIC (0,46) perché la base
          di capitale investito è più ampia e “diluisce” la crescita percentuale.
        </p>

        <h2>4. Risultati delle simulazioni Monte Carlo</h2>

        <h3>4.1 Portafoglio (indice senza flussi)</h3>
        <table>
          <thead>
            <tr>
              <th>Scenario</th>
              <th>Mediana indice finale</th>
              <th>CAGR</th>
              <th>Sharpe</th>
              <th>Sortino</th>
              <th>MDD</th>
              <th>Ulcer Idx</th>
              <th>5° perc.</th>
              <th>95° perc.</th>
              <th>Rapporto</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tech PAC</td>
              <td>12,01</td>
              <td>13,23 %</td>
              <td>0,64</td>
              <td>0,67</td>
              <td>45,33 %</td>
              <td>16,60 %</td>
              <td>2,48</td>
              <td>49,83</td>
              <td>0,29</td>
            </tr>
            <tr>
              <td>Tech PIC</td>
              <td>14,58</td>
              <td>14,34 %</td>
              <td>0,73</td>
              <td>0,86</td>
              <td>31,31 %</td>
              <td>10,18 %</td>
              <td>2,70</td>
              <td>52,85</td>
              <td>0,46</td>
            </tr>
            <tr>
              <td>Utilities PAC</td>
              <td>2,72</td>
              <td>5,13 %</td>
              <td>0,34</td>
              <td>0,33</td>
              <td>41,13 %</td>
              <td>18,22 %</td>
              <td>0,99</td>
              <td>8,88</td>
              <td>0,12</td>
            </tr>
            <tr>
              <td>Utilities PIC</td>
              <td>2,79</td>
              <td>5,27 %</td>
              <td>0,33</td>
              <td>0,34</td>
              <td>32,86 %</td>
              <td>11,75 %</td>
              <td>1,11</td>
              <td>8,72</td>
              <td>0,16</td>
            </tr>
            <tr>
              <td>Equal PAC</td>
              <td>4,29</td>
              <td>7,56 %</td>
              <td>0,46</td>
              <td>0,50</td>
              <td>41,93 %</td>
              <td>15,82 %</td>
              <td>1,34</td>
              <td>11,67</td>
              <td>0,18</td>
            </tr>
            <tr>
              <td>Equal PIC</td>
              <td>3,64</td>
              <td>6,67 %</td>
              <td>0,43</td>
              <td>0,43</td>
              <td>50,17 %</td>
              <td>17,82 %</td>
              <td>1,15</td>
              <td>10,62</td>
              <td>0,13</td>
            </tr>
          </tbody>
        </table>

        <h3>4.2 Investitore (ricchezza con versamenti)</h3>
        <table>
          <thead>
            <tr>
              <th>Scenario</th>
              <th>Investito tot.</th>
              <th>Mediana capitale finale</th>
              <th>CAGR</th>
              <th>MDD (ricchezza)</th>
              <th>5° perc.</th>
              <th>95° perc.</th>
              <th>Rapporto</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tech PAC</td>
              <td>250 000 $</td>
              <td>1 255 019 $</td>
              <td>8,40 %</td>
              <td>42,11 %</td>
              <td>462 437 $</td>
              <td>3 696 600 $</td>
              <td>0,20</td>
            </tr>
            <tr>
              <td>Tech PIC</td>
              <td>10 000 $</td>
              <td>145 824 $</td>
              <td>14,34 %</td>
              <td>31,31 %</td>
              <td>26 983 $</td>
              <td>528 456 $</td>
              <td>0,46</td>
            </tr>
            <tr>
              <td>Utilities PAC</td>
              <td>250 000 $</td>
              <td>449 264 $</td>
              <td>2,97 %</td>
              <td>31,58 %</td>
              <td>226 127 $</td>
              <td>1 001 630 $</td>
              <td>0,09</td>
            </tr>
            <tr>
              <td>Utilities PIC</td>
              <td>10 000 $</td>
              <td>27 938 $</td>
              <td>5,27 %</td>
              <td>32,86 %</td>
              <td>11 061 $</td>
              <td>87 241 $</td>
              <td>0,16</td>
            </tr>
            <tr>
              <td>Equal PAC</td>
              <td>250 000 $</td>
              <td>574 446 $</td>
              <td>4,25 %</td>
              <td>26,28 %</td>
              <td>275 875 $</td>
              <td>1 377 700 $</td>
              <td>0,16</td>
            </tr>
            <tr>
              <td>Equal PIC</td>
              <td>10 000 $</td>
              <td>36 364 $</td>
              <td>6,67 %</td>
              <td>50,17 %</td>
              <td>11 453 $</td>
              <td>106 204 $</td>
              <td>0,13</td>
            </tr>
          </tbody>
        </table>

        <h2>5. Confronto e implicazioni</h2>
        <ul>
          <li>
            <strong>Concentrato vs difensivo</strong> – 100 % Tech massimizza rendimento ma aumenta drawdown e dispersione
            degli esiti; Utilities riduce volatilità ma con CAGR modesto; Equal-weight è un compromesso.
          </li>
          <li>
            <strong>PIC vs PAC</strong> – I versamenti mensili riducono drawdown e tempi sott’acqua, ma diluiscono il CAGR
            sulla ricchezza totale; il PIC sfrutta di più il compounding, a costo di drawdown più lunghi.
          </li>
        </ul>

        <h2>6. Conclusioni</h2>
        <p>
          Il simulatore AlphaFrame, con la distinzione tra <em>indice</em> e <em>ricchezza</em>, aiuta a comprendere il
          trade-off rischio/rendimento. Le simulazioni Monte Carlo ricordano che il futuro può discostarsi notevolmente dal
          passato: gli intervalli 5°–95° percentile mostrano la gamma di risultati plausibili. La scelta dell’allocazione e
          della modalità di contribuzione va allineata a obiettivi, tolleranza al rischio e capacità di sostenere periodi
          prolungati di drawdown.
        </p>

        <h3>Fonti</h3>
        <ul>
          <li>
            Simulatore portafoglio ETF gratuito –{" "}
            <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
              alphaweb-93f02.web.app/it/tools
            </a>
          </li>
        </ul>

        <p>
          <strong>Provalo ora:</strong>{" "}
          <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
            vai ai Tools
          </a>{" "}
          e guarda il{" "}
          <a href="https://youtu.be/misCKs7346o" target="_blank" rel="noopener noreferrer">
            video tutorial
          </a>{" "}
          per vedere passo-passo come impostare PIC e PAC e leggere gli output.
        </p>
      </div>
    ),
  },



  {
  slug: "costruire-portafoglio-etf-ben-diversificato",
  title: "Costruire un Portafoglio di ETF Ben Diversificato",
  metaDescription:
    "Come comporre un portafoglio di ETF efficiente con correlazioni e clustering gerarchico. Esempi pratici, figure e notebook Colab per replicare l’analisi.",
  tags: ["etf", "educazione", "quant"],
  readTime: "12 min",
  author: "Redazione",
  datePublished: "2025-08-22",
  dateUpdated: "2025-08-22",
  coverImage: EtfClusterCover,
  canonical: `${DOMAIN}/kb/costruire-portafoglio-etf-ben-diversificato`,
  content: (
    <div>
      <h1>Costruire un Portafoglio di ETF Ben Diversificato</h1>

      <h2>Introduzione</h2>
      <p>
        L’obiettivo di questa analisi è mostrare come comporre un portafoglio di ETF
        diversificato ed efficiente, eliminando esposizioni ridondanti e massimizzando
        il rapporto rendimento/rischio. Partiremo da un ampio set di ETF coprendo vari
        settori economici, classi di attivo (azioni, obbligazioni, materie prime) e aree
        geografiche, per poi utilizzare strumenti quantitativi (correlazioni e clustering
        gerarchico) al fine di ridurre sovrapposizioni inutili. In altre parole, cercheremo
        di capire quali ETF sono davvero necessari per ottenere una diversificazione
        ottimale e come questi strumenti finanziari si relazionano tra loro da un punto di
        vista statistico. Il percorso che seguiremo riprende i contenuti di un mio video
        YouTube, arricchiti qui con riferimenti a fonti istituzionali e dettagli tecnici
        utili per approfondire il tema. L’analisi è completamente riproducibile tramite
        codice Python eseguibile su Google Colab (senza necessità di installazioni locali)
        che condividerò e spiegherò più avanti.
      </p>

      <p>
        Video:{" "}
        <a href="https://youtu.be/avTItKC9iag" target="_blank" rel="noopener noreferrer">
          Portafoglio ETF e Diversificazione – Video
        </a>{" "}
        • Notebook Colab:{" "}
        <a
          href="https://colab.research.google.com/github/paolobalasso/YoutubeTrading/blob/main/USETFsDataExploration.ipynb#scrollTo=3dDuvLacVODy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Apri su Google Colab
        </a>
      </p>

      <YouTubeEmbed
        videoId="avTItKC9iag"
        title="Portafoglio ETF e Diversificazione — video"
        onPlay={(id) => trackVideoPlay(id, "article")}
      />

        <YouTubeEmbed
          videoId="hr4Fzg0jcQ0"
          title="Ottimizzare il portafoglio con la frontiera efficiente"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

      <h2>Dati e Categorie di ETF</h2>
      <p>
        Un ETF (Exchange-Traded Fund) è un tipo di fondo d’investimento quotato in borsa e a
        gestione passiva, progettato per replicare l’andamento di un indice di mercato.{" "}
        <a
          href="https://it.wikipedia.org/wiki/Exchange-traded_fund"
          target="_blank"
          rel="noopener noreferrer"
        >
          (Wikipedia)
        </a>{" "}
        In pratica, tramite un singolo ETF è possibile investire in un paniere diversificato di
        asset (azioni, obbligazioni, ecc.), ottenendo un’ampia esposizione con un’unica operazione.
        Gli ETF disponibili sul mercato si dividono in diverse categorie, ad esempio per settore,
        area geografica o classe di investimento (azionaria, obbligazionaria, materie prime). Nel
        nostro dataset consideriamo un insieme di 27 ETF statunitensi molto eterogenei, con
        informazioni per ciascuno come il ticker (simbolo), il TER (Total Expense Ratio, costo
        annuo), la capitalizzazione di mercato, il codice ISIN, il broker di riferimento, il
        settore, la classe di attivo, la politica di distribuzione dei proventi (accumulazione vs
        distribuzione con frequenza trimestrale o mensile) e la metodologia di replica dell’indice
        (fisica a campionamento, sintetica, ecc.). La maggior parte di questi fondi sono azionari
        settoriali, ma sono inclusi anche ETF su obbligazioni, su materie prime e su mercati
        azionari di intere regioni.
      </p>

      <p>Per chiarezza, ecco le principali categorie di ETF presenti nel dataset:</p>
      <ul>
        <li>
          <strong>Azionari (Equity)</strong>: fondi che investono in panieri di titoli azionari.
          Possono essere focalizzati su specifici settori (ad es. tecnologia, energia, finanziario,
          sanitario, beni di consumo, utilities, etc.) oppure su aree geografiche (ad es. MSCI
          Europe, MSCI EM mercati emergenti, MSCI EAFE per sviluppati fuori US, ecc.).
        </li>
        <li>
          <strong>Obbligazionari (Fixed Income)</strong>: fondi che investono in titoli a reddito
          fisso. Nel dataset troviamo ETF su Treasury Bond USA di varie scadenze (breve 1–3 anni,
          media 7–10 anni, lunga 20+ anni), su obbligazioni corporate Investment Grade, su
          obbligazioni High Yield (alto rendimento, rating speculativo) e su titoli di Stato di
          mercati emergenti. Sono presenti anche ETF su bond indicizzati all’inflazione e
          <em>convertible securities</em> (obbligazioni convertibili).
        </li>
        <li>
          <strong>Materie Prime (Commodities)</strong>: fondi che seguono l’andamento delle
          commodity. Ad esempio un ETF sull’oro fisico, e alcuni ETF legati a panieri di materie
          prime agricole o energetiche (contratti futures su commodity).
        </li>
        <li>
          <strong>Multi-asset/Altro</strong>: include strumenti particolari non rientranti nelle
          categorie sopra in modo netto. Ad esempio, nel dataset abbiamo un ETF bilanciato in azioni
          convertibili (che combinano caratteristiche azionarie e obbligazionarie).
        </li>
      </ul>
      <p>
        Questa ricca base di dati ci permette di analizzare investimenti molto differenti tra loro.
        Ogni riga del dataset rappresenta un ETF specifico e, grazie alla varietà di classi di
        attivo e settori coperti, possiamo studiare come ciascun ETF si comporta rispetto agli altri
        in termini di correlazione dei rendimenti. L’ipotesi di partenza è che non sia necessario
        detenere tutti questi ETF contemporaneamente: alcuni potrebbero risultare ridondanti,
        muovendosi in maniera molto simile ad altri. Identificando queste sovrapposizioni, possiamo
        semplificare il portafoglio mantenendo solo gli ETF che apportano un reale beneficio in
        termini di diversificazione.
      </p>

      <h2>Analisi delle Correlazioni</h2>
      <figure>
        <img
          src={EtfCorrHeatmap}
          alt="Figura 1: Matrice di correlazione (heatmap) tra 27 ETF"
          style={{ width: "100%", height: "auto" }}
        />
        <figcaption>
          <em>Figura 1</em>: Matrice di correlazione (heatmap) dei rendimenti storici tra i 27 ETF
          considerati. Celle più chiare/rosse indicano alta correlazione positiva, celle più
          scure/blu indicano correlazione bassa o negativa.
        </figcaption>
      </figure>
      <p>
        Come primo passo, calcoliamo la matrice di correlazione tra i rendimenti dei vari ETF,
        visualizzandola nella heatmap di Figura 1. La correlazione misura la similarità tra due
        serie di rendimenti: varia tra −1 e 1, dove valori prossimi a 1 indicano che due ETF si
        muovono quasi all’unisono (relazione positiva perfetta), mentre valori vicini a −1
        indicano che si muovono in direzioni opposte (relazione inversa). Valori intorno a 0
        denotano assenza di relazione lineare. Nel nostro caso vediamo correlazioni che spaziano da
        un massimo di circa +0,99 (quasi perfettamente positiva) a un minimo di circa −0,35
        (moderatamente inversa). Quest’ultimo estremo corrisponde alla correlazione tra l’ETF sui
        Treasury Bond USA a lunghissimo termine (20+ anni) e l’ETF sul settore Finanziario:
        significa che storicamente, quando i titoli di Stato a lunga scadenza salivano, le azioni
        del settore finanziario tendevano a scendere, e viceversa. Questo riflette dinamiche note di{" "}
        <em>flight-to-quality</em>: in fasi di incertezza economica o turbolenza di mercato, gli
        investitori spesso abbandonano le azioni più rischiose per spostarsi su asset ritenuti più
        sicuri come i Treasury bond, facendo sì che questi ultimi salgano di prezzo mentre
        l’azionario scende.{" "}
        <a
          href="https://www.pimco.com/it/it/insights/negative-correlations-positive-allocations"
          target="_blank"
          rel="noopener noreferrer"
        >
          (PIMCO)
        </a>{" "}
        In effetti, a livello generale la correlazione tra mercato azionario e obbligazionario tende
        a farsi bassa o negativa nei periodi di stabilità macroeconomica (bassa inflazione intorno
        al 2%): ciò permette a queste due classi di attivo di bilanciarsi a vicenda in portafoglio,
        riducendo la volatilità complessiva per l’investitore{" "}
        <a
          href="https://www.pimco.com/it/it/insights/negative-correlations-positive-allocations"
          target="_blank"
          rel="noopener noreferrer"
        >
          (PIMCO)
        </a>
        .
      </p>
      <p>
        Osserviamo inoltre che altri ETF obbligazionari presenti (in particolare quelli su Treasury
        bond di varie scadenze) mostrano correlazioni negative o prossime allo zero rispetto agli
        ETF azionari. In termini quantitativi, su orizzonti di lungo periodo la correlazione tra
        obbligazioni governative e azioni è risultata vicina allo zero (ad es. 2000–2020 ~0,11 tra
        indice globale dei Treasury e indice azionario mondiale), mentre l’High Yield risulta molto
        più correlato all’azionario (spesso ~0,7–0,8).{" "}
        <a
          href="https://cdn.janushenderson.com/webdocs/113140_0521_CaseForHighYieldBond_ITA.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          (Janus Henderson)
        </a>
        .
      </p>
      <p>
        Un altro aspetto interessante emerso dalla heatmap è il ruolo dell’oro. L’ETF sull’oro
        mostra correlazione praticamente nulla con gli ETF azionari e solo lieve correlazione
        positiva con i Treasury e con i bond indicizzati all’inflazione: conferma il ruolo di{" "}
        <em>bene rifugio</em> e di diversificatore utile, con copertura durante eventi estremi di
        mercato.{" "}
        <a
          href="https://www.wallstreetitalia.com/oro-i-cinque-motivi-per-puntare-sul-bene-rifugio-per-eccellenza/"
          target="_blank"
          rel="noopener noreferrer"
        >
          (State Street / World Gold Council su WSI)
        </a>
        .
      </p>

      <h2>Clustering Gerarchico per Eliminare Ridondanze</h2>
      <figure>
        <img
          src={EtfDendrogram}
          alt="Figura 2: Dendrogramma del clustering gerarchico sugli ETF (distanza 1−correlazione)"
          style={{ width: "100%", height: "auto" }}
        />
        <figcaption>
          <em>Figura 2</em>: Dendrogramma risultante dal clustering gerarchico sugli ETF (distanza
          basata su <code>1 − correlazione</code>). I colori evidenziano i cluster tagliando
          l’albero alla soglia 0,14.
        </figcaption>
      </figure>
      <p>
        La matrice di correlazioni (27×27) è densa; il clustering gerarchico raggruppa gli ETF in
        base alla similarità dei loro andamenti usando la distanza{" "}
        <code>d<sub>ij</sub> = 1 − ρ<sub>ij</sub></code>. Leggendo il dendrogramma, ad es. MSCI
        Europe e MSCI EAFE sono uniti a distanza quasi nulla (correlazione ~0,99). Gli ETF geografici
        sviluppati formano un cluster; gli EM risultano più distanti. Healthcare e Consumer
        Defensive compaiono uniti a bassa distanza (settori difensivi). L’oro resta isolato in alto
        (massima diversificazione). I Treasury a varie scadenze formano un gruppo distinto dagli
        azionari. Per selezionare un set snello, si può tagliare l’albero a 0,14 (≈ correlazione
        0,86) e tenere un solo ETF rappresentativo per cluster (quello col rendimento storico
        migliore). Approcci di selezione “per cluster” sono proposti anche in letteratura per
        migliorare la diversificazione con meno titoli.{" "}
        <a
          href="https://fsc.stevens.edu/network-and-clustering-based-portfolio-optimization-enhancing-risk-adjusted-performance-through-diversification/"
          target="_blank"
          rel="noopener noreferrer"
        >
          (Stevens Institute of Technology)
        </a>
        .
      </p>

      <h2>Rendimento e Rischio degli ETF Selezionati</h2>
      <p>
        Eliminati i duplicati, valutiamo per ciascun ETF rendimento annuo composto, volatilità,
        Sharpe e max drawdown. In cima troviamo spesso <strong>Tecnologia</strong> (massimi
        rendimenti ma anche rischio elevato): motore “offensivo” che può subire drawdown marcati
        nelle fasi negative.{" "}
        <a
          href="https://www.alliancebernstein.com/it/it/adviser/insights/investment-insights/redefining-offense-and-defense-in-equities-the-evolution-of-technology-and-healthcare.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          (AllianceBernstein)
        </a>
        . <strong>Sanità</strong> mostra rendimento solido con volatilità più contenuta: settore
        difensivo che tende a proteggere nei momenti difficili{" "}
        <a
          href="https://www.alliancebernstein.com/it/it/adviser/insights/investment-insights/redefining-offense-and-defense-in-equities-the-evolution-of-technology-and-healthcare.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          (AB)
        </a>
        . Sul fronte bond, gli <strong>High Yield</strong> hanno resi storicamente interessanti con
        volatilità inferiore alle azioni, ma correlazione elevata con l’azionario (~0,7–0,8), quindi
        minore potere di diversificazione nelle crisi{" "}
        <a
          href="https://cdn.janushenderson.com/webdocs/113140_0521_CaseForHighYieldBond_ITA.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          (Janus Henderson)
        </a>
        . I <strong>Treasury</strong> hanno resi più modesti, ma bassa/negativa correlazione con le
        asset rischiose e quindi riducono il rischio complessivo di portafoglio{" "}
        <a
          href="https://www.pimco.com/it/it/insights/negative-correlations-positive-allocations"
          target="_blank"
          rel="noopener noreferrer"
        >
          (PIMCO)
        </a>
        . L’<strong>Oro</strong> aggiunge decorrelazione e migliora i rendimenti corretti per il
        rischio su portafogli ampi{" "}
        <a
          href="https://www.wallstreetitalia.com/oro-i-cinque-motivi-per-puntare-sul-bene-rifugio-per-eccellenza/"
          target="_blank"
          rel="noopener noreferrer"
        >
          (WGC/SSGA via WSI)
        </a>
        .
      </p>

      <figure>
        <img
          src={EtfAnnualHeatmap}
          alt="Figura 3: Heatmap dei rendimenti annuali per ETF"
          style={{ width: "100%", height: "auto" }}
        />
        <figcaption>
          <em>Figura 3</em>: Heatmap dei rendimenti annuali (colonne: anno; righe: ETF selezionati).
          Le celle verdi indicano anni di forte rendimento; quelle rosse anni negativi.
        </figcaption>
      </figure>

      <h2>Riproduzione dell’Analisi con Google Colab</h2>
      <p>
        Una parte fondamentale di questo progetto è la possibilità per chiunque di replicare
        l’analisi e personalizzarla, utilizzando il codice Python disponibile in un notebook su
        Google Colab. Google Colab è una piattaforma online che consente di eseguire codice Jupyter
        Notebook direttamente nel browser, senza installare nulla sul proprio PC, sfruttando
        risorse cloud.
      </p>
      <ol>
        <li>
          <strong>Accesso al notebook</strong>: apri{" "}
          <a
            href="https://colab.research.google.com/github/paolobalasso/YoutubeTrading/blob/main/USETFsDataExploration.ipynb#scrollTo=3dDuvLacVODy"
            target="_blank"
            rel="noopener noreferrer"
          >
            questo link Colab
          </a>
          . Troverai celle di codice e testo pronte all’uso.
        </li>
        <li>
          <strong>Importazione librerie</strong>: esegui le prime celle (pandas, numpy, matplotlib,
          scipy, funzioni di utilità).
        </li>
        <li>
          <strong>Caricamento dei dati</strong>: la tabella anagrafica (ticker, TER, settore, ecc.)
          viene letta da file; verifica l’anteprima.
        </li>
        <li>
          <strong>Prezzi storici</strong>: carica le serie dei prezzi; puoi allungare o accorciare
          l’orizzonte (es. 1–10+ anni) modificando i parametri.
        </li>
        <li>
          <strong>Prezzo vs Total Return</strong>: grafico didattico con dividendi reinvestiti per un
          ETF a scelta.
        </li>
        <li>
          <strong>Correlazioni</strong>: calcolo e heatmap dei rendimenti (giornalieri o mensili).
        </li>
        <li>
          <strong>Clustering gerarchico</strong>: parametro <code>distance_threshold</code> (es.
          0,14 ≈ correlazione 0,86) per definire i cluster; selezione automatica dell’ETF migliore
          per cluster.
        </li>
        <li>
          <strong>Visualizzazioni</strong>: tabella metriche e grafico interattivo Plotly
          (rendimenti vs volatilità).
        </li>
      </ol>

      <h2>Conclusioni</h2>
      <p>
        In questo studio abbiamo dimostrato un approccio <em>data-driven</em> alla costruzione di un
        portafoglio di ETF ben diversificato. Partendo da un insieme eterogeneo di fondi,
        correlazioni e clustering hanno evidenziato duplicati di esposizione. Eliminandoli,
        rimane una selezione più ristretta in cui ogni ETF svolge un ruolo distinto (azioni per
        regioni/settori, governativi e corporate, oro, ecc.). La chiave è bilanciare componenti
        difensive (oro, Treasury) e offensive (tech, high yield) secondo il proprio profilo.
      </p>
      <p>
        Spesso non serve detenere decine di ETF: è più efficace sceglierne pochi ben mirati che
        coprano aree realmente complementari. Nei prossimi approfondimenti partiremo da questa rosa
        per affrontare il tema dei pesi ottimali.
      </p>
      <p>
        Domande o dubbi? Prova il notebook, sperimenta e{" "}
        <a href="/contact">scrivimi</a>. E se preferisci il formato video, ecco il{" "}
        <a href="https://youtu.be/avTItKC9iag" target="_blank" rel="noopener noreferrer">
          tutorial completo su YouTube
        </a>
        .
      </p>

      <h2>Fonti</h2>
      <ul>
        <li>
          Wikipedia – Exchange-Traded Fund (ETF):{" "}
          <a
            href="https://it.wikipedia.org/wiki/Exchange-traded_fund"
            target="_blank"
            rel="noopener noreferrer"
          >
            it.wikipedia.org
          </a>
        </li>
        <li>
          PIMCO – Correlazione negativa fra azionario e obbligazionario:{" "}
          <a
            href="https://www.pimco.com/it/it/insights/negative-correlations-positive-allocations"
            target="_blank"
            rel="noopener noreferrer"
          >
            pimco.com
          </a>
        </li>
        <li>
          State Street Global Advisors / World Gold Council – Oro bene rifugio:{" "}
          <a
            href="https://www.wallstreetitalia.com/oro-i-cinque-motivi-per-puntare-sul-bene-rifugio-per-eccellenza/"
            target="_blank"
            rel="noopener noreferrer"
          >
            wallstreetitalia.com
          </a>
        </li>
        <li>
          AllianceBernstein – Tecnologia vs Sanità:{" "}
          <a
            href="https://www.alliancebernstein.com/it/it/adviser/insights/investment-insights/redefining-offense-and-defense-in-equities-the-evolution-of-technology-and-healthcare.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            alliancebernstein.com
          </a>
        </li>
        <li>
          Janus Henderson Investors – High Yield vs Azioni/Treasury:{" "}
          <a
            href="https://cdn.janushenderson.com/webdocs/113140_0521_CaseForHighYieldBond_ITA.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            cdn.janushenderson.com
          </a>
        </li>
        <li>
          Stevens Institute of Technology – Clustering e portafogli:{" "}
          <a
            href="https://fsc.stevens.edu/network-and-clustering-based-portfolio-optimization-enhancing-risk-adjusted-performance-through-diversification/"
            target="_blank"
            rel="noopener noreferrer"
          >
            fsc.stevens.edu
          </a>
        </li>
      </ul>
    </div>
  ),
  },

  {
    slug: "comprendere-regimi-economici-investment-clock",
    title: "Comprendere i Regimi Economici con l’Investment Clock",
    metaDescription:
      "Guida completa ai regimi economici con l’Investment Clock: definizioni, indicatori (PIL reale, inflazione core), allocazioni per fase e link a notebook Colab e video. Include una figura e due tabelle esplicative.",
    tags: ["macro", "educazione", "quant"],
    readTime: "10 min",
    author: "Redazione",
    datePublished: "2025-08-22",
    dateUpdated: "2025-08-22",
    coverImage: EcoClockCover,
    canonical: `${DOMAIN}/kb/comprendere-regimi-economici-investment-clock`,
    content: (
      <div>
        <h1>Comprendere i Regimi Economici con l’Investment Clock</h1>

        <p><strong>Disclaimer:</strong> le informazioni fornite hanno carattere puramente divulgativo e non costituiscono in alcun modo raccomandazioni di investimento. Prima di adottare qualsiasi strategia finanziaria è fondamentale consultare un consulente finanziario qualificato.</p>

        <h2>Introduzione e obiettivi</h2>
        <p>
          L’obiettivo di questo approccio è classificare la fase del ciclo economico in cui ci troviamo mediante indicatori macroeconomici e, di conseguenza, impostare un’allocazione tra asset class che storicamente ha massimizzato le performance in ciascuno scenario. La metodologia presentata, ispirata all’Investment Clock di Merrill Lynch, mira a fornire un framework sistematico e riproducibile, supportato da codice (Google Colab), per effettuare analisi macro-finanziarie in autonomia.
        </p>

        <h2>Il modello teorico: l’Investment Clock</h2>
        <p>
          Il modello dell’Investment Clock nasce dagli studi di Merrill Lynch e sviluppati in seguito da Trevor Greetham di Royal London Asset Management. L’idea è rappresentare il ciclo economico su un quadrante con due assi: inflazione sull’asse orizzontale e crescita economica sull’asse verticale. Secondo RLAM, l’economia attraversa periodi di espansione e contrazione, surriscaldamento e raffreddamento, con l’inflazione che aumenta o diminuisce; ogni fase favorisce asset class differenti.
        </p>
        <p><strong>Le fasi sono quattro:</strong></p>
        <ul>
          <li><strong>Reflazione (Reflection)</strong> – crescita debole e inflazione in calo (fase tipica di mercato ribassista).</li>
          <li><strong>Ripresa (Recovery)</strong> – crescita in accelerazione e inflazione ancora bassa (“Goldilocks”).</li>
          <li><strong>Surriscaldamento (Overheat)</strong> – crescita forte che inizia a scontrarsi con vincoli di offerta, facendo risalire l’inflazione.</li>
          <li><strong>Stagflazione (Stagflation)</strong> – crescita lenta/negativa e inflazione elevata (spesso preceduta da shock energetici).</li>
        </ul>
        <p>Il diagramma dell’Investment Clock riassume quali asset class e settori tendono a performare meglio in ciascuna fase, basandosi su oltre quattro decenni di dati storici.</p>

        {/* Figura 1: immagine */}
        <figure>
          <img
            src={EconomicRegimeClock}
            alt="Figura 1 – Il Business Cycle visto come Investment Clock"
            style={{ width: "100%", height: "auto" }}
          />
          <figcaption>
            <em>Figura 1 – Il “Business Cycle” visto come Investment Clock:</em> a sinistra la fase di reflazione con obbligazioni come asset privilegiato; segue la ripresa (azioni), il surriscaldamento (materie prime) e infine la stagflazione (cash).
          </figcaption>
        </figure>

        <h2>Asset class preferite in ogni fase</h2>
        <p><em>Secondo un approfondimento di RLAM (2024) sul “ClockWise”:</em></p>
        <ul>
          <li><strong>Reflazione</strong> – obbligazioni governative: rendimenti migliori quando la crescita è debole e l’inflazione cala.</li>
          <li><strong>Ripresa</strong> – azioni (stocks): performano al meglio quando la crescita è forte e l’inflazione continua a calare.</li>
          <li><strong>Surriscaldamento</strong> – materie prime (commodities): registrano rendimenti elevati quando sia crescita che inflazione sono in aumento.</li>
          <li><strong>Stagflazione</strong> – liquidità (cash) e ancora materie prime: la liquidità diventa la scelta difensiva mentre le commodities possono restare performanti.</li>
        </ul>
        <p>
          È importante sottolineare che tali associazioni di asset derivano da osservazioni storiche e non garantiscono risultati futuri: i mercati sono complessi e le correlazioni possono variare. Tale allocazione è una prima versione semplificata che contempla solamente 1 asset per regime economico. La difficoltà nel definire il momento esatto in cui il regime economico modifica il suo stato e ha condotto a versioni distribuite su più assets.
        </p>

        <h2>Indicatori macro utilizzati</h2>
        <h3>Prodotto Interno Lordo (PIL)</h3>
        <p>
          Il PIL nominale misura il valore dei beni e servizi prodotti ai prezzi correnti, mentre il PIL reale (o real GDP) corregge il dato per l’inflazione. L’FMI spiega che, per determinare il PIL reale, si deve aggiustare il valore nominale con un deflatore dei prezzi: in questo modo si distingue se l’aumento del valore deriva da una maggiore produzione o solo da prezzi più alti. Il tasso di crescita del PIL reale è quindi un indicatore fondamentale per valutare lo stato di salute dell’economia.
        </p>

        <h3>Inflazione e indice dei prezzi al consumo</h3>
        <p>
          L’Indice dei Prezzi al Consumo (CPI) misura le variazioni medie dei prezzi di un paniere di beni e servizi; tuttavia, per valutare meglio le tendenze di lungo periodo, le banche centrali utilizzano l’inflazione core, che esclude le componenti più volatili (cibo ed energia). La Federal Reserve sottolinea che i banchieri centrali si concentrano sull’inflazione core, ad esempio il deflatore PCE core, perché elimina le fluttuazioni temporanee e fornisce un’indicazione più chiara della tendenza sottostante. Concentrare la politica monetaria sull’inflazione core permette di evitare reazioni eccessive a shock temporanei; l’inflazione core “tenta di separare il segnale dall’errore”, offrendo un quadro migliore delle pressioni inflazionistiche e servendo da guida su dove si dirigerà la stessa inflazione headline.
        </p>

        <h3>Recessioni e business cycle</h3>
        <p>
          Nel determinare le fasi del ciclo, la nostra analisi considera “recessione” un periodo in cui il PIL reale registra due trimestri consecutivi di contrazione. Va ricordato, però, che si tratta di un criterio di convenienza: la Fed di St. Louis spiega che il National Bureau of Economic Research (NBER) utilizza vari indicatori (reddito reale, occupazione, produzione industriale ecc.) per dichiarare ufficialmente una recessione. Rimane comunque vero che “due trimestri negativi” sono frequentemente associati alle recessioni.
        </p>

        <h2>Metodo di classificazione e risultati storici</h2>
        <p>
          Il nodo cruciale riguarda la definizione delle condizioni che definiscono le fasi economiche. La recessione tecnica è associata a “due trimestri negativi”. Nel nostro caso, la fase economica viene determinata valutando sia il PIL reale e l’inflazione core verificando se siano sopra o sotto determinate soglie. Chiaramente questi diventano parametri fondamentali da definire. Nel transcript fornito, si adottano 2,5% come soglia di crescita e 3% come soglia di inflazione: sopra tali valori si parla di “alta” crescita/inflazione, sotto di “bassa”. Incrociando le due variabili si ottengono i quattro regimi (Reflazione: bassa crescita e bassa inflazione; Ripresa: alta crescita e bassa inflazione; Surriscaldamento: alta crescita e alta inflazione; Stagflazione: bassa crescita e alta inflazione).
        </p>
        <p>
          L’analisi storica dal 1947 a oggi (come indicato dal transcript) evidenzia che:
        </p>
        <ul>
          <li>Circa 61% delle volte la crescita del PIL reale è stata sopra il 3% rispetto all’anno precedente.</li>
          <li>Circa 53% delle volte l’inflazione (core) è stata sopra il 3%.</li>
          <li>La fase più rara risulta la stagflazione; seguono la flessione e poi, quasi equamente, recovery e overheat (~30–31% ciascuna).</li>
          <li>Le recessioni degli anni ’80 e la crisi finanziaria del 2008 rientrano in fasi di Reflazione (bassa crescita, inflazione contenuta), mentre gli anni recenti mostrano una combinazione di alta inflazione e crescita moderata simile, a livello di comportamento, a quella dei primi anni ’80.</li>
        </ul>

        <h2>Asset Allocation per ciascuna fase</h2>
        <p>
          Uno schema di asset allocation noto nel mondo dell’Investment Clock è quello proposto da Corey Rittenhouse negli anni ’80, ripreso in vari studi e poi rielaborato da gestori come Ray Dalio (portafoglio All Weather). L’idea è attribuire ad ogni fase una combinazione di asset che abbia storicamente massimizzato rendimento e minimizzato il rischio. Nella versione a quattro asset (azioni, obbligazioni, materie prime, cash), i pesi sono del 100% quando si è certi di essere in quella fase, come mostra la tabella seguente (Figura 2):
        </p>

        {/* Tabella 1: Allocazione “pura” per regime (qualitativa, come da testo) */}
        <figure>
          <table className="kb-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Regime</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Asset prevalenti</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "8px" }}>Reflazione</td>
                <td style={{ padding: "8px" }}>Obbligazioni governative; cash</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Ripresa</td>
                <td style={{ padding: "8px" }}>Azioni (core); possibile supporto dei bond</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Surriscaldamento</td>
                <td style={{ padding: "8px" }}>Materie prime; azioni</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Stagflazione</td>
                <td style={{ padding: "8px" }}>Cash; materie prime</td>
              </tr>
            </tbody>
          </table>
          <figcaption>
            <em>Figura 2 – Allocazione “pura” per ciascuno dei quattro regimi:</em> azioni e bond per la Ripresa; materie prime e azioni nel Surriscaldamento; cash e commodities nella Stagflazione; bond e cash nella Reflazione.
          </figcaption>
        </figure>

        <p>
          Se non si ha certezza dello scenario, si può attribuire una probabilità di accadimento a ciascuna fase. Ad esempio, assumendo la stessa probabilità (25%) per ogni scenario, si ottiene un portafoglio permanente al 25% di ogni asset (azioni, obbligazioni, commodities, oro/liquidità). Questo approccio è simile al concetto di portafoglio permanent di Harry Browne o All Weather di Ray Dalio.
        </p>
        <p>
          Per una diversificazione maggiore, Rittenhouse propone una matrice a sei asset (azioni, bond dei mercati emergenti, commodities, bond corporate, Treasury bond e inflation-linked bond). Nello schema seguente (Figura 3), le righe rappresentano gli asset, le colonne i regimi, e i valori esprimono la percentuale da investire se si è certi di trovarsi in quel regime:
        </p>

        {/* Tabella 2: Portafoglio All Weather statico (probabilità uniformi, 6 asset) */}
        <figure>
          <table className="kb-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Asset</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Peso con probabilità uniformi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "8px" }}>Azioni</td>
                <td style={{ padding: "8px" }}>20%</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Bond Mercati Emergenti</td>
                <td style={{ padding: "8px" }}>15%</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Commodities</td>
                <td style={{ padding: "8px" }}>14%</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Bond Corporate</td>
                <td style={{ padding: "8px" }}>6,25%</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Treasury Bond</td>
                <td style={{ padding: "8px" }}>25%</td>
              </tr>
              <tr>
                <td style={{ padding: "8px" }}>Inflation-Linked Bond</td>
                <td style={{ padding: "8px" }}>20%</td>
              </tr>
            </tbody>
          </table>
          <figcaption>
            <em>Figura 3 – Allocazione con 6 asset (versione statica con probabilità uniformi):</em> composizione indicativa ispirata allo schema Rittenhouse/All Weather. Le ripartizioni per singolo regime possono essere definite nel notebook Colab.
          </figcaption>
        </figure>

        <h2>Considerazioni finali</h2>
        <ul>
          <li>Il modello dell’Investment Clock offre un framework per comprendere la posizione nel ciclo economico e orientare l’asset allocation.</li>
          <li>L’uso del PIL reale e dell’inflazione core permette di classificare le fasi in maniera trasparente.</li>
          <li>Le schede di Corey Rittenhouse (4 o 6 asset) mostrano come ripartire il portafoglio a seconda del regime; combinando le fasi con probabilità si ottiene un portafoglio robusto e bilanciato.</li>
        </ul>
        <p>
          Va ribadito che queste associazioni derivano da analisi storiche e non garantiscono risultati futuri. Ogni investitore dovrebbe considerare il proprio orizzonte temporale, la propria tolleranza al rischio e consultare un professionista prima di implementare strategie basate su questi modelli.
        </p>

        <h2>Link utili</h2>
        <ul>
          <li>
            <strong>Notebook Colab (metodologia):</strong> EconomicRegime.ipynb —{" "}
            <a href="https://colab.research.google.com/github/paolobalasso/YoutubeTrading/blob/main/EconomicRegime.ipynb#scrollTo=hs1XKYDccmTP" target="_blank" rel="noopener noreferrer">
              Apri su Google Colab
            </a>
          </li>
          <li>
            <strong>Video YouTube:</strong>{" "}
            <a href="https://youtu.be/vxvqfH1qfuE" target="_blank" rel="noopener noreferrer">
              https://youtu.be/vxvqfH1qfuE
            </a>
          </li>
        </ul>

        <YouTubeEmbed
          videoId="vxvqfH1qfuE"
          title="Regimi economici e Investment Clock — video"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>Fonti principali</h2>
        <ul>
          <li>RLAM “ClockWise” (asset per fase del ciclo) — <a href="https://www.rlam.com" target="_blank" rel="noopener noreferrer">rlam.com</a></li>
          <li>Definizioni su PIL reale e inflazione core — <a href="https://www.imf.org" target="_blank" rel="noopener noreferrer">imf.org</a> · <a href="https://www.federalreserve.gov" target="_blank" rel="noopener noreferrer">federalreserve.gov</a></li>
          <li>Criteri NBER per recessioni — <a href="https://www.stlouisfed.org" target="_blank" rel="noopener noreferrer">stlouisfed.org</a></li>
        </ul>
      </div>
    ),
  },



  {
    slug: "consulenza-finanziaria-indipendente-guida",
    title: "Consulenza finanziaria indipendente: definizione, principi e benefici",
    metaDescription:
      "Che cos’è la consulenza finanziaria indipendente secondo TUF e MiFID II, differenze rispetto alla consulenza tradizionale, principi, vantaggi pratici e riferimenti istituzionali (OCF, CONSOB, FCA).",
    tags: ["educazione", "consulenza", "normativa"],
    readTime: "6 min",
    author: "Redazione",
    datePublished: "2025-08-22",
    dateUpdated: "2025-08-22",
    coverImage: IndFinCover,
    canonical: `${DOMAIN}/kb/consulenza-finanziaria-indipendente-guida`,
    content: (
      <div>
        <h1>Che cos’è la consulenza finanziaria indipendente?</h1>

        <p>
          In Italia, la consulenza finanziaria è regolata dal{" "}
          <strong>Testo Unico della Finanza</strong> (TUF) e dalla direttiva europea{" "}
          <strong>MiFID II</strong>. L’albo unico tenuto dall’<strong>OCF</strong> (Organismo di vigilanza)
          distingue tre sezioni: i <em>consulenti finanziari abilitati all’offerta fuori sede</em>, i{" "}
          <em>consulenti finanziari autonomi</em> e le <em>società di consulenza finanziaria</em>.
          I consulenti autonomi e le società sono gli operatori che prestano{" "}
          <strong>consulenza su base indipendente</strong>; non collocano prodotti e non gestiscono
          il patrimonio, ma affiancano il cliente nella pianificazione finanziaria.
        </p>

        <p style={{ marginTop: "0.75rem" }}>
          <a href="https://www.normattiva.it/uri-res/N2Ls?urn:nir:stato:decreto.legislativo:1998-02-24;58!vig="
            target="_blank" rel="noopener noreferrer">TUF (Normattiva)</a>{" · "}
          <a href="https://eur-lex.europa.eu/legal-content/IT/TXT/?uri=CELEX:32014L0065"
            target="_blank" rel="noopener noreferrer">Direttiva MiFID II</a>{" · "}
          <a href="https://www.organismocf.it" target="_blank" rel="noopener noreferrer">OCF – Albo</a>
        </p>

        <h2>Differenze rispetto alla consulenza “tradizionale”</h2>
        <p>
          La MiFID II impone requisiti specifici a chi si presenta come consulente indipendente.
          Secondo l’articolo 24, se un intermediario afferma di fornire consulenza su base indipendente deve:
        </p>
        <ul>
          <li>
            <strong>analizzare un’ampia gamma di strumenti finanziari</strong>: deve valutare un numero e una
            varietà sufficiente di prodotti di tipo e provenienza diversi, senza limitarsi a strumenti emessi
            da sé o da soggetti con cui ha stretti legami. Anche il FCA Handbook (Regno Unito) riporta lo
            stesso obbligo: l’intermediario deve valutare prodotti sufficientemente diversificati per soddisfare
            gli obiettivi del cliente e non può limitarsi a quelli del proprio gruppo.
          </li>
          <li>
            <strong>rinunciare a inducement e commissioni</strong>: il consulente indipendente non può accettare
            o trattenere provvigioni, incentivi monetari o benefici non monetari da terzi in relazione al
            servizio reso; può ricevere solo piccoli benefit che migliorano la qualità del servizio e non ne
            compromettono l’indipendenza. La remunerazione deve quindi provenire esclusivamente dal cliente,
            tipicamente sotto forma di parcella.
          </li>
        </ul>
        <p>
          La consulenza “non indipendente” o “restrictive advice” consente invece all’intermediario di ricevere
          incentivi da emittenti di prodotti e di limitare l’analisi a un universo ristretto di strumenti. Per
          questo motivo i consulenti legati a reti bancarie o di vendita vengono spesso remunerati in base alle
          commissioni incassate sui prodotti collocati, generando potenziali conflitti di interesse.
        </p>
        <p style={{ marginTop: "0.75rem" }}>
          <a href="https://eur-lex.europa.eu/legal-content/IT/TXT/?uri=CELEX:32014L0065#d1e2797-1-1"
            target="_blank" rel="noopener noreferrer">MiFID II – Articolo 24</a>{" · "}
          <a href="https://www.handbook.fca.org.uk/handbook/COBS/6.2A" target="_blank" rel="noopener noreferrer">
            FCA Handbook – COBS 6.2A (inducements & independent advice)
          </a>
        </p>

        <h2>Principi fondamentali</h2>
        <p>
          Oltre agli obblighi sopra indicati, la MiFID II stabilisce che gli intermediari devono{" "}
          <strong>agire sempre nel migliore interesse del cliente</strong>. Nel processo di trasposizione
          della direttiva, la CONSOB ricorda che la centralità del cliente permea tutta l’architettura
          normativa: gli intermediari devono servire al meglio gli interessi dei clienti, con un elevato
          livello di correttezza e trasparenza. Questo principio si traduce per i consulenti indipendenti in:
        </p>
        <ul>
          <li>
            <strong>Imparzialità</strong>: l’assenza di legami commerciali con banche, assicurazioni o Sgr
            permette di formulare raccomandazioni basate solo sulle esigenze del cliente.
          </li>
          <li>
            <strong>Ampiezza di analisi</strong>: valutazione di strumenti diversi (azioni, obbligazioni,
            fondi, ETF, polizze, ecc.) per costruire soluzioni su misura.
          </li>
          <li>
            <strong>Trasparenza dei costi</strong>: l’onorario (fee only) viene concordato a priori; non ci
            sono costi occulti legati a retrocessioni o inducement.
          </li>
        </ul>
        <p style={{ marginTop: "0.75rem" }}>
          <a href="https://www.consob.it/web/area-pubblica/mifid2" target="_blank" rel="noopener noreferrer">
            CONSOB – MiFID II (centralità del cliente)
          </a>
        </p>

        <h2>Benefici per gli investitori</h2>
        <p>Scegliere un consulente finanziario indipendente comporta diversi vantaggi pratici:</p>
        <ul>
          <li>
            <strong>Assenza di conflitti d’interesse</strong>: il consulente lavora esclusivamente per il cliente
            e non percepisce provvigioni dai fornitori di prodotti, riducendo il rischio di raccomandazioni
            motivate da incentivi.
          </li>
          <li>
            <strong>Scelta più ampia e personalizzata</strong>: l’obbligo di analizzare un numero sufficiente di
            strumenti diversi garantisce che la strategia tenga conto dell’intero mercato, non solo dell’offerta
            di una banca o di un produttore.
          </li>
          <li>
            <strong>Pianificazione olistica</strong>: la consulenza indipendente non si limita a selezionare
            singoli prodotti, ma considera il patrimonio complessivo (liquidità, investimenti, previdenza,
            fiscalità, protezione assicurativa) e l’orizzonte di vita del cliente.
          </li>
          <li>
            <strong>Maggiore trasparenza e controllo</strong>: il cliente conosce in anticipo il costo del
            servizio e può monitorare l’andamento del portafoglio senza timore che il consulente guadagni
            sulle operazioni effettuate.
          </li>
        </ul>

        <h2>Conclusioni</h2>
        <p>
          La <strong>consulenza finanziaria indipendente</strong> rappresenta una modalità di relazione che pone
          il risparmiatore al centro, come richiesto dalle normative europee e italiane. Le regole MiFID II
          prevedono che chi si dichiara indipendente debba esaminare un ampio ventaglio di strumenti e rifiutare
          incentivi da terzi. Ciò tutela l’investitore da possibili conflitti d’interesse e favorisce una
          consulenza più obiettiva, trasparente e su misura. Tuttavia, è importante verificare che il
          professionista o la società siano effettivamente iscritti all’albo OCF nella sezione dei{" "}
          <strong>consulenti finanziari autonomi</strong> o delle <strong>società di consulenza finanziaria</strong>.
        </p>
      </div>
    ),
  },

  // --- incolla QUESTO oggetto dentro l’array `articles` in src/components/Articles.js ---
  {
    slug: "deep-learning-asset-allocation-guida",
    title: "Deep Learning e Asset Allocation: una guida per consulenti finanziari",
    metaDescription:
      "Che cos’è il Deep Learning, come si applica all’asset allocation tattica multi-asset, punti di forza rispetto al ML tradizionale, rischi, governance e riferimenti istituzionali (BCE, PRA/BoE).",
    tags: ["ai", "deep learning", "quant", "allocazione", "educazione"],
    readTime: "9 min",
    author: "Redazione",
    datePublished: "2025-08-22",
    dateUpdated: "2025-08-22",
    coverImage: DLIntroCover,
    canonical: `${DOMAIN}/kb/deep-learning-asset-allocation-guida`,
    content: (
      <div>
        <h1>Deep Learning e Asset Allocation: una guida per un'allocazione tattica</h1>
        <YouTubeEmbed
          videoId="yD5qNk5Iy84"
          title="Allocazione di portafoglio con Deep Learning: può battere SPY e il 60/40?"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />


        <h2>Introduzione</h2>
        <p>
          Il sistema finanziario moderno sta attraversando una trasformazione profonda. In un contesto in cui flussi di dati, notizie e segnali di mercato
          sono sempre più complessi, la tecnologia diventa uno strumento indispensabile per gestire il capitale. L’Intelligenza Artificiale (IA) in particolare
          ha aumentato la capacità di elaborare informazioni, riconoscere pattern e prevedere scenari, ma comporta anche nuovi rischi e sfide. La Banca Centrale
          Europea (BCE) sottolinea che l’emergere di strumenti di intelligenza artificiale generativa costituisce un salto tecnologico con impatti potenzialmente
          significativi sul sistema finanziario: l’IA porta benefici e rischi, e la sua diffusione comporta problematiche legate ai dati, allo sviluppo e
          all’impiego dei modelli; un’adozione concentrata potrebbe amplificare il rischio operativo, la concentrazione di mercato e comportamenti imitativi,
          richiedendo possibili iniziative regolamentari mirate<span> [1]</span>.
        </p>
        <p>
          Per i consulenti finanziari è quindi fondamentale comprendere sia le opportunità sia i limiti di queste tecnologie e saperle raccontare ai clienti.
          In questo articolo ripercorriamo i concetti di Deep Learning (DL) e ne illustriamo l’applicazione in un modello proprietario di allocazione tattica,
          evidenziandone i punti di forza rispetto ai metodi tradizionali di Machine Learning (ML) e i requisiti di governance.
        </p>

        <h2>Cos’è il Deep Learning</h2>
        <p>
          Il Deep Learning è una branca del Machine Learning basata su reti neurali profonde che, grazie a numerosi strati di elaborazione non lineare,
          riescono a catturare relazioni complesse nei dati. A differenza degli algoritmi ML tradizionali (come regressioni lineari, alberi decisionali o SVM)
          che necessitano di un’intensa attività di feature engineering e spesso faticano a modellare strutture temporali, le reti neurali possono elaborare
          direttamente sequenze e grandi quantità di variabili. Una recente rassegna accademica evidenzia che il DL consente di ottimizzare un portafoglio
          direttamente o replicare un indice con un numero ridotto di asset; l’IA produce stime migliori di rendimento e rischio e risolve problemi di
          ottimizzazione in presenza di vincoli complessi<span> [2]</span>. Tuttavia, la stessa fonte sottolinea che i modelli basati su IA sono spesso
          “black box”: l’assenza di trasparenza genera sfide di interpretabilità per investitori e regolatori<span> [3]</span>.
        </p>
        <p>
          Nel campo della previsione di serie temporali, gli algoritmi di DL mostrano performance superiori rispetto ai modelli statistici classici. Ad esempio,
          gli approcci tradizionali come ARIMA sono stati superati con largo margine dai modelli Long Short-Term Memory (LSTM); altre architetture – come le
          Gated Recurrent Unit (GRU), i modelli Seq2Seq e le reti neurali convoluzionali (CNN) – continuano a ottenere risultati all’avanguardia nella previsione
          dei mercati<span> [4]</span>. Questi progressi derivano dalla capacità delle reti neurali di cogliere dipendenze non lineari e dinamiche tra variabili
          finanziarie, andando oltre la media-varianza della teoria di Markowitz.
        </p>

        <h2>Contesto normativo e gestione del rischio</h2>
        <p>
          L’introduzione di modelli basati su IA richiede un adeguato framework di model risk management. Il documento di discussione del Prudential Regulation
          Authority (PRA) del Regno Unito evidenzia che la gestione del rischio modello è sempre più importante per mitigare i rischi legati all’uso dell’IA:
          l’attuale normativa britannica offre regole solo per modelli di capitale o stress test, senza riferimenti espliciti alla IA e alla spiegabilità dei
          modelli<span> [5]</span>. Il PRA propone di introdurre principi di governo specifici per tutte le fasi del ciclo di vita del modello – identificazione
          e classificazione dei modelli, governance, sviluppo, validazione indipendente e misure di mitigazione – applicabili anche ai modelli IA<span> [6]</span>.
          In parallelo, la BCE ricorda che un’adozione estesa dell’IA da parte di pochi fornitori può accrescere i rischi sistemici: maggiore concentrazione,
          fragilità operativa e comportamenti di emulazione<span> [1]</span>. Per gli operatori è quindi essenziale adottare procedure di validazione, spiegabilità
          e “kill switch” per fermare algoritmi che si comportano in modo anomalo.
        </p>

        <h2>Il modello di Deep Learning per l’allocazione tattica</h2>

        <h3>Dati e preparazione</h3>
        <p>
          Il modello proprietario illustrato in questo articolo nasce con l’obiettivo di ottenere apprezzamento del capitale attraverso una gestione tattica
          multi-asset. Il portafoglio considera otto ETF liquidi appartenenti a diverse asset class (oro, utilities, consumi discrezionali, energia, beni di
          consumo di base, tecnologia, titoli di Stato USA a lunga scadenza, sanità). I dati utilizzati spaziano dal febbraio 2006 al febbraio 2025. Per
          l’addestramento del modello si è adottato un approccio walk-forward: il periodo fino al febbraio 2020 è utilizzato per l’apprendimento, mentre gli anni
          successivi (incluso l’episodio della pandemia) rappresentano un out-of-sample per valutare la capacità di adattamento del modello.
        </p>
        <p>
          La fase di data gathering comprende l’allineamento temporale degli asset, l’integrazione di indicatori macroeconomici con ritardi realistici, e
          l’aggiunta di indicatori tecnici (RSI, MACD, medie mobili, ecc.). Le variabili numeriche vengono confrontate con un benchmark (l’ETF S&amp;P 500 – SPY)
          per fornire una misura della performance relativa. A questa base dati si aggiungono variabili stagionali per catturare cicli di mercato. I dati sono
          normalizzati e trasformati in sequenze temporali con 71 caratteristiche per ciascun asset.
        </p>

        <h3>Architettura e metodologia</h3>
        <ul>
          <li><strong>Layer LSTM</strong>: modellano la dipendenza temporale dei rendimenti finanziari, catturando pattern a lungo termine.</li>
          <li><strong>Layer convoluzionali con meccanismo di attenzione</strong>: evidenziano relazioni tra asset e pesano dinamicamente le informazioni più rilevanti.</li>
          <li><strong>Dropout e Batch Normalization</strong>: migliorano la generalizzazione e la stabilità dell’addestramento.</li>
          <li><strong>Strato d’uscita Softmax</strong>: restituisce un vettore di pesi (allocazione) sulle otto asset class.</li>
        </ul>
        <p>
          Un elemento chiave è la funzione di perdita finanziaria. Oltre alla classica ottimizzazione degli errori, la loss include componenti che massimizzano il
          rapporto di Sharpe, penalizzano la concentrazione di portafoglio tramite un termine di entropia e premiano l’extra-rendimento rispetto al benchmark.
          Questo consente di allineare l’apprendimento a metriche care agli investitori. L’addestramento è iterativo: per ogni finestra temporale si addestra il
          modello sui dati disponibili e lo si valida su dati successivi. L’uso del walk-forward riduce l’overfitting, perché il modello non vede mai
          contemporaneamente passato e futuro.
        </p>

        <h3>Risultati addestramento</h3>
        <p>
          Il modello è stato addestrato su dati da febbraio 2006 a febbraio 2020, escludendo deliberatamente la crisi COVID-19 per valutare la reale capacità di
          adattamento out-of-sample. Nonostante ciò, il modello ha mostrato un’elevata resilienza, regolando dinamicamente le allocazioni durante il periodo
          pandemico e minimizzando i drawdown.
        </p>
        <p>
          Le figure seguenti illustrano il comportamento del modello al variare delle epoche di training, evidenziando i miglioramenti del delta di rendimento rispetto
          al benchmark e la maggiore robustezza ottenuta tramite adattamento walk-forward. Questi snapshot esemplificano la capacità del modello di apprendere da
          condizioni di mercato in evoluzione e di affinare le allocazioni di conseguenza.
        </p>
        <p>
          L’evoluzione per epoche mostra un chiaro processo di “apprendimento allocativo”. Nelle prime iterazioni il portafoglio mantiene una composizione più
          diversificata e stabile, con un delta di allocazione contenuto tra gli ETF: i pesi variano lentamente e il modello tende a distribuire il rischio su più
          asset (equity settoriale, TLT e GLD). In questa fase il ritorno cumulato supera già lo SPY, ma il vantaggio è ancora moderato: l’alpha deriva soprattutto
          da una migliore diversificazione e da un’esposizione più ordinata ai trend.
        </p>

        {/* FIGURA 2 — Evoluzione allocazioni per epoche */}
        <figure>
          <a href={dlAllocEpochs} target="_blank" rel="noopener noreferrer">
            <img
              src={dlAllocEpochs}
              alt="Evoluzione delle allocazioni per epoche: bande di allocazione (regime switching)"
              loading="lazy"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </a>
          <figcaption>Figura 2 — Evoluzione delle allocazioni per epoche (regime switching).</figcaption>
        </figure>

        <p>
          Avanzando di epoca, il modello “impara” regimi e transizioni: il delta di allocazione aumenta, compaiono rotazioni più nette e periodi di concentrazione
          selettiva sui segmenti con momentum o carry più favorevole (ad es. sovrappeso su tecnologia/consumi in bull market; riallocazioni verso TLT/GLD nelle fasi
          di stress - vedi crisi 2008). Queste scelte più decise si riflettono in equity curve via via più ripide sia in training sia in test, con un gap crescente
          sul benchmark: il portafoglio non solo partecipa ai rialzi, ma evita con maggiore prontezza i drawdown dei listini, migliorando il profilo rischio/rendimento.
        </p>
        <p>
          Nelle ultime epoche la dinamica diventa ancora più evidente: le bande di allocazione mostrano blocchi compatti (regime switching), segno di una maggiore
          confidenza statistica del modello nel selezionare i driver di performance del periodo. L’aumento del ritorno cumulato è la conseguenza diretta di tre
          fattori: (i) timing più rapido nelle transizioni di regime, (ii) concentrazione tattica sugli asset vincenti quando l’evidenza è forte, (iii) de-risking
          tempestivo verso asset rifugio quando il contesto peggiora. Il risultato è un’alpha più stabile: il portafoglio tende a guadagnare di più nelle fasi
          favorevoli e a perdere meno nelle correzioni, consolidando la superiorità rispetto allo SPY e al 60/40.
        </p>

        <p>
          Dopo l’elaborazione, le allocazioni vengono filtrate per renderle implementabili: si applicano soglie minime di posizione, si limita la frequenza di
          ribilanciamento e si incorporano costi reali (26% di capital gain tax e 0,3% di costi di transazione). Questo livello di filtraggio riduce il numero
          medio di riallocazioni a circa 7,7 cambi per anno.
        </p>

        <h3>Risultati principali</h3>
        <p>Le performance del modello sono riassunte nei seguenti grafici e tabelle.</p>

        <table>
          <thead>
            <tr>
              <th></th>
              <th>2016</th>
              <th>2017</th>
              <th>2018</th>
              <th>2019</th>
              <th>2020</th>
              <th>2021</th>
              <th>2022</th>
              <th>2023</th>
              <th>2024</th>
              <th>2025</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Portfolio</td>
              <td>14,7%</td>
              <td>36,6%</td>
              <td>29,8%</td>
              <td>41,6%</td>
              <td>45,4%</td>
              <td>56,4%</td>
              <td>-0,8%</td>
              <td>65,8%</td>
              <td>23,4%</td>
              <td>5,6%</td>
            </tr>
            <tr>
              <td>SPY</td>
              <td>12,0%</td>
              <td>21,7%</td>
              <td>-4,6%</td>
              <td>31,2%</td>
              <td>18,3%</td>
              <td>28,7%</td>
              <td>-18,2%</td>
              <td>26,2%</td>
              <td>24,9%</td>
              <td>-0,2%</td>
            </tr>
            <tr>
              <td>60-40</td>
              <td>8,1%</td>
              <td>16,8%</td>
              <td>-2,9%</td>
              <td>24,7%</td>
              <td>21,5%</td>
              <td>14,8%</td>
              <td>-22,8%</td>
              <td>16,9%</td>
              <td>10,9%</td>
              <td>1,9%</td>
            </tr>
          </tbody>
        </table>
            
        {/* FIGURA 1 — Annualized Returns */}
        <figure>
          <a href={dlAnnualized} target="_blank" rel="noopener noreferrer">
            <img
              src={dlAnnualized}
              alt="Annualized Returns 2016–2025: portafoglio DL vs SPY e 60/40"
              loading="lazy"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </a>
          <figcaption>Figura 1 — Annualized Returns 2016–2025 (YTD): portafoglio DL vs SPY e 60/40.</figcaption>
        </figure>

        <p>
          Negli anni 2016–2025 (YTD) il grafico degli “Annualized Returns” mostra con chiarezza un vantaggio sistematico del portafoglio generato dal modello
          rispetto ai due riferimenti di mercato (SPY e 60/40). L’aspetto più rilevante non è solo l’entità dei picchi positivi, ma la capacità di mantenere
          performance robuste in contesti di mercato molto diversi, suggerendo un’allocazione dinamica che si adatta via via al regime prevalente.
        </p>
        <p>
          Nei periodi di stress il modello ha attenuato le perdite o addirittura generato rendimenti positivi: nel 2018 chiude in forte rialzo (+29,8%) contro un
          mercato in calo (SPY –4,6%), mentre nel 2022 limita il danno a –0,8% a fronte di correzioni marcate sia per SPY (–18,2%) sia per il 60/40 (–22,8%).
          Questa tenuta nei drawdown è coerente con un processo che ribilancia in modo opportunistico, riducendo l’esposizione ai segmenti più vulnerabili quando
          la volatilità si concentra.
        </p>
        <p>
          Nelle fasi espansive, il modello riesce ad amplificare l’upside: la sequenza 2019–2021 mostra extra-rendimenti significativi (fino al +56,4% nel 2021),
          e il 2023 rappresenta un altro esempio emblematico con +65,8% contro il +26,2% dello SPY. Anche quando il mercato corre molto, il portafoglio mantiene
          un differenziale favorevole nella maggior parte degli anni. Fa eccezione il 2024, dove il modello resta comunque su ottimi livelli (+23,4%) pur
          leggermente sotto SPY (+24,9%) e ben sopra il 60/40 (+10,9%). L’avvio del 2025 YTD conferma la resilienza (+5,6% vs –0,2% SPY e +1,9% 60/40).
        </p>
        <p><em>(Nota: 2025 è fino a febbraio; le performance passate non garantiscono rendimenti futuri.)</em></p>

        {/* FIGURA 3 — Composizione media del portafoglio */}
        <figure>
          <a href={dlWeightsAvg} target="_blank" rel="noopener noreferrer">
            <img
              src={dlWeightsAvg}
              alt="Composizione media del portafoglio DL per asset/settore"
              loading="lazy"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </a>
          <figcaption>Figura 3 — Composizione media del portafoglio (pesi medi per asset/settore).</figcaption>
        </figure>

        <p>
          La composizione media del portafoglio evidenzia l’orientamento del modello: circa 46,4% in tecnologia (ETF IYW), 13,2% in oro (GLD), 11,4% in energia (IYE)
          e 10,8% in utilities (IDU). Le altre asset class hanno pesi minori: consumer discretionary 8,4% (IYC), sanità 3,5% (XLV), treasury a lunga scadenza 6,3%
          (TLT) e zero esposizione ai beni di consumo di base (IYK). Questa distribuzione riflette una preferenza per settori growth ma mantiene diversificazione su
          asset difensivi come l’oro e i bond statali.
        </p>
        

        <h2>Confronto con altre metodologie di Machine Learning</h2>
        <p>
          Metodi di ML tradizionali – come regressioni, alberi decisionali o reti Bayesiane – sono efficaci quando la dimensione dei dati è contenuta o i pattern
          sono relativamente semplici. Tuttavia, per catturare la non linearità e le relazioni sequenziali tipiche dei mercati finanziari, la letteratura dimostra
          che i modelli di DL – in particolare LSTM, CNN, modelli Seq2Seq e Generative Adversarial Networks – ottengono risultati migliori: ad esempio, l’LSTM supera
          di gran lunga l’ARIMA nel forecasting e tecniche come le CNN, originariamente sviluppate per immagini, forniscono previsioni più accurate sui dati finanziari
          rispetto ai metodi non neurali<span> [4]</span>. Inoltre, i modelli di DL possono elaborare contemporaneamente decine di indicatori tecnici, macroeconomici
          e di sentiment.
        </p>
        <p>
          Il nostro modello possiede ulteriori caratteristiche distintive rispetto a molte applicazioni ML presenti sul mercato:
        </p>
        <ul>
          <li>
            <strong>Loss finanziaria personalizzata</strong>: mentre molti approcci ottimizzano semplicemente l’errore di previsione, il nostro modello massimizza
            il rapporto di Sharpe e il rendimento in eccesso, penalizzando la mancanza di diversificazione. Questo allineamento con gli obiettivi degli investitori
            è difficile da ottenere con tecniche ML tradizionali.
          </li>
          <li>
            <strong>Walk-forward optimization</strong>: la formazione su finestre scorrevoli riduce l’overfitting rispetto ai back-test statici. La letteratura
            accademica riconosce che l’addestramento su “dati futuri” introduce bias; il nostro approccio, addestrando soltanto sui dati disponibili al momento,
            minimizza questo rischio.
          </li>
          <li>
            <strong>Filtro operativo</strong>: l’integrazione dei costi reali e l’applicazione di soglie di ribilanciamento garantiscono che le strategie proposte
            siano implementabili e non restino simulazioni teoriche.
          </li>
        </ul>
        <p>
          Ciononostante, il DL presenta limitazioni da non trascurare. Innanzitutto, richiede una quantità elevata di dati e notevoli risorse computazionali;
          inoltre, la complessità rende difficile spiegare perché il modello prenda determinate decisioni, un problema di interpretabilità già segnalato dagli
          studiosi<span> [3]</span>. L’adozione di tecniche di explainable AI e un robusto quadro di controllo (come raccomandato dal PRA<span> [6]</span>) sono
          quindi fondamentali per mitigare il rischio modello.
        </p>

        <h2>Conclusione</h2>
        <p>
          L’evoluzione della finanza quantitativa dimostra come l’Intelligenza Artificiale e in particolare il Deep Learning possano offrire opportunità significative
          per migliorare le decisioni di investimento. Le evidenze accademiche mostrano che i modelli DL superano i metodi tradizionali nelle previsioni e
          nell’allocazione del portafoglio<span> [4]</span>, e gli organi istituzionali riconoscono il potenziale trasformativo ma richiamano all’attenzione sui rischi
          di concentrazione e sulla necessità di un’efficace governance<span> [1]</span>. Il modello qui presentato, con la sua architettura LSTM-CNN-Attention, la loss
          finanziaria personalizzata e il filtraggio operativo, rappresenta un esempio concreto di come il DL possa essere applicato in modo efficiente e responsabile
          alla gestione di portafogli multi-asset.
        </p>
        <p>
          Per i consulenti finanziari, integrare questi strumenti significa non soltanto ottenere performance potenzialmente superiori, ma anche dotarsi di una visione
          olistica delle dinamiche di mercato. Nel raccomandare o utilizzare soluzioni basate su IA è tuttavia indispensabile mantenere un presidio di controllo e
          trasparenza, assicurandosi che gli algoritmi siano ben compresi, validati e allineati alle esigenze del cliente. Solo così si potranno cogliere appieno le
          opportunità del futuro rimanendo al contempo all’interno di un perimetro di rischio accettabile.
        </p>

        <h2>Riferimenti</h2>
        <ol>
          <li>
            The rise of artificial intelligence: benefits and risks for financial stability — BCE.{" "}
            <a
              href="https://www.ecb.europa.eu/press/financial-stability-publications/fsr/special/html/ecb.fsrart202405_02~58c3ce5246.en.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </li>
          <li>
            Enhancing portfolio management using artificial intelligence: literature review — PMC.{" "}
            <a
              href="https://pmc.ncbi.nlm.nih.gov/articles/PMC11033520/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </li>
          <li>
            (Interpretabilità) Ibidem, sezioni su explainability e black box.{" "}
            <a
              href="https://pmc.ncbi.nlm.nih.gov/articles/PMC11033520/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </li>
          <li>
            (Forecasting time-series con DL) Ibidem, sezioni su LSTM/GRU/CNN/Seq2Seq.{" "}
            <a
              href="https://pmc.ncbi.nlm.nih.gov/articles/PMC11033520/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </li>
          <li>
            DP5/22 — Artificial Intelligence and Machine Learning | Bank of England (PRA).{" "}
            <a
              href="https://www.bankofengland.co.uk/prudential-regulation/publication/2022/october/artificial-intelligence"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </li>
          <li>
            (Governance ciclo di vita del modello) Ibidem — principi proposti dal PRA.{" "}
            <a
              href="https://www.bankofengland.co.uk/prudential-regulation/publication/2022/october/artificial-intelligence"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>
          </li>
        </ol>
      </div>
    ),
  },

  {
  slug: "deep-learning-asset-allocation-etf-backtest-stress-test",
  title: "Deep Learning Portfolio Allocation con ETF Globali: Training, Simulazioni e Stress Test",
  metaDescription:
    "Versione Global del modello di allocazione con DL: pipeline, architettura, backtest, due metodologie di simulazione (replica storica e rendimenti sintetici correlati), scenari Bull/Covid/Financial crisis e conclusioni.",
  tags: ["quant", "deep learning", "asset allocation"],
  readTime: "9 min",
  author: "Redazione",
  datePublished: "2025-09-05",
  dateUpdated: "2025-09-05",
  coverImage: DLSyntCover,
  canonical: `${DOMAIN}/kb/allocazione-portafoglio-deep-learning-simulazioni-stress-test`,
  content: (
    <div>
      <h1>Deep Learning Portfolio Allocation con ETF Globali: Training, Simulazioni e Stress Test</h1>
        <YouTubeEmbed
          videoId="2LwbHZ5seqo"
          title="Deep Learning e finanza: stress test e affidabilità dei modelli"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />


      <h2>Creazione del Modello</h2>
      <p>
        Il modello di allocazione qui descritto è la versione Global,rispetto a
        quella focalizzata negli Stati Uniti già descritta nell’articolo
        precedente. Quindi la versione Global opera su un universo di ETF che
        copre Stati Uniti, Europa ed Emerging Markets (equity settoriale e
        broad, governativi/credit, oro/commodity). L’obiettivo è la generazione
        di extra-rendimento risk-adjusted rispetto a un benchmark azionario
        (es. S&amp;P 500) mantenendo una logica di rotazione tattica tra
        asset/regioni.
      </p>
      <p>
        Rispetto alla precedente versione US-only, l’estensione geografica
        introduce:
      </p>
      <ul>
        <li>
          maggiore opzionalità cross-sezionale (più “leve” per estrarre alpha in
          regimi diversi);
        </li>
        <li>
          diversificazione geografica e valutaria (con rendicontazione in EUR
          nel reporting, via conversione EURUSD);
        </li>
        <li>
          nuove interazioni tra driver macro/volatilità (es. shock non sincroni
          fra USA, Europa ed EM).
        </li>
      </ul>

      <h2>Feature Engineering e Model Architecture</h2>
      <p>
        La pipeline integra serie di prezzi/volatilità (ETF, benchmark),
        indicatori tecnici (RSI, MACD, etc), variabili macro (crescita,
        inflazione, tassi—con ritardi realistici) e segnali stagionali. Le
        grandezze sono armonizzate su un indice temporale unico, normalizzate e
        trasformate in sequenze multivariabili per alimentare il modello
      </p>
      <p>
        In termini architetturali il modello combina componenti ricorrenti
        (p.es. LSTM/GRU/RNN) e convoluzionali/attenzione per catturare pattern
        non lineari intra-e cross-asset. Importante menzionare che la funzione
        obiettivo non si limita all’errore di previsione ma include termini per
        massimizzare Sharpe, premiare l’extra-rendimento vs benchmark e
        penalizzare la concentrazione (entropia), allineando l’addestramento a
        metriche rilevanti per l’investitore. Questo impianto metodologico
        riprende le linee guida introdotte nell’articolo di riferimento su DL
        per l’asset allocation e l’importanza di un training out-of-sample
        robusto.
      </p>
      <p>
        Il modello è addestrato con una metodologia walk-forward: si scorre nel
        tempo su finestre storiche, e in ogni finestra i dati sono suddivisi in
        train / validation / test (p.es. 70/15/15, con early stopping e
        selezione iperparametri sulla validation). Si validano le scelte sulla
        porzione test immediatamente successiva e poi si avanza la finestra. In
        questo modo il modello non “vede” il futuro e il risultato fuori
        campione è genuino; è una procedura più vicina alla alla reale consecutio
        temporum e rispecchia le buone pratiche di data science richiamate nel
        precedente articolo. La previsione del modello viene fatta giornalmente
        anche se la frequenza del cambio sugli asset è un altro parametro oggetto
        di ottimizzazione in quanto una maggiore frequenza di ribilanciamento
        genera maggiori costi di transazione e tassazioni.
      </p>

      <h2>Risultati del modello</h2>
      <p>
        Viene condiviso il rendimento cumulato del modello considerando diversi
        range temporali. In particolare gli ultimi 3 anni fungono da validation
        e di conseguenza non sono stati considati dal modello per aggiornare i
        pesi della propria rete neurale, ne come testing .Per una visione
        completa del backtest, la Figura&nbsp;1 mostra i rendimenti cumulati
        (portafoglio, SPY e 60/40) e le allocazioni su diversi orizzonti
        temporali. La Figura&nbsp;2 riporta le stesse grandezze ma limita
        l’analisi a un periodo recente (1&nbsp;anno, 6&nbsp;mesi e 1&nbsp;mese).
        La Tabella&nbsp;1 sintetizza le metriche chiave del backtest (CAGR,
        Sharpe e drawdown massimo) per il portafoglio, il benchmark SPY e il
        portafoglio filtrato. Si prega di tenere in considerazione la seguente
        nota prima di visualizzare i grafici. L’asse temporale non è
        equidistribuito il primo pannello copre quasi diciassette anni, il
        secondo soltanto cinque e il terzo due. Per questo motivo le traiettorie
        sembrano più dilatate nell’ultima colonna rispetto alle altre. È
        importante tenere conto di queste differenze di scala quando si
        confrontano visivamente le curve: un’apparente variazione nella forma
        non implica necessariamente un cambiamento nel comportamento del modello,
        ma può essere dovuta alla diversa dilatazione dell’asse delle ascisse.
      </p>

      <p>
        <figure>
          <a href={fig1} target="_blank" rel="noopener noreferrer">
            <img
              src={fig1}
              alt="Figura 1 — Rendimenti cumulati e allocazioni: all, 5 e 2 anni."
              loading="lazy"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </a>
          <figcaption>Figura 1 — Rendimenti cumulati e allocazioni del
        backtest considerando tutto lo storico, 5 e 2 anni.</figcaption>
        </figure>
        
      </p>
      <p>
        <figure>
          <a href={fig2} target="_blank" rel="noopener noreferrer">
            <img
              src={fig2}
              alt="Figura 2 — – Rendimenti e allocazioni del backtest:ultimi 12, 6 e 1 mese."
              loading="lazy"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </a>
          <figcaption>Figura 2 – Rendimenti e allocazioni del backtest
        considerando gli ultimi 12, 6 e 1 mese.</figcaption>
        </figure>
        
      </p>

      <p>
        <strong>Tabella&nbsp;1</strong> – Metriche del backtest per
        portafoglio, benchmark e portafoglio filtrato
      </p>
      <table>
        <thead>
          <tr>
            <th>Strumento</th>
            <th>CAGR all</th>
            <th>Sharpe all</th>
            <th>Max Drawdown all</th>
            <th>CAGR 1Y</th>
            <th>Sharpe 1Y</th>
            <th>Max Drawdown 1Y</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Portafoglio</td>
            <td>26.8%</td>
            <td>0.06</td>
            <td>54.8%</td>
            <td>46.0%</td>
            <td>0.13</td>
            <td>11.0%</td>
          </tr>
          <tr>
            <td>Benchmark SPY</td>
            <td>10.5%</td>
            <td>0.03</td>
            <td>60.6%</td>
            <td>22.5%</td>
            <td>0.07</td>
            <td>15.6%</td>
          </tr>
          <tr>
            <td>Portafoglio filtrato</td>
            <td>27.0%</td>
            <td>0.06</td>
            <td>54.8%</td>
            <td>45.8%</td>
            <td>0.13</td>
            <td>11.0%</td>
          </tr>
        </tbody>
      </table>

      <h2>2. Metodologie di generazione dei dati futuri</h2>
      <p>
        Al fine di testare il comportamento del modello di deep learning,
        considerando l’elevata complessità e la limitata esplicabilità del
        modello (1 milione di parametri) si è cercato di verificare l’allocazione
        del modello al variare delle serie storiche in input. Per tale operazione
        sono stati considerati 2 approcci differenti dettagliati sotto.
      </p>

      <h3>2.1 Replica di pattern storici</h3>
      <p>
        Una prima metodologia simula serie future replicando i pattern di
        rendimento osservati in un periodo storico predefinito.
      </p>
      <p>
        I rendimenti vengono ripetuti ciclicamente fino a coprire l’orizzonte
        desiderato e applicati ai livelli correnti dei prezzi per ottenere una
        traiettoria sintetica. Le macro-feature vengono replicate allo stesso
        modo. Questa tecnica preserva esattamente la correlazione storica e la
        sequenza di shock dello scenario originale.
      </p>
      <p>
        <strong>Assunzioni e limiti:</strong> - Si presume che i pattern storici
        possano ripresentarsi in futuro identici (stazionarietà). Cambiamenti
        strutturali nei mercati non sono considerati. - La variabilità
        intra-scenario è assente: si ripete sempre lo stesso blocco di
        rendimenti, quindi non si introducono nuove combinazioni di shock e
        recuperi. Inoltre il punto di partenza (livello dei prezzi) può
        differire molto da quello originario, generando traiettorie diverse
        nonostante i rendimenti siano gli stessi.
      </p>
      <p>
        Il vantaggio è che tale approccio consente di testare come il modello
        reagisce a un contesto già noto (es. il 2008), mantenendo la coerenza tra
        rendimenti, volatilità e macro-feature.
      </p>
      <p>
        Lo svantaggio è che si non valuta la capacità del modello di affrontare
        scenari inediti o combinazioni di eventi diverse; potrebbe
        sopravvalutare l’efficacia del modello in contesti futuri
        imprevedibili.
      </p>

      <h3>2.2 Generazione di ritorni sintetici correlati</h3>
      <p>
        La seconda metodologia genera dati futuri partendo da una distribuzione
        multivariata normale che preserva la correlazione storica tra i
        rendimenti degli ETF e del benchmark, ma permette di ottenere stime
        inedite.
      </p>
      <p>
        Di seguito si propone una procedura dettagliata per i più avezzi alle
        metodologie quantitative statistiche. Per chi non fosse interessato a
        tali approfondimenti passi pure al paragrafo successivo dei risultati.
      </p>
      <p>
        La procedura è la seguente:
      </p>
      <ol>
        <li>
          <strong>Stima di media e covarianza:</strong> dai rendimenti storici
          degli ETF e del benchmark si calcola un vettore di medie e una matrice
          di covarianza. La VIX e le macro-feature non entrano in questa
          covarianza. Ad esempio il VIX è simulato come un random walk con
          varianza proporzionata allo scenario, e poi limitato tra 5 e 80.
        </li>
        <li>
          <strong>Parametri di scenario:</strong> in base allo scenario (bull,
          lateral, high_vol, low_vol), si applicano fattori di drift e
          volatilità alla media e alla covarianza. Ad esempio, “bull” moltiplica
          la media per 1,5; “high_vol” raddoppia la varianza.
        </li>
        <li>
          <strong>Campionamento dei rendimenti:</strong> tramite decomposizione
          di Cholesky (o eigen-decomposition) si campionano serie di rendimenti
          gaussiani correlati. Il risultato fornisce rendimenti per ciascun ETF
          e per il benchmark.
        </li>
        <li>
          <strong>Simulazione del VIX:</strong> separatamente, il VIX è simulato
          come un random walk con varianza proporzionata allo scenario, e poi
          limitato tra 5 e 80.
        </li>
        <li>
          <strong>Costruzione dei prezzi:</strong> si parte dai prezzi correnti
          e si moltiplica per <em>e<sup>r</sup></em> per ottenere i prezzi
          futuri.
        </li>
      </ol>
      <p>
        <strong>Assunzioni e limiti:</strong> La normalità dei rendimenti è uno
        delle assunzioni fondamentali. Assumendo che i rendimenti multivariati
        siano gaussiani si ignora code pesanti e salti tipici dei mercati
        finanziari. Inoltre i parametri dei fattori di fattori di drift e
        volatilità sono arbitrari e stabiliti a mano; piccoli cambiamenti
        possono alterare drasticamente i risultati. Infine c’è indipendenza tra
        le variabili macro,che restano storiche e il VIX che è simulato
        separatamente. Il modello, quindi può ricevere segnali macro/VIX che non
        si riflettono nei prezzi simulati, generando decisioni difficili da
        interpretare.
      </p>
      <p>
        <strong>Vantaggi:</strong> permette di testare la sensibilità del
        modello a diversi livelli di drift e volatilità, introducendo
        variabilità e scenari non presenti nello storico.
      </p>
      <p>
        <strong>Svantaggi:</strong> può produrre traiettorie poco realistiche
        (es. “financial_crisis” con rendimenti positivi) e le allocazioni
        risultano ancora molto concentrate, perché il filtro non consente un
        reale ribilanciamento.
      </p>

      <h2>3. Utilizzo e confronto delle due metodologie</h2>
      <p>
        In base ai risultati analizzati, le due metodologie servono a scopi
        differenti:
      </p>
      <p>
        <strong>Replica di pattern storici:</strong> ideale per valutare la
        coerenza del modello in contesti reali già osservati. Permette di
        verificare se l’algoritmo riesce a proteggere il portafoglio in una
        crisi (es. 2008) o a seguire un trend rialzista. È particolarmente utile
        per spiegare al lettore come il modello reagisce a un evento noto, con
        grafici che mostrano rendimenti cumulati, delta vs benchmark e
        allocazioni.
      </p>
      <p>
        <strong>Ritorni sintetici correlati:</strong> utile come stress test per
        esplorare la sensibilità dell’algoritmo a diverse combinazioni di drift
        e volatilità. Non fornisce però informazioni affidabili sulla capacità
        del modello di battere il benchmark, perché le performance dipendono
        fortemente dai parametri scelti. È consigliato mostrare solo gli scenari
        che aggiungono valore (ad esempio “high_vol” per valutare l’impatto di
        volatilità elevata) e spiegare chiaramente che si tratta di
        un’esercitazione esplorativa.
      </p>
      <p>
        Di seguito vengono analizzati tre scenari (Bull, Covid crash, Financial
        crisis) limitandosi all’ultima colonna a destra, corrispondente al mese
        finale della simulazione e metriche associate. In ciascun caso,
        l’allocazione del portafoglio è pressoché identica nei due metodi.ciò
        che cambia è l’andamento dei singoli ETF, e quindi il rendimento
        cumulato.
      </p>

      <h3>Scenario Bull (2012–2014)</h3>
      <p>
        Secondo la metodologia simulativa con replica storica, nell’ultimo mese
        la strategia resta concentrata quasi al 100 % su un singolo ETF relativo
        al Healthcare,con un periodo di transizione precedente in cui il
        portfolio è stato allocato nel tecnologico, come si vede dall’area
        chart. Tale aspetto sembra alquanto strano, considerando siamo oramai
        abituati ad allocare il portafoglio nel settore tecnologico durante il
        bull market. In realtà il modello si muove correttamente considerando il
        movimento degli ETF sottostanti spostandosi nello strumento che durante
        il periodo 2012-2014 avrebbe poi avuto una bull run significativa
        (l’etf sull’healthcare appunto - XLV) .
      </p>
      <p> 
      <figure>
        <a href={fig3} target="_blank" rel="noopener noreferrer">
          <img
            src={fig3}
            alt="Figura 3 — Scenario Bull (2012–2014): rendimenti cumulati vs SPY/60-40 e allocazioni tempo-varianti."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 3 — Scenario Bull (2012–2014) con replica storica dei pattern: confronto dei rendimenti cumulati del
          portafoglio rispetto a SPY e 60/40 e relativa area-chart di allocazione. Evidenziata la rotazione su Healthcare (XLV).
        </figcaption>
      </figure>
      </p>
      <figure>
        <a href={fig4} target="_blank" rel="noopener noreferrer">
          <img
            src={fig4}
            alt="Figura 4 — Scenario Bull: metriche 1M (CAGR, Sharpe, Max Drawdown) portafoglio vs SPY."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 4 — Andamenti Simulati ETF sottostanti secondo la simulazione storica vs quella attuale.
        </figcaption>
      </figure>
      <p>
        Le metriche di riferimento vengono riportate nella figura successiva. Il
        portafoglio realizza un CAGR 1M di circa 27 % con Sharpe di circa 0,11,
        superando di poco lo SPY (24 % con Sharpe 0,12), ma a prezzo di un
        drawdown più profondo (−16,5 % contro −9,7 %). Il modello sovraperforma
        lo SPY di circa 3&nbsp;punti nel mese ma a prezzo di un drawdown più
        profondo.
      </p>

      <table>
        <thead>
          <tr>
            <th>Scenario</th>
            <th>Metodologia</th>
            <th>CAGR portafoglio</th>
            <th>CAGR SPY</th>
            <th>Sharpe portafoglio</th>
            <th>Sharpe SPY</th>
            <th>MDD portafoglio</th>
            <th>MDD SPY</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Bull</td>
            <td>replica pattern</td>
            <td>26,9 %</td>
            <td>24,1 %</td>
            <td>0,11</td>
            <td>0,12</td>
            <td>-16,1 %</td>
            <td>-9,7 %</td>
          </tr>
        </tbody>
      </table>

      <p>
        Nella metodologia simulativa multivariata l’allocazione rimane similare
        anche se con un certo ritardo, ma la traiettoria sintetica degli ETF
        genera un rendimento con una durata minore (1 anno contro i due anni
        generati precedentemente) e dunque questo spiega i ritorni cumulati
        degli asset sono più piatti e meno correlati ai valori storici. Si nota
        come l’oro (GLD) nel secondo approccio simulativo abbia dei rendimenti
        maggiori rispetto ad altri, con un indice relativo al settore healthcare
        che cresce invece solo successivamente nel tempo.
      </p>
      <figure>
        <a href={fig5} target="_blank" rel="noopener noreferrer">
          <img
            src={fig5}
            alt="Figura 5 — Simulazione sintetica Cholensky: rendimenti cumulati e allocazioni"
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 5 — Simulazione sintetica Cholensky: rendimenti cumulati e allocazioni.
        </figcaption>
      </figure>

      {/* === Figure 6 === */}
      <figure>
        <a href={fig6} target="_blank" rel="noopener noreferrer">
          <img
            src={fig6}
            alt="Figura 6 — Simulazione sintetica Cholensky: Andamenti ritorni cumulati ETF sottostanti"
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 6 — Simulazione sintetica Cholensky: Andamenti ritorni cumulati ETF sottostanti.
        </figcaption>
      </figure>
      <h3>Scenario Covid crash (febbraio–aprile 2020)</h3>
      <p>
        Si è deciso di prendere come ulteriore punto di analisi un momento
        transitorio inusuale, quindi il bear market momentaneo del Covid, sempre
        simulandolo secondo i due approcci simulativi precedentemente descritti
      </p>
      <p>
        Secondo la metodologia simulativa con replica storica,il portafoglio
        annulla quasi totalmente l’esposizione azionaria e si posiziona in oro.
        Sotto si propongono nuovamente gli andamenti degli ETF che ripercorrono
        quanto accaduto in tale periodo storico, con una differenza che ha
        comunque un impatto, cioè che questo nuovo COVID crash parte da oggi, con
        un inerzia di serie storiche, momentum, volatilità e drift diversi
        rispetto a quelli appena precedenti a Febbraio 2020. Per questo lo
        scenario il modello non reagisce esattamente come fatto nel training, ma
        in maniera molto simile, perché la sequenza e serie storica è comunque
        diversa.
      </p>
      <figure>
        <a href={fig7} target="_blank" rel="noopener noreferrer">
          <img
            src={fig7}
            alt="Figura 7 — Scenario Covid Crisis: rendimenti cumulati e allocazioni con simulazione rendimenti passati."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 7 — Scenario Covid Crisis: rendimenti cumulati e allocazioni con simulazione rendimenti passati.
        </figcaption>
      </figure>

      {/* === Figure 8 === */}
      <figure>
        <a href={fig8} target="_blank" rel="noopener noreferrer">
          <img
            src={fig8}
            alt="Figura 8 — Scenario Covid Crisis: andamento ETF con simulazione con rendimenti passati."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 8 — Scenario Covid Crisis: andamento ETF con simulazione con rendimenti passati.
        </figcaption>
      </figure>
      <p>
        Il risultato è sorprendente: CAGR 1M ≈ 63 %, Sharpe 0,13 e drawdown
        intorno al 12 %, mentre lo SPY crolla del 5 % con drawdown oltre il 33 %.
        Questo riflette la rotazione e mantenimento verso asset rifugio,
        sfruttando il continuo momentum dell’oro, seppur dopo aver raggiunto il
        picco altri etf hanno potuto prezzarsi maggiormente.
      </p>

      <table>
        <thead>
          <tr>
            <th>Scenario</th>
            <th>Metodologia</th>
            <th>CAGR portafoglio</th>
            <th>CAGR SPY</th>
            <th>Sharpe portafoglio</th>
            <th>Sharpe SPY</th>
            <th>MDD portafoglio</th>
            <th>MDD SPY</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Covid Crash</td>
              <td>pattern replay</td>
              <td>63.0%</td>
              <td>—4.9</td>
              <td>0.132</td>
              <td>0.01</td>
              <td>-12.5%</td>
              <td>—33.7</td>
          </tr>
        </tbody>
      </table>

      <p>
        La simulazione multivariata  presenta la stessa allocazione su asset
        difensivi, la serie sintetica non riproduce il crollo e il rimbalzo, gli
        ETF simulati seguono un processo quasi gaussiano, per cui anche con pesi
        difensivi si ottiene un rendimento moderatamente positivo. Anche qui si
        ha un delta di durata tra le due simulazioni, mentre la simulazione
        storica ha una durata esattamente pari al periodo Covid, la simulazione
        multivariata ha per tutti gli scenari una durata prestabilità, ovvero un
        anno. Quindi tale simulazione ha in qualche modo mantenuto l’andamento
        stabile dell’oro e di ripresa degli altri ETF, e il modello in tale
        trend, comunque inedito, si è mantenuto nell’oro. Si ribadisce nuovamente
        che l’output serve più a testare la sensibilità del modello che a
        valutarne l’abilità in contesti reali.
      </p>
      {/* === Figure 9 === */}
      <figure>
        <a href={fig9} target="_blank" rel="noopener noreferrer">
          <img
            src={fig9}
            alt="Figura 9 — Scenario Covid Crisis: rendimenti e allocazioni da simulazione multivariata (gaussiana)"
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 9 — Scenario Covid Crisis: rendimenti e allocazioni da simulazione multivariata (gaussiana)
        </figcaption>
      </figure>

      {/* === Figure 10 === */}
      <figure>
        <a href={fig10} target="_blank" rel="noopener noreferrer">
          <img
            src={fig10}
            alt="Figura 10 — Scenario Covid Crisis: andamento ETFs da simulazione multivariata (gaussiana)"
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 10 — Scenario Covid Crisis: andamento ETFs da simulazione multivariata (gaussiana).
        </figcaption>
      </figure>
      <p>
        <strong>Tabella&nbsp;2</strong> – Metriche di rendimento e rischio a
        1&nbsp;anno per gli scenari replicati
      </p>
      <table>
          <thead>
            <tr>
              <th>Scenario </th>
              <th>Portfolio CAGR </th>
              <th>SPY CAGR </th>
              <th>Portfolio Sharpe </th>
              <th>SPY Sharpe </th>
              <th>Portfolio MDD </th>
              <th>SPY MDD </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Bull replay</td>
              <td>26.9%</td>
              <td>24.1%</td>
              <td>0.10</td>
              <td>0.11</td>
              <td>-16.1%</td>
              <td>-9.7%</td>
            </tr>
            <tr>
              <td>Bull synt</td>
              <td>22.6%</td>
              <td>-5.4%</td>
              <td>0.082</td>
              <td>-0.013</td>
              <td>-12.7%</td>
              <td>-26.3%</td>
            </tr>
            <tr>
              <td>Covid replay</td>
              <td>63.0%</td>
              <td>-4.9%</td>
              <td>0.132</td>
              <td>0.01</td>
              <td>-12.5%</td>
              <td>-33.7%</td>
            </tr>
            <tr>
              <td>Covid synt</td>
              <td>30.0%</td>
              <td>30.6%</td>
              <td>0.097</td>
              <td>0.101</td>
              <td>-17.0%</td>
              <td>-9.6%</td>
            </tr>
            <tr>
              <td>Financial replay</td>
              <td>3.9%</td>
              <td>1.7%</td>
              <td>0.018</td>
              <td>0.011</td>
              <td>-21.0%</td>
              <td>-17.6%</td>
            </tr>
            <tr>
              <td>Financial synth</td>
              <td>-12.7%</td>
              <td>−24.4%</td>
              <td>0.04</td>
              <td>−0.03</td>
              <td>-61.2%</td>
              <td>-52.3%</td>
            </tr>
          </tbody>
        </table>

      <h2>3. Conclusioni</h2>
      <p>
        Dall’analisi emerge che tra le due metodologie di test simulato, replica
        storica è il modo più affidabile per testare la strategia, perché
        conserva la coerenza fra rendimenti, volatilità e segnali macro. Tali
        metodologie sono utili in ogni caso per testare o evidenziare problemi di
        overfitting del modello, aspetti che è necessario valutare prima della
        messa in produzione del modello. Per questo aspetto il comportamento
        della rete neurale profonda si è rivelata positiva.
      </p>
      <p>
        Sulla base di queste simulazioni, il giudizio complessivo sul modello può
        essere così considerato positivo.Il modello mantiene la capacità di
        proteggere il capitale nelle crisi (sia reali che replicate), generando
        drawdown inferiori allo SPY; generazione di extra-rendimento in mercati
        laterali grazie alla rotazione settoriale e integrazione di segnali
        macro e tecnici che aiutano a riconoscere i regimi di mercato. In
        sintesi, il modello Global conferma la capacità di fornire protezione
        nelle crisi e di generare alpha in contesti laterali, ma rimane
        migliorabile per ridurre la concentrazione e sfruttare meglio i rally
        sostenuti.
      </p>

      <p>
        <strong>Vuoi leggere altri articoli simili?</strong>{" "}
        <a href="/kb">Torna alla Knowledge Base</a>
      </p>
    </div>
  ),
  },

  {
  slug: "capitale-umano-perche-rilevante",
  title: "Che cos’è il capitale umano e perché è rilevante?",
  metaDescription:
    "Cos’è il capitale umano, perché conta, come si valuta e come integrarlo nell’asset allocation con la formula BMS e due esempi numerici.",
  tags: ["educazione", "capitale umano", "asset allocation"],
  readTime: "10 min",
  author: "Redazione",
  datePublished: "2025-08-22",
  dateUpdated: "2025-08-22",
  coverImage: HumanCapitalCover,
  canonical: `${DOMAIN}/kb/capitale-umano-perche-rilevante`,
  content: (
    <div>
      <h1>Che cos’è il capitale umano e perché è rilevante?</h1>

      <p>
        In finanza personale, per capitale umano si intende il valore attuale di tutti i redditi da
        lavoro futuri che un individuo guadagnerà nella vita lavorativa. Spesso il capitale umano è
        l’asset più prezioso per un investitore giovane, ben più del patrimonio finanziario
        accumulato, ed è una componente intangibile ma cruciale della ricchezza totale
        dell’individuo. Secondo l’ISTAT, il valore medio del capitale umano di un italiano è stato
        stimato attorno a 342.000 €, a riprova del peso significativo di questa risorsa. Ignorare il
        capitale umano nella pianificazione finanziaria significa trascurare una parte sostanziale
        della ricchezza e del profilo di rischio complessivo di una persona.
      </p>

      <p>
        Dal punto di vista finanziario, possiamo considerare il capitale umano come un asset
        aggiuntivo nel portafoglio complessivo di un individuo. Pur non essendo negoziabile (non si
        può vendere o diversificare direttamente sul mercato), esso presenta un profilo di
        rischio/rendimento che deve essere tenuto in conto. In particolare, età, stabilità del
        lavoro e settore di attività influenzano il valore e il rischio del capitale umano. All’inizio
        della carriera si hanno molti anni di reddito davanti (capitale umano elevato) ma pochi
        risparmi accumulati; viceversa, verso la pensione il capitale umano si riduce mentre il
        patrimonio finanziario aumenta grazie ai risparmi e agli investimenti effettuati negli anni.
        Questo significa che da giovani la capacità di prendere rischio finanziario è maggiore,
        perché sostenuta da un ampio capitale umano “assicurabile” nel tempo, mentre in età avanzata
        occorre essere più conservativi poiché la quota di ricchezza dipendente dal lavoro è minima.
        Come osservato da Bodie, Merton e Samuelson (1992), la flessibilità nel lavoro (es. la
        possibilità di prolungare la carriera o fare straordinari) offre una sorta di assicurazione
        contro i rischi finanziari, incoraggiando i giovani lavoratori a investire una porzione
        maggiore del loro patrimonio finanziario in azioni rispetto agli investitori più anziani.
      </p>

      <p>
        <strong>Figura 1:</strong> Andamento semplificato del capitale umano e finanziario durante il
        ciclo di vita. In giovane età il capitale umano (linea gialla) domina la ricchezza totale,
        mentre il patrimonio finanziario accumulato (linea arancione) è inizialmente ridotto e cresce
        nel tempo con il risparmio. La linea rossa tratteggiata indica la ricchezza totale (capitale
        umano + finanziario) in questo esempio ipotetico.
      </p>

      <p>
        Come mostra la Figura 1, per un individuo giovane la maggior parte della ricchezza è
        costituita dal capitale umano, che viene progressivamente convertito in ricchezza finanziaria
        man mano che si risparmia e investe nel corso della vita lavorativa. La ricchezza totale tende
        a crescere nel tempo se parte del reddito da lavoro viene risparmiato (nel nostro esempio
        abbiamo ipotizzato un incremento tale da mantenere costante la somma H+W). In generale, il
        rapporto fra capitale umano e capitale finanziario (H/W) varia nel ciclo di vita: è molto alto
        all’inizio (lavoratori agli esordi con pochi risparmi) e tende a zero in prossimità della
        pensione. Ne consegue che un giovane investitore con grande “ricchezza in capitale umano” e
        pochi asset finanziari dovrebbe investire in misura relativamente maggiore in strumenti
        rischiosi (azioni) rispetto a un investitore maturo vicino al pensionamento con basso capitale
        umano residuo. Questo è il principio alla base dei classici fondi life-cycle o dei consigli
        finanziari che suggeriscono elevati pesi azionari da giovani e via via più obbligazioni con
        l’avanzare dell’età.
      </p>

      <p>
        Un altro motivo per cui il capitale umano è rilevante: funge da ammortizzatore del rischio. Se
        il reddito da lavoro è stabile, l’investitore può permettersi di prendere più rischio con gli
        investimenti, sapendo di poter contare su un flusso di cassa certo per coprire le spese (e
        magari acquistare ancora attivi finanziari a prezzi di saldo in caso di ribassi di mercato). Al
        contrario, se il reddito lavorativo è volatile o incerto, la capacità di sopportare perdite
        finanziarie diminuisce. In sostanza, il profilo di rischio del capitale umano dovrebbe guidare
        la composizione del portafoglio finanziario dell’investitore. Elementi come la stabilità del
        posto di lavoro, la volatilità dei redditi e il settore professionale vanno considerati
        attentamente nell’asset allocation complessiva. Come regola generale, il capitale umano va
        “coperto” o compensato dal capitale finanziario: se il lavoro di una persona è rischioso, il
        portafoglio finanziario dovrà essere più conservativo; viceversa, un capitale umano molto
        sicuro permette di investire il patrimonio finanziario in modo più aggressivo.
      </p>
        <YouTubeEmbed
          videoId="vsFT8YPrwO4"
          title="Come cambia il portafoglio con l'età: il capitale umano"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />


      <h2>Come valutare il capitale umano</h2>
      <p>
        Valutare il capitale umano significa calcolare il valore attuale dei redditi futuri attesi di
        un individuo. In pratica, è un esercizio di attualizzazione analogo a quello che si farebbe per
        valutare un titolo obbligazionario o una rendita. Formalmente si può scrivere:
      </p>
      <p>
        <BM>{tex`H = \sum_{t=1}^{T} \frac{\mathbb{E}[\text{Reddito}_{t}]}{(1 + r_{d})^{t}}`}</BM>
      </p>
      <p>
        dove <IM>{tex`T`}</IM> è il numero di anni lavorativi rimanenti e <IM>{tex`r_{d}`}</IM> è il
        tasso di sconto appropriato. La scelta del tasso di sconto è cruciale: per redditi molto sicuri
        (es. stipendio di un dipendente pubblico a tempo indeterminato) si può usare un tasso vicino al
        rendimento dei titoli di Stato o al tasso privo di rischio. Per redditi più incerti andrà
        aggiunto un premio per il rischio, analogamente a quanto si fa per il costo del capitale
        azionario di un’azienda. Ad esempio, un giovane impiegato con stipendio stabile di 30.000 €
        annui e 27 anni fino alla pensione potrebbe avere un capitale umano intorno agli 810.000 €
        semplicemente moltiplicando reddito annuo per anni restanti (ignorando per semplicità crescita
        e sconto). Più rigorosamente, se consideriamo lo stesso reddito di 30.000 € con tasso di sconto
        reale del 2%, il valore attuale dei prossimi 27 anni di stipendio risulta circa 600.000–700.000
        €, a seconda dell’ipotesi di crescita del reddito (qui assumiamo una crescita nulla in termini
        reali, quindi solo attualizzazione). Un risultato simile (qualche centinaio di migliaia di euro)
        vale per molti lavoratori: questo spiega perché il capitale umano rappresenta spesso la fetta
        principale della ricchezza nelle prime fasi della vita lavorativa.
      </p>
      <p>
        È importante notare che il valore del capitale umano diminuisce nel tempo: ogni anno che passa
        si “consuma” una parte della capacità di guadagno futura (oltre al fatto che si avvicina la
        pensione). Inoltre, eventi avversi possono ridurre <IM>{tex`H`}</IM> in modo improvviso
        (perdita del lavoro, invalidità, decesso – rischi contro cui è opportuno assicurarsi). Al
        contrario, investire in formazione ed esperienza può aumentare i redditi futuri attesi, e quindi
        incrementare il capitale umano. Anche cambiamenti nei tassi di interesse influiscono: un aumento
        del tasso di sconto (es. tassi di mercato più alti o maggior percezione di rischio sul proprio
        lavoro) riduce il valore attuale del capitale umano, mentre tassi più bassi lo aumentano.
      </p>

      <h2>Capitale umano e asset allocation: teoria e modelli</h2>
      <p>
        Includere il capitale umano nei modelli di asset allocation significa considerare l’investitore
        non solo in base al patrimonio finanziario che possiede, ma anche alla “posizione implicita”
        derivante dal suo lavoro. Dal punto di vista teorico, questo problema è stato affrontato da
        numerosi studi accademici nel contesto dei modelli di portafoglio con background risk (rischio
        in background non negoziabile). Uno dei risultati fondamentali (Bodie, Merton e Samuelson, 1992)
        è che un investitore con reddito da lavoro certo o poco correlato al mercato dovrebbe orientare
        il proprio portafoglio finanziario maggiormente verso asset rischiosi rispetto a un investitore
        privo di reddito da lavoro. In altri termini, il capitale umano privo di rischio agisce come
        un’“obbligazione implicita” nel patrimonio dell’investitore.
      </p>

      <p>
        Formalmente, nel modello mean–variance a un periodo con un asset rischioso (azioni) e uno
        risk-free, il peso ottimale in azioni sul patrimonio finanziario <IM>{tex`W`}</IM> con capitale
        umano <IM>{tex`H`}</IM> è:
      </p>
      <p>
        <BM>{tex`
          w_{\mathrm{az}}(W)
          \;=\;
          \frac{W+H}{W}\cdot\frac{\mathbb{E}[R_m]-R_f}{A\,\sigma_m^{2}}
          \;-\;
          \frac{\operatorname{Cov}(R_L,\,R_m)}{A\,W\,\sigma_m^{2}}
        `}</BM>
      </p>
      <p>
        dove: <IM>{tex`A`}</IM> è l’avversione al rischio; <IM>{tex`\sigma_m^{2}`}</IM> la varianza del
        mercato; <IM>{tex`R_L`}</IM> è il rendimento del capitale umano (variazione % del reddito), non
        il livello <IM>{tex`Y`}</IM> in euro.
      </p>

      <p><strong>Punti chiave (BMS):</strong></p>
      <ul>
        <li>
          Se <IM>{tex`R_L`}</IM> è non correlato al mercato (o il lavoro è di fatto risk-free), la
          covarianza è ~0 e resta solo il fattore leva <IM>{tex`(W+H)/W`}</IM>: l’allocazione azionaria
          sui soli asset finanziari va aumentata perché <IM>{tex`H`}</IM> si comporta come un bond
          implicito.
        </li>
        <li>
          Se <IM>{tex`R_L`}</IM> è pro-ciclico (cov positiva), il secondo termine è sottrattivo: la quota
          azionaria si riduce per evitare doppia esposizione allo stesso rischio.
        </li>
        <li>
          Nella mean–variance la varianza del reddito non negoziabile non entra direttamente nei pesi
          ottimali: conta solo la covarianza con il mercato.
        </li>
        <li>
          Gli esiti “oltre 100%” o “&lt;0%” sono ottimi non vincolati; in pratica si applicano vincoli
          (0–100%, no short/no leva).
        </li>
      </ul>

      <p>
        Nota sulle estensioni CRRA / life-cycle. Nei modelli multi-periodo con utilità CRRA
        (Campbell-Viceira), oltre alla “domanda miopica” compaiono domande di copertura intertemporale
        (hedging demand) che dipendono da variabili di stato e prevedibilità dei rendimenti. Sono modelli
        più ricchi ma anche più complessi; qui restiamo sull’impianto BMS per coerenza con la trattazione.
      </p>

      <p>
        Integrare il capitale umano nella tradizionale mean-variance di Markowitz si può fare quindi
        estendendo il concetto di wealth per includere la ricchezza umana accanto a quella finanziaria e
        utilizzando la formula sopra. Il termine di covarianza deve essere stimato sui <em>rendimenti</em>{" "}
        del reddito (variazioni percentuali) e non sui livelli in euro. Definiamo la beta del reddito:
      </p>
      <p>
        <BM>{tex`\beta_{L} \;=\; \frac{\operatorname{Cov}(R_L,\,R_m)}{\sigma_m^{2}}`}</BM>
      </p>
      <p>
        allora il termine correttivo può essere scritto anche come{" "}
        <IM>{tex`-\dfrac{\operatorname{Cov}(R_L,\,R_m)}{A\,W\,\sigma_m^{2}} = -\dfrac{\beta_L}{A\,W}`}</IM>.
      </p>

      <h2>Esempi pratici: integrazione del capitale umano nell’asset allocation</h2>

      <h3>Esempio 1: Famiglia a doppio reddito stabile, lungo termine</h3>
      <p>
        <strong>Ipotesi.</strong> Due coniugi 35enni: lui impiego pubblico (30.000 € netti/anno), lei
        impiego privato stabile (25.000 €). Orizzonte 30 anni. Patrimonio finanziario{" "}
        <IM>{tex`W = 200{.}000\,\text{€}`}</IM> (iniziale 50/50). Profilo moderato.
      </p>
      <p>
        <strong>Valore attuale del capitale umano (H).</strong> Consideriamo i due redditi come poco
        rischiosi e debolmente correlati al mercato. Con tasso reale <IM>{tex`r_d = 2\%`}</IM> e reddito
        complessivo 55.000 €/anno:
      </p>
      <p>
        <BM>{tex`
          H \;\approx\;
          55{.}000 \times \frac{1 - (1+0{,}02)^{-30}}{0{,}02}
          \;\approx\; 1{.}231{.}800\,\text{€}.
        `}</BM>
      </p>
      <p>
        <strong>Rapporto H/W.</strong> <IM>{tex`H/W \approx 6{,}15`}</IM>.
      </p>
      <p>
        <strong>Peso azionario ottimale (BMS).</strong> Assumiamo{" "}
        <IM>{tex`\mathbb{E}(R_m)-R_f = 5\%`}</IM>, <IM>{tex`\sigma_m = 20\% \Rightarrow \sigma_m^2=0{,}04`}</IM>,{" "}
        <IM>{tex`A=4`}</IM>. Con covarianza <IM>{tex`\operatorname{Cov}(R_L,R_m)\approx 0`}</IM> (redditi
        bond-like):
      </p>
      <p>
        <BM>{tex`
          w_{\mathrm{az}}(W)
          \;=\;
          \underbrace{\frac{W+H}{W}}_{=\,7{,}15}
          \cdot \frac{0{,}05}{4\cdot 0{,}04}
          \;-\; 0
          \;=\;
          7{,}15 \cdot 0{,}3125
          \;\approx\; 2{,}23 \;\; (223\%).
        `}</BM>
      </p>
      <p>
        È un ottimo non vincolato &gt;100% per i soli asset finanziari. Con vincolo 0–100%, la soluzione
        vincolata è avvicinarsi al 100% azioni su <IM>{tex`W`}</IM> (o comunque a una quota molto alta).
        Questo risultato, apparentemente “aggressivo”, è coerente perché l’86% della ricchezza totale è
        bond-like grazie a <IM>{tex`H`}</IM>. In termini pratici e di comunicazione al cliente, l’idea
        intuitiva di “target sul totale” (es. voler 50/50 su <IM>{tex`W+H`}</IM>) è utile come linea guida
        ma non discende dalla FOC BMS: è un criterio narrativo per spiegare perché l’allocazione
        finanziaria debba essere più azionaria.
      </p>
      <p>
        <strong>Sensitività.</strong> Se parte del reddito privato avesse moderata correlazione positiva,{" "}
        <IM>{tex`\operatorname{Cov}(R_L,R_m)>0`}</IM> aggiunge un termine sottrattivo e il peso azionario
        vincolato potrebbe scendere (es. 80–100%), restando comunque elevato dato l’alto{" "}
        <IM>{tex`H/W`}</IM>.
      </p>

      <h3>Esempio 2: Imprenditore con reddito volatile e alto potenziale</h3>
      <p>
        <strong>Ipotesi.</strong> 40enne imprenditore tech. Reddito atteso 80.000 €/anno, alta volatilità
        e alta correlazione con il mercato (<IM>{tex`\rho`}</IM> elevata).{" "}
        <IM>{tex`W = 300{.}000\,\text{€}`}</IM> investiti 70/30.
      </p>
      <p>
        <strong>Valore attuale del capitale umano (H).</strong> Per rischio elevato, usiamo{" "}
        <IM>{tex`r_d = 8\%`}</IM>, orizzonte 20 anni:
      </p>
      <p>
        <BM>{tex`
          H \;\approx\;
          80{.}000 \times \frac{1 - (1+0{,}08)^{-20}}{0{,}08}
          \;\approx\;
          80{.}000 \times 9{,}8
          \;\approx\; 784{.}000\,\text{€}\;(\sim 800\text{k}).
        `}</BM>
      </p>
      <p>
        <strong>Rapporto H/W.</strong> <IM>{tex`H/W \approx 2{,}67`}</IM>.
      </p>
      <p>
        <strong>Peso azionario ottimale (BMS).</strong> Con parametri di mercato come sopra e{" "}
        <IM>{tex`\operatorname{Cov}(R_L,R_m)>0`}</IM> rilevante, conviene stimare{" "}
        <IM>{tex`\beta_L = \operatorname{Cov}(R_L,R_m)/\sigma_m^{2}`}</IM> usando variazioni % del
        reddito (o una proxy settoriale). Il termine{" "}
        <IM>{tex`-\dfrac{\operatorname{Cov}(R_L,R_m)}{A\,W\,\sigma_m^{2}} = -\dfrac{\beta_L}{A\,W}`}</IM> può
        diventare grande al punto da rendere <IM>{tex`w_{\mathrm{az}}(W)\le 0`}</IM>. Con vincolo 0–100%,
        la soluzione pratica è spingere verso 0% azioni (o comunque una quota molto bassa), perché il
        lavoro fornisce già un’enorme esposizione “equity-like”. Un hedging più fine (derivati) sarebbe
        teoricamente ottimo, ma di rado adottato dal retail.
      </p>
      <p>
        <strong>Sensitività.</strong> Se la correlazione scende (settore meno ciclico),{" "}
        <IM>{tex`\operatorname{Cov}(R_L,R_m)`}</IM> si riduce e una certa quota azionaria finanziaria
        torna ammissibile (es. 20–40%). Se la volatilità del reddito è alta ma non correlata, in MV non
        cambia i pesi (entra solo la covarianza), ma in pratica è prudente mantenere più
        liquidità/obbligazioni (e, in modelli CRRA multi-periodo, emerge una maggiore hedging demand).
      </p>

      <h2>Conclusioni</h2>
      <p>
        Il capitale umano è un elemento spesso trascurato ma di fondamentale importanza nella costruzione
        di portafogli ottimali per investitori privati. Rappresenta il valore attuale dei futuri guadagni
        da lavoro e può essere concettualmente assimilato a una grande posizione in un asset non
        negoziabile che influisce sul profilo di rischio complessivo. Integrare il capitale umano nelle
        scelte di asset allocation, nel quadro Bodie–Merton–Samuelson, significa:
      </p>
      <ul>
        <li>
          usare il fattore <IM>{tex`(W+H)/W`}</IM> per catturare l’effetto “bond implicito” quando il
          reddito è poco correlato al mercato;
        </li>
        <li>
          applicare la correzione di covarianza <IM>{tex`\operatorname{Cov}(R_L,R_m)`}</IM> (stimata su
          rendimenti del reddito) per ridurre/aumentare l’azionario finanziario quando il lavoro è
          rispettivamente pro-/anti-ciclico;
        </li>
        <li>
          riconoscere che la varianza del reddito in sé non modifica i pesi in MV a un periodo (conta la
          covarianza), mentre nelle versioni CRRA multi-periodo compaiono anche domande di copertura
          intertemporali.
        </li>
      </ul>
      <p>
        Questa integrazione rende il portafoglio più aderente alla situazione reale dell’investitore,
        migliorando la diversificazione totale tra capitale umano e capitale finanziario. Gli esempi
        numerici mostrano inoltre l’importanza di ribilanciare nel tempo: man mano che{" "}
        <IM>{tex`H`}</IM> si “consuma” o cambia natura (più o meno correlato al mercato), l’asset
        allocation va rivista per restare efficiente. In conclusione, considerare il capitale umano nella
        pianificazione finanziaria conduce a scelte più consapevoli e robuste, evitando di sovraesporsi ai
        medesimi rischi su fronte lavoro e investimenti e massimizzando il rendimento atteso per un dato
        livello di rischio complessivo.
      </p>
    </div>
  ),
},


  {
    slug: "psicologia-investitore-bias",
    title: "Psicologia dell'investitore: bias cognitivi e come difendersi",
    metaDescription:
      "I bias più comuni (conferma, ancoraggio, recency), come influenzano le decisioni di investimento e come mitigarli con piani disciplinati e diversificazione.",
    tags: ["psicologia", "educazione"],
    readTime: "6 min",
    author: "Redazione",
    datePublished: "2025-05-08",
    coverImage: PsyCover,
    canonical: `${DOMAIN}/kb/psicologia-investitore-bias`,
    content: (
      <div>
        <h1>Psicologia dell'investitore: bias cognitivi e come difendersi</h1>
        <p>
          Le decisioni d'investimento non sono sempre razionali: la finanza comportamentale dimostra che siamo soggetti a numerosi{" "}
          <strong>bias cognitivi</strong> che possono danneggiare i nostri risultati. Comprenderli è il primo passo per evitarli.
        </p>

        <h2>1. Bias più comuni</h2>
        <ul>
          <li>
            <strong>Bias di conferma</strong>: cerchiamo solo informazioni che confermano le nostre opinioni e ignoriamo dati contrari.
          </li>
          <li>
            <strong>Ancoraggio</strong>: ci fissiamo su un prezzo di acquisto o un massimo/minimo precedente e fatichiamo a venderne in perdita
            o a comprare su nuovi massimi.
          </li>
          <li>
            <strong>Recency bias</strong>: attribuiamo troppa importanza agli eventi recenti, trascurando la storia di lungo periodo.
          </li>
          <li>
            <strong>Illusione di controllo</strong>: crediamo di avere più controllo sul mercato di quanto non sia, portandoci a overtrading.
            Studi accademici dimostrano che un eccessivo turnover riduce i rendimenti netti degli investitori retail.
          </li>
        </ul>

        <h2>2. Come difendersi</h2>
        <ol>
          <li>Stabilire regole <strong>ex-ante</strong>: asset allocation target, soglie di ribilanciamento, stop-loss ragionati.</li>
          <li>Adottare un <strong>PAC</strong> automatico per investire gradualmente e ridurre l'impatto emotivo.</li>
          <li>Mantenere <strong>diario d'investimento</strong> per riflettere sulle decisioni e sui sentimenti associati.</li>
          <li>Affidarsi a un <strong>consulente indipendente</strong> per ancorare le scelte a dati e strategie documentate.</li>
        </ol>

        <p>
          Ricorda: riconoscere i bias è la base per evitarli. Per un programma completo di educazione comportamentale,{" "}
          <a href="/contact">scrivimi</a>
        </p>
      </div>
    ),
  },


// --- NUOVO ARTICOLO ---
{
  slug: "copertura-valutaria-etf-hedged-vs-unhedged",
  title: "Copertura valutaria: ETF hedged vs unhedged e come analizzarli",
  metaDescription:
    "Hedged o unhedged? Cos’è la copertura valutaria negli ETF, pro e contro, e un’analisi quantitativa con Python (Colab) su S&P 500, MSCI World e Treasury 20+ anni.",
  tags: ["etf", "valute", "educazione", "quant"],
  readTime: "10 min",
  author: "Redazione",
  datePublished: "2025-08-22",
  dateUpdated: "2025-08-22",
  coverImage: HedgedCover,
  canonical: `${DOMAIN}/kb/copertura-valutaria-etf-hedged-vs-unhedged`,
  content: (
    <div>
      <h1>Copertura valutaria: ETF hedged vs unhedged e come analizzarli</h1>

      <h2>DISCLAIMER</h2>
      <p>
        Le analisi e le opinioni qui esposte hanno scopo puramente informativo.
        Non costituiscono raccomandazioni di investimento. Prima di adottare
        qualunque strategia è fondamentale confrontarsi con un consulente
        finanziario.
      </p>

      <h2>Introduzione e obiettivi</h2>
      <p>
        Investire sui mercati internazionali permette di diversificare il
        portafoglio, ma espone l’investitore al rischio di cambio. Un
        investitore europeo che acquista un ETF sull’indice S&amp;P 500 quotato
        in dollari, ad esempio, otterrà un rendimento che dipende sia dalla
        performance dell’indice sia dall’andamento del cambio euro/dollaro.
        Come ricorda Vanguard, anche se un indice azionario statunitense sale
        del 10 %, il rendimento in sterline (o euro) può essere diverso perché
        la somma da convertire al momento del rimborso è influenzata dal cambio.
        Per gestire questa variabile esistono ETF “hedged” (con copertura
        valutaria), che cercano di neutralizzare gli effetti dei movimenti
        valutari. Gli ETF “unhedged”, al contrario, lasciano aperta
        l’esposizione al cambio.
      </p>
      <p>
        L’obiettivo di questo articolo è spiegare come funziona la copertura
        valutaria, quali sono i vantaggi e gli svantaggi degli ETF hedged
        rispetto agli unhedged, e illustrare, attraverso un’analisi aggiornata
        con Python (disponibile su Google Colab), le differenze di rendimento
        fra le due tipologie negli ultimi anni. Lo faremo mantenendo un taglio
        divulgativo ma rigoroso, con riferimenti a studi istituzionali e
        mostrando un esempio grafico.
      </p>
      <p>
        <strong>Video di approfondimento:</strong> il concetto spiegato in modo pratico.
      </p>
      <YouTubeEmbed
        videoId="x3S1ZbtwnNk"
        title="ETF hedged vs unhedged e fluttuazioni valutarie"
        onPlay={(id) => trackVideoPlay(id, "article")}
      />

      <h2>Perché i tassi di cambio si muovono?</h2>
      <p>
        Le fluttuazioni valutarie dipendono da numerosi fattori macroeconomici:
        differenziali di tasso d’interesse, inflazione, stabilità politica,
        andamento dell’economia e shock globali. In generale, una valuta tende
        ad apprezzarsi se il Paese offre tassi di interesse più elevati o
        maggiore crescita attesa, perché gli investitori vi spostano capitali
        alla ricerca di rendimenti superiori; si deprezza, invece, se
        l’economia rallenta o l’inflazione è più alta. Non è detto che queste
        oscillazioni si compensino nel lungo termine: periodi di forza o
        debolezza persistente possono durare molti anni, rendendo difficile
        prevedere il punto di arrivo.
      </p>

      <h2>Cos’è un ETF hedged e perché usarlo</h2>
      <p>
        Un ETF hedged (coperto) e la versione unhedged (non coperta) investono
        nello stesso paniere di titoli; la differenza è che l’ETF hedged
        utilizza contratti forward (o altri derivati valutari) per bloccare il
        tasso di cambio futuro e neutralizzare l’effetto delle fluttuazioni.
        Questo consente all’investitore di replicare la performance “in valuta
        locale” dell’indice, senza che il rendimento dipenda dal rafforzamento o
        indebolimento della valuta estera. La copertura elimina però anche la
        possibilità di beneficiare di movimenti favorevoli della valuta.
      </p>
      <p>
        Vanguard spiega che offre share class con copertura valutaria soprattutto
        per i fondi obbligazionari, poiché i bond servono a ridurre la
        volatilità del portafoglio e il rischio di cambio può neutralizzarne il
        beneficio. Per contro, la società non offre share class hedged per fondi
        azionari destinati agli investitori privati britannici, perché le azioni
        sono già più rischiose e il contributo della valuta può risultare neutro
        nel lungo termine. Morningstar evidenzia che la copertura valutaria
        riduce la volatilità, ma nel lungo periodo l’effetto sul rendimento
        totale è moderato: da gennaio 2001 a settembre 2022 l’indice MSCI ACWI
        ex USA hedged ha superato di poco (23 968 $ contro 21 936 $ su 10 000 $
        investiti) l’indice non coperto, e solo a partire da giugno 2022.
        Inoltre, gli ETF hedged presentano costi più elevati (0,30–0,40 % contro
        &lt;0,10 % degli unhedged), possono generare distribuzioni di capital
        gain per via del rinnovo mensile dei contratti forward e non eliminano
        del tutto il rischio di cambio.
      </p>

      <h2>Pro e contro in sintesi</h2>
      <ul>
        <li>
          <strong>Rischio di cambio</strong>: Ridotto grazie all’uso di
          contratti forward (hedged) vs totale esposizione al cambio (unhedged),
          con possibilità di guadagno o perdita aggiuntiva.
        </li>
        <li>
          <strong>Volatilità</strong>: Inferiore negli hedged (non subiscono la
          volatilità della valuta) vs maggiore negli unhedged, specie in periodi
          di forte variazione valutaria.
        </li>
        <li>
          <strong>Costi</strong>: Commissioni e costi di hedging più elevati
          negli hedged vs generalmente più bassi negli unhedged.
        </li>
        <li>
          <strong>Rendimento nel lungo termine</strong>: In media simile, con
          differenze legate ai tassi d’interesse e ai costi (hedged talvolta
          leggermente inferiori o superiori a seconda dei periodi).
        </li>
        <li>
          <strong>Applicazione tipica</strong>: Hedged più diffusi su fondi
          obbligazionari e per chi vuole ridurre il rischio totale; unhedged
          tipici sugli azionari per investitori che accettano l’oscillazione di
          cambio.
        </li>
      </ul>

      <h2>Metodologia dell’analisi quantitativa (codice Python)</h2>
      <p>
        Per valutare empiricamente l’impatto della copertura valutaria, è stato
        creato un notebook Python (disponibile su GitHub) che scarica i prezzi
        storici di alcune coppie di ETF e del tasso di cambio EUR/USD tramite la
        libreria yfinance. L’analisi considera tre casi:
      </p>
      <ul>
        <li>
          <strong>S&amp;P 500 europeo</strong> – versione non coperta
          (IUSA.AS) e coperta (IUSE.AS).
        </li>
        <li>
          <strong>MSCI World</strong> – versione non coperta (IWDA.AS) e
          coperta (IWDE.AS).
        </li>
        <li>
          <strong>US Treasury 20+ Years</strong> – ETF di bond a lunga
          scadenza non coperto vs la versione coperta (DTLE.L).
        </li>
      </ul>
      <p>Per ciascuna coppia, il codice:</p>
      <ul>
        <li>
          Scarica i prezzi adjusted close degli ETF dal 2019 ad oggi
          (aggiornamento fine agosto 2025).
        </li>
        <li>
          Calcola una terza serie di riferimento (“Perfect Hedge”) moltiplicando
          i prezzi dell’ETF non coperto per il tasso EUR/USD, simulando una
          copertura teorica senza costi.
        </li>
        <li>
          Calcola i rendimenti cumulativi (cumulative return) e li confronta.
        </li>
      </ul>
      <p>
        Il notebook produce grafici comparativi e calcola lo spread annualizzato
        tra l’ETF hedged reale e l’ETF perfettamente coperto, così da evidenziare
        l’inefficienza della copertura reale (costi di hedging, differenza di
        tassi d’interesse). I risultati che riportiamo di seguito derivano
        dall’aggiornamento del notebook a settembre 2025.
      </p>

      <h2>Risultati: hedged vs unhedged negli ultimi anni</h2>

      <h3>ETF S&amp;P 500</h3>
      <p>
        Per l’indice S&amp;P 500 la versione coperta ha offerto un vantaggio
        ancora più evidente. Tra ottobre 2022 e settembre 2025 l’ETF hedged
        IUSE.AS è passato da 1 a circa 1,67, contro circa 1,46 della versione
        non coperta IUSA.AS; la copertura perfetta avrebbe raggiunto circa 1,75.
        Questo differenziale (circa 20 % a favore del hedged) è dovuto alla
        forte svalutazione del dollaro rispetto all’euro dal quarto trimestre
        2022: l’investitore europeo che ha coperto il cambio ha evitato la
        perdita legata al ribasso del dollaro. In anni precedenti, quando il
        dollaro era in trend di rafforzamento, gli ETF unhedged avevano spesso
        sovraperformato; l’inversione recente sottolinea come la convenienza
        della copertura dipenda dalle dinamiche valutarie e vada valutata caso
        per caso.
      </p>

      <figure>
        <a href={fxFig1} target="_blank" rel="noopener noreferrer">
          <img
            src={fxFig1}
            alt="Figura 1 — S&P 500: confronto rendimenti cumulativi tra unhedged, hedged e perfect hedge."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 1 — S&amp;P 500: confronto dei rendimenti cumulativi tra ETF
          non coperto (unhedged), coperto (hedged) e copertura teorica
          “perfetta”.
        </figcaption>
      </figure>

      <h3>ETF MSCI World</h3>
      <p>
        L’analisi aggiornata dal 5 ottobre 2022 al 8 settembre 2025 mostra che
        la versione hedge IWDE.AS ha sovraperformato la versione non coperta
        IWDA.AS. Se un investimento iniziale uguale a 1 viene normalizzato al 5
        ottobre 2022, alla fine del periodo l’ETF hedged varrebbe circa 1,62,
        mentre la versione unhedged sarebbe intorno a 1,49; la copertura
        perfetta (IWDA.PerfectHedged) arriverebbe a circa 1,78. La differenza di
        performance tra hedged e unhedged (≈ 13 %) riflette il rafforzamento
        dell’euro sul dollaro nel periodo; tuttavia la copertura valutaria non
        replica interamente la copertura ideale, perché incorpora costi di
        hedging e non copre il 100 % della quota denominata in valute diverse
        dal dollaro.
      </p>

      <figure>
        <a href={fxFig2} target="_blank" rel="noopener noreferrer">
          <img
            src={fxFig2}
            alt="Figura 2 — MSCI World: confronto rendimenti cumulativi tra unhedged, hedged e perfect hedge."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 2 — MSCI World: rendimenti cumulativi a confronto tra versione
          non coperta, coperta e copertura teorica “perfetta”.
        </figcaption>
      </figure>

      <h3>ETF obbligazionario US Treasury 20+ Years</h3>
      <p>
        Sul fronte obbligazionario, l’ETF hedged su Treasury USA a lunga
        scadenza ha registrato un gap medio di circa 1,6 % annuo rispetto alla
        copertura ideale. Durante la fase di rafforzamento dell’euro (fine 2022)
        il vantaggio del hedged è stato temporaneo, ma su orizzonti più lunghi
        l’ETF non coperto tende a recuperare e superare la controparte hedged,
        anche grazie alle cedole reinvestite e alla differenza di tassi.
      </p>
      <p>
        L’immagine seguente, mostra come i rendimenti cumulativi delle tre serie
        (unhedged, hedged e “perfect hedge”) divergano progressivamente nel
        tempo.
      </p>

      <figure>
        <a href={fxFig3} target="_blank" rel="noopener noreferrer">
          <img
            src={fxFig3}
            alt="Figura 3 — Treasury 20+ anni: confronto rendimenti cumulativi tra unhedged, hedged e perfect hedge."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Figura 3 — US Treasury 20+ anni: confronto dei percorsi di rendimento
          cumulato tra ETF non coperto, coperto e copertura teorica.
        </figcaption>
      </figure>

      <h2>Prevedere il cambio: esperimento con Prophet</h2>
      <p>
        Per valutare se la copertura sia conveniente nei prossimi anni, il
        notebook utilizza la libreria Prophet per prevedere il tasso di cambio
        EUR/USD. Addestrato sui dati storici, il modello prevede un trend
        discendente del cambio, con un intervallo di confidenza (80 %) tra 1,00
        e 1,15 nel prossimo anno. L’errore medio assoluto del 6 % e la deviazione
        standard dell’errore di 8 centesimi indicano però una notevole
        incertezza. Supponendo un cambio a 1,15, l’investitore che sceglie l’ETF
        hedged otterrebbe un vantaggio potenziale di soli 2–3 punti percentuali
        rispetto alla versione non coperta; se invece l’euro non dovesse
        rafforzarsi, la copertura comporterebbe un costo inutile. La predizione
        quindi non fornisce certezze, ma invita a considerare che le oscillazioni
        valutarie possono rivelarsi un alleato o un nemico.
      </p>

      <h2>Potenzialità e limiti del modello Python</h2>
      <p>
        L’analisi presentata è completamente riproducibile: il notebook utilizza
        solo librerie open-source (yfinance per il download dei dati, pandas e
        numpy per i calcoli, matplotlib per i grafici). È possibile modificare
        il periodo di osservazione, cambiare gli ETF analizzati o integrare
        ulteriori indici (ad esempio mercati emergenti) per esplorare altre
        esposizioni valutarie. Il metodo di calcolo del “perfect hedge”
        moltiplicando il prezzo dell’ETF per il tasso di cambio può essere
        applicato a qualsiasi strumento, purché i dati siano disponibili.
      </p>
      <p>
        Rispetto alle analisi disponibili sul mercato (spesso basate su medie di
        lungo periodo o su indici sintetici), questo approccio consente di
        valutare con precisione l’effetto della valuta su ETF specifici,
        evidenziando i costi reali della copertura e l’andamento del differenziale
        in diversi periodi. Non è un algoritmo di machine learning complesso: non
        vi è un modello predittivo delle allocazioni, ma un semplice calcolo
        statistico. Tuttavia, è un esempio di come un investitore possa usare
        strumenti quantitativi per prendere decisioni più consapevoli.
      </p>

      <h2>Confronto con altre metodologie</h2>
      <p>
        Esistono algoritmi più sofisticati (ad esempio reti neurali o modelli
        LSTM) che provano a prevedere l’andamento dei tassi di cambio o a
        ottimizzare un portafoglio considerando simultaneamente più variabili.
        Tali modelli possono cogliere pattern non lineari e interazioni complesse,
        ma hanno due limitazioni: richiedono grandi quantità di dati storici e le
        previsioni possono essere facilmente invalidate da shock economici
        imprevisti. In questo contesto, la semplicità del modello utilizzato
        (copertura “perfetta” e confronto diretto) può risultare un vantaggio: è
        trasparente, facilmente verificabile e non nasconde ipotesi implicite.
        Come sottolinea Morningstar, l’effetto della copertura oscilla in cicli e
        nel lungo periodo la differenza di performance si riduce, mentre i costi
        e le tasse possono erodere i vantaggi. Pertanto, un approccio sofisticato
        potrebbe aggiungere marginali benefici rispetto a una valutazione semplice
        e periodica.
      </p>

      <h2>Considerazioni finali</h2>
      <ul>
        <li>
          <strong>La copertura valutaria riduce la volatilità:</strong> chi non
          vuole vedere i propri investimenti influenzati dai movimenti del cambio
          può optare per ETF hedged. Questo può essere particolarmente utile nel
          breve periodo o per investimenti obbligazionari.
        </li>
        <li>
          <strong>Nel lungo periodo l’extra-rendimento è limitato:</strong> dati
          storici e analisi quantitative mostrano che hedged e unhedged tendono ad
          avere rendimenti a favore tendenzialmene verso quest’ultimo per la
          componente dei costi. Il vantaggio eventuale dipende anche dal
          differenziale dei tassi d’interesse.
        </li>
        <li>
          <strong>I costi contano:</strong> gli ETF hedged presentano commissioni
          più alte, potenziali distribuzioni di capital gain e costi di
          transazione legati al rinnovo dei forward. Nel tempo, queste voci
          possono erodere il rendimento.
        </li>
        <li>
          <strong>La scelta dipende da aspettative e orizzonte:</strong> se si
          prevede un forte apprezzamento della propria valuta nel breve periodo,
          la copertura può offrire protezione; se invece si crede che la valuta
          estera resterà stabile o si indebolirà, lasciare l’esposizione al
          cambio può incrementare i rendimenti.
        </li>
        <li>
          <strong>Diversificazione valutaria:</strong> un ulteriore modo per
          gestire il rischio di cambio è investire in ETF denominati in più
          valute o in valute diverse (es. dollaro, yen, franco svizzero),
          creando un portafoglio multicurrency. Questo tema sarà approfondito in
          futuri articoli.
        </li>
      </ul>
      <p>
        In conclusione, la decisione di scegliere un ETF hedged o unhedged deve
        essere presa sulla base del proprio profilo di rischio, delle convinzioni
        sull’andamento del cambio e dell’orizzonte temporale.Tuttavia non è detto
        che la copertura non debba essere considerata per dei costi più elevati,
        in quanto i fattori da considerare sono molteplici Gli strumenti
        quantitativi presentati consentono di valutare concretamente gli effetti
        della copertura, ma non sostituiscono il giudizio professionale. Per
        questo è consigliabile confrontarsi con un esperto prima di implementare
        qualunque strategia. Per una spiegazione ulteriore si prega di visualizzare il video di approfondimento sul 
        canale YouTube.
      </p>

      <h2>Risorse utili e codice</h2>
      <ul>
        <li>
          <strong>Notebook Colab (aggiornato):</strong> HedgedvsUnhedged.ipynb
          {/* Es.: sostituisci con il tuo link Colab/GitHub */}
        </li>
        <li>
          <strong>Video di approfondimento:</strong>{" "}
          <a
            href="https://www.youtube.com/watch?v=x3S1ZbtwnNk"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/watch?v=x3S1ZbtwnNk
          </a>
        </li>
        <li>
          <strong>Analisi Morningstar</strong> sull’efficacia dei currency-hedged
          ETFs.
        </li>
        <li>
          <strong>Approfondimento Vanguard</strong> sulle share class hedged e
          sui vantaggi/limitazioni della copertura.
        </li>
        <li>
          <strong>Articolo Harvest ETF</strong> sulle caratteristiche dei currency
          hedged ETF.
        </li>
      </ul>
    </div>
  ),
},

{
  slug: "factor-investing-guida-completa",
  title: "Factor Investing: concetti, evidenze e guida per l’investitore",
  metaDescription:
    "Che cos’è il factor investing, quali sono i fattori principali (value, momentum, low volatility, quality), evidenze empiriche, implementazione mono e multi-fattoriale, rischi/costi e ruolo del capitale umano. Guida completa con riferimenti.",
  tags: ["factor", "educazione", "etf"],
  readTime: "10 min",
  author: "Redazione",
  datePublished: "2025-08-22",
  dateUpdated: "2025-08-22",
  coverImage: FactorCover,
  canonical: `${DOMAIN}/kb/factor-investing-guida-completa`,
  content: (
    <div>
      <h1>Factor Investing: concetti, evidenze e guida per l’investitore</h1>

      <h2>Introduzione</h2>
      <p>
        Il factor investing è un approccio d’investimento che si concentra su
        caratteristiche sistematiche – i cosiddetti fattori – in grado di generare
        premi di rendimento superiori a quelli offerti dal portafoglio di mercato
        nel lungo periodo. Fin dalla formulazione del Capital Asset Pricing Model
        (CAPM) negli anni ’60, i ricercatori hanno notato anomalie nelle valutazioni
        che il CAPM da solo non riusciva a spiegare: titoli con multipli bassi,
        volatilità ridotta o momenti di prezzo favorevoli hanno ottenuto rendimenti
        superiori a quelli previsti dal modello. Queste anomalie sono state codificate
        come fattori di rischio e, negli ultimi decenni, la loro combinazione ha assunto
        un ruolo sempre più centrale nella gestione di portafogli istituzionali e retail.
      </p>
      <p>
        La guida di Robeco chiarisce che investire in fattori significa puntare su segmenti
        del mercato caratterizzati da proprietà strutturali che, in passato, hanno assicurato
        rendimenti aggiustati per il rischio superiori a quelli dell’indice. Inizialmente
        confinato a portafogli accademici, il factor investing ha iniziato a diffondersi tra
        gli investitori professionali dopo che lo studio del 2009 sulla gestione del fondo
        sovrano norvegese NBIM dimostrò che oltre il 70% dei rendimenti attivi era spiegato
        da esposizioni fattoriali implicite. Successivamente, molti investitori hanno iniziato
        a sfruttare i fattori in modo deliberato, come terza via tra gestione passiva ed attiva:
        strategie basate su regole, trasparenti e a costi ridotti, ma capaci di generare extra-rendimento.
      </p>
      <p>
        L’approccio non mira a scoprire il singolo titolo vincente, bensì a
        catturare questi premi di rischio in modo trasparente e sistematico.
        Per ridurre le fasi di sottoperformance dei singoli fattori è
        consigliabile combinare più fattori in portafogli multi‑factor.
      </p>

      <h2>I principali fattori premianti</h2>
      <p>
        La letteratura accademica ha identificato numerosi fattori, ma solo alcuni soddisfano
        criteri rigidi di persistenza, pervasività (presenti in più mercati), robustezza (resistono
        alle diverse metodologie di costruzione), investibilità e spiegazione intuitiva. Tra questi,
        quattro sono considerati “provati” per il mercato azionario e sono ampiamente utilizzati:
      </p>
      <ul>
        <li>
          <strong>Value</strong> – Le azioni con valutazioni basse (ad esempio, basso rapporto
          prezzo/valore contabile o price-to-earnings) tendono a sovraperformare quelle con valutazioni
          elevate. Questa anomalia, documentata già negli anni ’70, è stata riscontrata in molti mercati:
          titoli “a buon mercato” offrono rendimenti più alti a parità di rischio.
        </li>
        <li>
          <strong>Momentum</strong> – I titoli che hanno registrato buone performance recenti continuano
          in media a farlo anche nei mesi successivi. Questa tendenza, formalizzata negli anni ’90,
          rappresenta uno dei premi fattoriali più persistenti.
        </li>
        <li>
          <strong>Low Volatility</strong> – I titoli con volatilità o beta di mercato più bassi ottengono
          rendimenti superiori a quanto suggerito dal loro rischio: una violazione del CAPM confermata sia
          nei mercati sviluppati che in quelli emergenti; offre drawdown più contenuti.
        </li>
        <li>
          <strong>Quality</strong> – Le imprese con fondamentali solidi (utili persistenti, leva contenuta,
          solidità del bilancio) tendono a sovraperformare quelle con qualità inferiore; nelle versioni moderne,
          la qualità include anche la sostenibilità degli utili e la governance.
        </li>
      </ul>
      <p>
        Altri fattori frequentemente citati sono <em>size</em> (small-cap vs large-cap), <em>carry/value</em> e
        <em> sentiment</em>. Recentemente, la ricerca ha proposto fattori legati agli asset intangibili, come capitale
        intellettuale e reputazione: Sparkline Capital, ad esempio, suggerisce un fattore “intangible value” che investe
        in aziende con forte capitale intellettuale e brand, ottenendo rendimenti poco correlati ai fattori tradizionali.
        Questo fattore sfrutta la crescente importanza degli asset immateriali (marchi, proprietà intellettuale,
        capitale umano) nell’economia moderna.
      </p>
      <h2>Fondamenti e formule</h2>
      <h3>Dal CAPM ai modelli Fama‑French</h3>
      <p>
        Il <strong>Capital Asset Pricing Model</strong> (CAPM) stabilisce che il
        rendimento atteso di un asset è funzione del tasso privo di rischio e
        della sua sensibilità al mercato (beta):
      </p>
      <p style={{ fontFamily: "monospace", paddingLeft: "1rem" }}>
        E[R] = R_f + β\*(E[R_M] – R_f)
      </p>
      <p>
        Il modello può essere visto come una combinazione long sul mercato e
        short sul risk‑free: un titolo con β=1,3 equivale a detenere il 130 % del
        mercato e a finanziare il 30 % con una posizione short sul risk‑free.
      </p>
      <p>
        Per spiegare le differenze di rendimento non catturate dal CAPM,
        Fama e French hanno introdotto i fattori <em>size</em> (SMB) e
        <em>value</em> (HML). La formula del modello a tre fattori stima
        l’extra rendimento di un portafoglio come somma delle esposizioni al
        mercato, al fattore dimensione e al fattore valore.
      </p>
      <h2>Evidenze empiriche</h2>
      <p>
        Per quantificare i premi fattoriali, diversi studi hanno analizzato portafogli long/short che acquistano
        titoli con punteggi alti su un fattore e vendono titoli con punteggi bassi. Alpha Architect, ad esempio,
        mostra che investire in azioni a buon mercato dopo lo scoppio della bolla internet (2000–2014) ha generato
        un premio annuo di circa 4,67% rispetto al mercato. Nello stesso periodo, strategie basate su value, momentum,
        low volatility, quality e size hanno tutte evidenziato rendimenti superiori al mercato. Tuttavia, questi premi
        non sono costanti nel tempo: periodi prolungati di sottoperformance possono mettere alla prova la disciplina
        dell’investitore, che deve mantenere l’esposizione ai fattori anche nei cicli avversi.
      </p>
      <p>
        Un report del 2024 di Russell Investments conferma che la performance dei fattori varia su base trimestrale:
        nel terzo trimestre 2024 il fattore Low Volatility ha sovraperformato l’indice globale con un extra-rendimento
        tra +0,8% e +2,3%, mentre i fattori Momentum e Growth hanno sottoperformato (–0,7% a –1,8%) e il fattore Value
        ha dato risultati misti. Ciò sottolinea l’importanza di combinare più fattori per mitigare la ciclicità di ciascun premio.
      </p>

      <h2>Dalla teoria alla pratica: costruire portafogli fattoriali</h2>
      <p>Robeco distingue due modalità principali di implementare i fattori:</p>
      <ul>
        <li>
          <strong>Portafogli “puri” su un singolo fattore</strong>: massimizzano l’esposizione a uno specifico
          premio (es. indice value o momentum). Espongono però a lunghi periodi di sottoperformance quando il fattore
          attraversa un ciclo negativo.
        </li>
        <li>
          <strong>Portafogli multi-fattoriali integrati</strong>: combinano più fattori nello stesso paniere.
          L’integrazione può essere (a) “integrata”, dove ogni titolo è valutato simultaneamente su più fattori e
          selezionato solo se ha punteggi elevati su tutti; oppure (b) “a compartimenti”, costruendo <em>sleeve</em>
          separati per ciascun fattore e aggregandoli. Ricerche (AQR/Alpha Architect) mostrano che approcci integrati
          con vincoli di tracking error possono generare alpha superiore rispetto a portafogli separati; altri studi
          segnalano che, quando il numero di titoli è limitato, le strategie a compartimenti possono risultare competitive.
        </li>
      </ul>
      <p>
        In ogni caso, la scelta tra approccio integrato e a silo dipende da obiettivi, costi di turnover e capacità
        di assumere tracking error.
      </p>

      <h2>Fattori oltre l’azionario</h2>
      <p>
        La maggior parte degli investitori associa il factor investing alle azioni, ma molti premi esistono anche in
        altre asset class: obbligazioni (credit spread, term premium), valute (carry), materie prime (backwardation vs
        contango). Ad esempio, strategie “carry” in ambito valutario consistono nel comprare valute con tassi alti e
        vendere quelle con tassi bassi; nelle obbligazioni corporate esistono fattori legati a valore (spread) e momentum.
        La diversificazione tra asset class aumenta la probabilità che almeno una strategia fattoriale sia in un ciclo favorevole.
      </p>

      <h2>Costi e rischi</h2>
      <p>
        Investire in fattori non è esente da costi e rischi. ETF o fondi smart beta possono avere commissioni più alte
        rispetto agli indici tradizionali e generare maggiore turnover, con costi di trading e impatti fiscali. È
        fondamentale selezionare prodotti efficienti (spese contenute, metodologia trasparente) e considerare che i
        premi possono affievolirsi se un fattore diventa troppo popolare o se i dati non vengono aggiornati
        correttamente. Nessuna strategia è immune da drawdown: value ha sottoperformato a lungo negli anni 2010; momentum
        può soffrire in mercati laterali o con forti inversioni.
      </p>

      <h2>Il capitale umano come fattore di rischio</h2>
      <p>
        Le presentazioni di Andrew Ang evidenziano una dimensione spesso trascurata: anche il capitale umano ha esposizioni
        fattoriali. Il reddito da lavoro rappresenta una quota importante della ricchezza complessiva e può essere
        considerato un asset non negoziabile con caratteristiche simili a quelle di un’obbligazione o di un’azione.
        Se la tua fonte di reddito è <em>bond-like</em> (impiego stabile e poco ciclico), hai maggiore capacità di
        assumere rischio finanziario e puoi mantenere più equity anche avvicinandoti alla pensione; al contrario, se
        il tuo reddito è <em>stock-like</em> (imprenditore o settore ciclico), conviene detenere più obbligazioni o
        asset difensivi per compensare il rischio del capitale umano.
      </p>
      <p>
        Ricerche recenti quantificano l’esposizione del capitale umano ai fattori. Blanchett e Straehl (2017) stimano
        che il capitale umano medio sia circa per il 30% simile a un’azione, ma le differenze settoriali sono ampie:
        settore pubblico ha beta circa nullo, mentre l’industria mineraria presenta beta ~0,53. Queste differenze
        influenzano la quota ottimale in azioni: i dipendenti pubblici potrebbero detenere fino al 76% in equity,
        mentre chi lavora nel mining dovrebbe limitarsi al 40%. In Svezia, un aumento del 20% nella volatilità dei
        salari riduce del 20% la quota investita in azioni.
      </p>
      <p>
        La società Irrational Capital, in collaborazione con J.P. Morgan, ha sviluppato l’indice Human Capital Factor®,
        che misura la qualità del capitale umano (morale, cultura aziendale, engagement). I report mostrano che l’HCI ha
        battuto l’indice in ogni anno del campione (anche nel 2024), con miglior rapporto rischio/rendimento, minore
        volatilità e drawdown rispetto ad altri stili. Ciò suggerisce che integrare la qualità del capitale umano nella
        selezione dei titoli può generare alpha duraturo, confermando l’importanza degli intangibili.
      </p>

      <h2>Human asset evaluation e capitale umano personale</h2>
      <p>
        Considerare la natura <em>stock-like</em> o <em>bond-like</em> del proprio lavoro e come varia lungo il ciclo di vita
        è fondamentale per progettare un portafoglio bilanciato e scegliere quali fattori privilegiare. Un giovane con
        reddito stabile può permettersi più value e momentum; un imprenditore con reddito volatile dovrebbe preferire
        low volatility, quality o multi-fattoriali meno esposti al rischio di mercato.
      </p>

      <h2>Suggerimenti per l’investitore</h2>
      <ul>
        <li>
          <strong>Diversifica tra fattori e asset class.</strong> Combina value, momentum, low volatility, quality e size;
          integra fattori anche su obbligazioni, valute e materie prime.
        </li>
        <li>
          <strong>Valuta il capitale umano.</strong> Analizza stabilità del reddito e correlazione con i fattori di mercato;
          se il lavoro è ciclico, riduci esposizione ai titoli dello stesso settore e aumenta i fattori difensivi.
        </li>
        <li>
          <strong>Scegli prodotti efficienti.</strong> Verifica metodologia, universo investibile, ribilanciamento e costi.
          Valuta anche l’eventuale copertura valutaria (hedged) dove appropriato.
        </li>
        <li>
          <strong>Mantieni la disciplina.</strong> I premi fattoriali sono ciclici: per beneficiarne serve orizzonte e coerenza.
        </li>
        <li>
          <strong>Valuta l’integrazione dei fattori.</strong> Un approccio integrato può migliorare il profilo rischio/rendimento,
          ma bilancia complessità e concentrazione.
        </li>
      </ul>

      <h2>Conclusioni</h2>
      <p>
        Il factor investing rappresenta un’evoluzione rispetto alla semplice distinzione tra gestione attiva e passiva.
        Sfruttando fattori documentati – value, momentum, low volatility, quality, size e intangibili – è possibile migliorare
        i rendimenti corretti per il rischio e costruire portafogli più robusti. Tuttavia i fattori sono ciclici e richiedono
        metodo e disciplina. Integrare il capitale umano nel processo di asset allocation aiuta ad evitare concentrazioni
        di rischio e a modulare l’esposizione ai fattori finanziari in base alla propria situazione personale.
      </p>

      <h3>Riferimenti</h3>
      <ul>
        <li>
          [1] What is Factor Investing? –{" "}
          <a href="https://www.nepc.com/a-guide-to-factor-investing/" target="_blank" rel="noopener noreferrer">
            https://www.nepc.com/a-guide-to-factor-investing/
          </a>
        </li>
        <li>
          [2] [3] Intangible Value: A Sixth Factor –{" "}
          <a
            href="https://www.sparklinecapital.com/post/intangible-value-a-sixth-factor"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.sparklinecapital.com/post/intangible-value-a-sixth-factor
          </a>
        </li>
        <li>
          [4] [5] Factor Investing: Evidence Based Insights –{" "}
          <a
            href="https://alphaarchitect.com/factor-investing-and-evidence-based-investing/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://alphaarchitect.com/factor-investing-and-evidence-based-investing/
          </a>
        </li>
        <li>
          [6] Equity Factor Report – Q3 2024 | Russell Investments –{" "}
          <a
            href="https://russellinvestments.com/content/ri/nn/en-gb/insights/russell-research/2024/10/equity-factor-report---q3-2024-value-and-low-volatility-strategi.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            link
          </a>
        </li>
        <li>
          [7] [8] Should Investors Combine or Separate Their Factor Exposures? –{" "}
          <a
            href="https://alphaarchitect.com/should-investors-combine-or-separate-their-factor-exposures/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://alphaarchitect.com/should-investors-combine-or-separate-their-factor-exposures/
          </a>
        </li>
        <li>
          [9] Do Currency-Hedged ETFs Have Merit for the Long Term? | Morningstar –{" "}
          <a
            href="https://www.morningstar.com/funds/do-currency-hedged-etfs-have-merit-long-term"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.morningstar.com/funds/do-currency-hedged-etfs-have-merit-long-term
          </a>
        </li>
        <li>
          [10] Andrew Ang – Slides (locale) –{" "}
          <a href="http://localhost:8451/file:///home/oai/share/51630_20151119_113426_ANDREW_SLIDESBOOK.pdf" target="_blank" rel="noopener noreferrer">
            localhost
          </a>
        </li>
        <li>
          [11] [12] [13] Factor Human Capital Risk into Your Financial Plans –{" "}
          <a
            href="https://cogentsw.com/financial-planning/factor-human-capital-risk-into-your-financial-plans/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://cogentsw.com/financial-planning/factor-human-capital-risk-into-your-financial-plans/
          </a>
        </li>
        <li>
          [14] [15] [16] J.P. MORGAN RESEARCH | Irrational Capital –{" "}
          <a href="https://www.irrational.capital/jp-morgan-research" target="_blank" rel="noopener noreferrer">
            https://www.irrational.capital/jp-morgan-research
          </a>
        </li>
      </ul>
    </div>
  ),
},


{
  slug: "alpha-e-beta-negli-investimenti-come-calcolarli",
  title: "Che cosa sono l’Alpha e il Beta negli investimenti (e come calcolarli)",
  metaDescription:
    "Alpha e Beta spiegati in modo rigoroso ma chiaro: definizioni, formule CAPM, come calcolarli e interpretarli con esempi pratici su ETF settoriali (Tech vs Utilities).",
  tags: ["educazione", "finanza", "etf", "risk management"],
  readTime: "12 min",
  author: "Redazione",
  datePublished: "2025-08-22",
  dateUpdated: "2025-08-22",
  coverImage: AlphaBetaCover,
  canonical: `${DOMAIN}/kb/alpha-e-beta-negli-investimenti-come-calcolarli`,
  content: (
    <div>
      <h1>Che cosa sono l’Alpha e il Beta negli investimenti (e come calcolarli)</h1>

      <p>
        Nel mondo degli investimenti si sente spesso parlare di <strong>Alpha</strong> e{" "}
        <strong>Beta</strong>, due indicatori fondamentali per valutare la performance e il rischio
        di portafogli, fondi ed ETF. Si tratta di concetti derivati dal modello finanziario di
        riferimento, il <em>Capital Asset Pricing Model</em> (CAPM), utilizzati sia da investitori
        retail sia da professionisti per capire come un investimento si comporta rispetto al
        mercato. In questo articolo, scritto in stile divulgativo ma con approfondimenti tecnici,
        vedremo cosa indicano esattamente Alpha e Beta, come si calcolano in termini quantitativi, e
        forniremo esempi pratici – utilizzando dati reali di ETF settoriali statunitensi – per
        illustrare il loro utilizzo. L’obiettivo è aiutare gli investitori (soprattutto chi investe
        in ETF passivi) a comprendere meglio questi concetti e a trarne indicazioni utili per le
        proprie scelte di investimento.
      </p>
        <YouTubeEmbed
          videoId="PgCskOHJYMw"
          title="Alfa e beta spiegati semplice"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />


      <h2>Alpha e Beta in sintesi: perché sono importanti?</h2>
      <p>
        Alpha e Beta sono due facce della stessa medaglia. In breve:
      </p>
      <ul>
        <li>
          <strong>Beta</strong> misura la volatilità e il rischio sistematico di un investimento
          rispetto al mercato di riferimento (es. l’indice S&amp;P 500). È un indicatore che ci dice
          quanto il titolo o il fondo “segua” i movimenti del mercato.
        </li>
        <li>
          <strong>Alpha</strong> misura la performance in eccesso di un investimento rispetto a
          quanto ci si aspetterebbe in base al suo Beta. Indica se il rendimento ottenuto è superiore
          (o inferiore) a quello “giustificato” dal rischio di mercato assunto.
        </li>
      </ul>
      <p>
        In altre parole, il Beta ci dice quanto un investimento è correlato al mercato e quanto è
        rischioso rispetto ad esso, mentre l’Alpha ci dice quanto un investimento rende in più (o in
        meno) rispetto al mercato, al netto del rischio assunto. Questi due indicatori sono cruciali
        per valutare fondi ed ETF: ad esempio, un fondo passivo che replica un indice avrà Beta
        vicino a 1 e Alpha circa zero (segue il mercato fedelmente), mentre un gestore attivo
        cercherà di ottenere Alpha positivo (battere il mercato) magari assumendo un certo Beta
        (esposizione al mercato).
      </p>

      <h2>Beta: cos’è e come funziona?</h2>
      <p>
        <strong>Beta</strong> ({String.raw`\beta`}) è un coefficiente che definisce la misura del rischio sistematico
        di un’attività finanziaria o di un portafoglio. Tecnicamente, il Beta di un investimento{" "}
        <IM>{String.raw`i`}</IM> rispetto a un indice di mercato <IM>{String.raw`m`}</IM> si calcola come:
      </p>
      <p>
        <BM>{String.raw`\beta_i \;=\; \dfrac{\operatorname{Cov}(R_i,\,R_m)}{\operatorname{Var}(R_m)}`}</BM>
      </p>
      <p>
        dove <IM>{String.raw`R_i`}</IM> sono i rendimenti dell’investimento <IM>{String.raw`i`}</IM> e{" "}
        <IM>{String.raw`R_m`}</IM> sono i rendimenti del mercato (indice benchmark). In parole semplici,{" "}
        <IM>{String.raw`\beta`}</IM> esprime quanto i movimenti del titolo seguono (o amplificano, o attenuano) i
        movimenti del mercato di riferimento. Il calcolo pratico del Beta richiede:
      </p>
      <ol>
        <li>
          <em>Dati storici dei rendimenti</em> – ad esempio, si raccolgono i rendimenti mensili di un titolo o ETF e
          quelli dell’indice di mercato corrispondente per un certo periodo (es. 3 anni).
        </li>
        <li>
          <em>Covarianza e varianza</em> – si calcola la covarianza tra i rendimenti del titolo e quelli del mercato,
          e la varianza dei rendimenti del mercato.
        </li>
        <li>
          <em>Rapporto covarianza/varianza</em> – dividendo la covarianza per la varianza del mercato si ottiene il
          valore di Beta. Questo è matematicamente equivalente alla pendenza (<em>slope</em>) di una retta di
          regressione lineare tra i rendimenti del titolo (variabile dipendente) e quelli del mercato (variabile
          indipendente).
        </li>
      </ol>

      <h3>Interpretazione del Beta</h3>
      <ul>
        <li>
          <IM>{String.raw`\beta = 1`}</IM>: l’investimento si muove in media in linea col mercato. Se il mercato fa
          +1%, anche il titolo ~+1%; se scende −1%, il titolo ~−1%. Un Beta pari a 1 indica dunque che la volatilità
          del titolo è simile a quella dell’indice di riferimento.
        </li>
        <li>
          <IM>{String.raw`\beta > 1`}</IM>: l’investimento è più volatile del mercato. Tende ad amplificare i
          movimenti (es. <IM>{String.raw`\beta = 1{,}2`}</IM>).
        </li>
        <li>
          <IM>{String.raw`0 < \beta < 1`}</IM>: l’investimento è meno volatile del mercato (movimenti nella stessa
          direzione ma attenuati).
        </li>
        <li>
          <IM>{String.raw`\beta \approx 0`}</IM>: l’investimento non mostra correlazione con il mercato (movimenti
          indipendenti).
        </li>
        <li>
          <IM>{String.raw`\beta < 0`}</IM>: l’investimento si muove in direzione opposta al mercato (correlazione
          negativa).
        </li>
      </ul>
      <p>
        Beta quindi misura il <em>rischio sistemico</em>: il rischio legato ai movimenti del mercato nel suo
        complesso, che non è eliminabile con la diversificazione. Per definizione, il mercato (benchmark) ha{" "}
        <IM>{String.raw`\beta = 1`}</IM>. Conoscere il Beta di un titolo o fondo aiuta a capire quanto quel prodotto
        è esposto alle oscillazioni del mercato.
      </p>
      <p>
        <em>Esempio concettuale</em>: immagina un fondo con{" "}
        <IM>{String.raw`\beta = 1{,}5`}</IM>. Se il mercato in un anno guadagna +10%, ci aspettiamo (in media) che il
        fondo guadagni circa +15% grazie al suo beta elevato. Se però rende solo +12% o, al contrario, +18%, la
        differenza rispetto al “previsto” è l’Alpha, che vediamo ora.
      </p>

      <h2>Alpha: cos’è e cosa indica?</h2>
      <p>
        <strong>Alpha</strong> ({String.raw`\alpha`}) rappresenta la capacità di un investimento di generare{" "}
        <em>rendimento aggiuntivo</em> indipendentemente dal mercato. In termini pratici, l’Alpha è quel rendimento
        extra (positivo o negativo) che un gestore o un titolo ottiene rispetto al suo indice di riferimento, dopo
        aver considerato il rischio di mercato (Beta).
      </p>
      <p>
        In un fondo gestito attivamente, l’Alpha misura il valore aggiunto (o distrutto) dal gestore: un{" "}
        <IM>{String.raw`\alpha > 0`}</IM> indica che il fondo ha “battuto il mercato”, un{" "}
        <IM>{String.raw`\alpha < 0`}</IM> indica sottoperformance. Per strumenti passivi (ETF indicizzati) ci si
        attende <IM>{String.raw`\alpha \approx 0`}</IM>.
      </p>
      <p>
        Dal punto di vista metodologico, l’Alpha è l’intercetta in una regressione lineare tra i rendimenti
        dell’investimento e quelli del mercato. Riprendendo il CAPM, la relazione base (in eccesso rispetto al tasso
        privo di rischio) è:
      </p>
      <p>
        <BM>{String.raw`R_{i} - R_{f} \;=\; \alpha \;+\; \beta\,\big(R_{m} - R_{f}\big) \;+\; \varepsilon`}</BM>
      </p>
      <p>
        Riarrangiando, si ottiene l’<em>Alpha di Jensen</em> per un portafoglio{" "}
        <IM>{String.raw`p`}</IM>:
      </p>
      <p>
        <BM>{String.raw`\alpha_{p} \;=\; (R_{p} - R_{f}) \;-\; \beta_{p}\,\big(R_{m} - R_{f}\big)`}</BM>
      </p>

      <h3>Interpretazione dell’Alpha</h3>
      <ul>
        <li>
          <IM>{String.raw`\alpha = 0`}</IM>: rendimento pari a quello atteso dato il Beta (nessuna sovra/sotto-performance).
        </li>
        <li>
          <IM>{String.raw`\alpha > 0`}</IM>: rendimento superiore a quello previsto dal CAPM (valore aggiunto indipendente dal mercato).
        </li>
        <li>
          <IM>{String.raw`\alpha < 0`}</IM>: rendimento inferiore al “dovuto” per il rischio assunto (sottoperformance).
        </li>
      </ul>
      <p>
        Insieme a Beta, l’Alpha è tra i principali indicatori per valutare la performance aggiustata per il rischio
        (assieme a deviazione standard, Sharpe, R², Sortino/Information, ecc.).
      </p>

      <h2>Gestione passiva vs attiva: il ruolo di Alpha e Beta</h2>
      <p>
        Negli investimenti <strong>passivi</strong> in ETF, il concetto centrale è il{" "}
        <em>Beta di mercato</em>: comprando un ETF indicizzato si acquista Beta, ossia la performance del mercato
        sottostante (meno costi). L’Alpha atteso è vicino a zero. Nella <strong>gestione attiva</strong>, l’obiettivo
        è generare Alpha positivo tramite selezione titoli, sovra/sottopesi settoriali, market timing. Tuttavia,
        battere il mercato in modo consistente è difficile; su orizzonti lunghi solo una minoranza di fondi attivi
        produce Alpha positivo persistente dopo i costi.
      </p>

      <h2>Esempi pratici: calcolo di Alpha e Beta per ETF settoriali</h2>
      <p>
        Consideriamo due ETF settoriali USA: <em>Tecnologia</em> (es. XLK) e{" "}
        <em>Utility</em> (es. XLU), con benchmark generale l’S&amp;P 500. I settori hanno profili di
        rischio/rendimento molto diversi: tech più volatile e con rendimenti elevati nell’ultimo decennio, utilities
        più difensive.
      </p>

      <h3>Figura (concettuale)</h3>
      <figure>
        <a href={AlphaBetaPlot} target="_blank" rel="noopener noreferrer">
          <img
            src={AlphaBetaPlot}
            alt="Scatterplot dei rendimenti (portafoglio vs mercato) con linea di regressione: pendenza = Beta, intercetta = Alpha."
            loading="lazy"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </a>
        <figcaption>
          Scatterplot dei rendimenti di un portafoglio contro il mercato con la retta di regressione CAPM. La pendenza
          della retta rappresenta il <strong>Beta</strong> e l’intercetta rappresenta l’<strong>Alpha</strong>.
        </figcaption>
      </figure>

      <h3>Beta del settore Tecnologia vs S&amp;P 500</h3>
      <p>
        L’ETF del settore Tecnologia (ticker: XLK) negli ultimi anni ha mostrato una volatilità ben superiore al
        mercato. Calcolando il Beta su base storica (ad esempio usando rendimenti mensili degli ultimi 5-10 anni), si
        trova che il Beta di XLK rispetto all’S&amp;P 500 è leggermente sopra 1, indicando sensibilità amplificata.
        In effetti, la deviazione standard dei rendimenti di XLK risulta circa il 27% annuo, a fronte di ~19% per
        l’S&amp;P 500[1], e con un’alta correlazione con il mercato (data la natura azionaria, la correlazione a 1 non
        è lontana). Questo porta il Beta del settore Tech ad essere intorno a 1,1 – 1,2 (circa un 10-20% più volatile
        del mercato). Un Beta maggiore di 1 era prevedibile: le società tecnologiche tendono ad essere più soggette a cicli
        economici e oscillazioni (si pensi alle discese durante lo scoppio della bolla dot-com o alle rapide salite
        negli anni recenti), quindi hanno un rischio sistematico maggiore.
        Per un calcolo concreto, utilizziamo un orizzonte di 10 anni. Tra il 2015 e il 2025, l’ETF XLK ha registrato
        un rendimento medio annuo composto di circa +23,3%, a fronte di ~+15,3% annuo per l’S&amp;P 500[2]. Supponendo
        un tasso privo di rischio medio trascurabile in quegli anni (era molto basso, intorno al 0-2%), possiamo
        stimare il Beta e l’Alpha:
        <ul>
          <li>
            <strong>Beta (XLK) –</strong> Supponiamo β = 1,2 sui 10 anni (valore coerente con la maggiore
            volatilità osservata del 27% vs 19% e alta correlazione).
          </li>
          <li>
            <strong>Rendimento atteso secondo CAPM –</strong> Data β=1,2, se il mercato ha reso +15,3%, il
            rendimento “atteso” per XLK sarebbe: R_f+1,2×(15,3%-R_f). Anche assumendo R_f≈0%, ciò dà un
            atteso ≈ 18,4%.
          </li>
          <li>
            <strong>Rendimento effettivo di XLK –</strong> ~23,3% annuo.
          </li>
        </ul>
        Alpha (XLK) = rendimento effettivo – rendimento atteso = +23,3% - 18,4% ≈ +4,9% annuo. Questo Alpha
        positivo indica che il settore tecnologico ha sovraperformato le aspettative in base al suo rischio. Anche
        considerando un po’ di rischio-free, il risultato non cambia di molto (con R_f maggiore di 0% l’alpha calcolato
        sarebbe leggermente inferiore ma sempre fortemente positivo). In altre parole, l’ETF tech ha ottenuto un
        extra-rendimento significativo oltre quanto spiegabile dal semplice “essere più volatile”: c’è stato un
        guadagno aggiuntivo, dovuto alla crescita straordinaria dei titoli tecnologici in quel periodo.
      </p>

      <h3>Beta del settore Utility vs S&amp;P 500</h3>
      <p>
        Passiamo ora all’ETF del settore Utility (ticker: XLU), che include aziende di elettricità, gas, acqua, ecc.
        Le utilities sono considerate difensive: domanda relativamente stabile, alti dividendi, minore sensibilità ai
        cicli economici. Ci aspettiamo quindi un Beta inferiore a 1. Infatti, storicamente il Beta di XLU si aggira
        intorno a 0,7 rispetto all’S&amp;P 500[3]. Questo significa che se il mercato sale o scende del 10%, il
        settore utility in media sale/scende di circa il 7%. I dati confermano una volatilità minore: ad esempio,
        la deviazione standard giornaliera di XLU è intorno al 16-17%, significativamente sotto quella dell’S&amp;P
        500 (~19%)[4], e con correlazione moderata.
        Guardando di nuovo ai 10 anni 2015-2025, XLU ha ottenuto un rendimento medio annuo composto di circa +10,9%,
        a fronte del +15,3% dell’S&amp;P 500[5][6]. Stimiamo:
        <ul>
          <li>
            <strong>Beta (XLU) –</strong> circa β = 0,7 (come da storia osservata).
          </li>
          <li>
            <strong>Rendimento atteso secondo CAPM –</strong> Con β=0,7 e mercato +15,3% (ponendo rischio-free
            trascurabile come prima), il CAPM ci darebbe un rendimento atteso ≈ 0%+0,7×15,3%=10,7% annuo circa.
            (Se considerassimo R_f ad esempio 2%, sarebbe 2%+0,7×(15,3%-2%)=2%+0,7×13,3%=11,3%. L’idea non cambia
            di molto.)
          </li>
          <li>
            <strong>Rendimento effettivo di XLU –</strong> ~10,9% annuo.
          </li>
        </ul>
        Alpha (XLU) ≈ 10,9% - 10,7% = +0,2% annuo (praticamente ~0%). Con un R_f del 2% nell’esempio, avremmo 10,9%
        - 11,3% = -0,4%, ossia un piccolo alpha leggermente negativo. Possiamo concludere che il settore utility ha
        reso grosso modo quanto ci si aspetta dal suo Beta – leggermente sotto le attese se includiamo un tasso privo
        di rischio, ma in linea entro un margine ridotto. Questo ha senso: le utility avevano un rischio minore e
        infatti hanno ottenuto rendimenti più bassi del mercato, come previsto. Non c’è stata una significativa
        sovra- o sotto-performance indipendente dal mercato, il che si riflette in un Alpha intorno allo zero
        (lievemente negativo considerando i dividendi elevati e altre caratteristiche che però il CAPM base potrebbe
        non cogliere). In sintesi, il settore utility non ha “battuto” il mercato né deluso oltre quanto imputabile al
        minor rischio: ha fornito il rendimento atteso per un investimento difensivo.
      </p>

      <h3>Confronto e considerazioni</h3>
      <p>
        Dall’esempio risulta chiaro come Beta e Alpha insieme dipingono un quadro completo: XLK (Tech) aveva Beta &gt; 1
        e ha prodotto un Alpha consistente positivo (ha sovraperformato oltre il rischio di mercato), mentre XLU
        (Utility) aveva Beta &lt; 1 e ha prodotto Alpha ~0 o leggermente negativo (ha reso meno del mercato, ma
        proporzionatamente al minor rischio assunto). Per un investitore in ETF passivi, questi indicatori aiutano a
        comprendere la natura del proprio portafoglio: se si possiedono molti settori “aggressivi” con Beta alti, ci
        si può aspettare maggior volatilità e potenzialmente extra-rendimento in bull market (ma rischio di
        sottoperformance in bear market); settori difensivi daranno stabilità (Beta bassi) ma difficilmente batteranno
        il mercato in rally prolungati. È importante notare che l’Alpha, essendo una misura storica, non è garantito
        nel futuro: il fatto che il tech abbia avuto ~5% annuo di Alpha negli ultimi 10 anni non significa che lo
        manterrà nei prossimi 10 (potrebbe ridursi se il settore rallenta o se altri settori recuperano). Allo stesso
        modo, un Alpha negativo passato non condanna un settore per sempre – ma spesso riflette dinamiche strutturali
        (es. difficoltà di battere il mercato per fondi gestiti attivamente, o settori maturi che crescono meno
        della media). Infine, ricordiamo che Alpha e Beta sono calcolati rispetto a un certo benchmark: è fondamentale
        scegliere il benchmark giusto. Nel nostro esempio abbiamo usato l’S&amp;P 500 come riferimento per entrambi
        gli ETF settoriali; ciò va bene per un confronto generale, ma talvolta per valutare davvero la bravura di un
        gestore conviene usare un benchmark più mirato. Ad esempio, un fondo settore Tecnologia andrebbe confrontato a
        un indice tech (il suo Alpha misurato vs S&amp;P 500 include anche l’effetto di settore); tuttavia dal punto di
        vista di un asset allocator, confrontare al broad market è utile per capire come il settore contribuisce alla
        performance complessiva del portafoglio. L’importante è coerenza: Beta e Alpha hanno senso solo in relazione
        allo stesso indice di riferimento.
      </p>

      <h2>Conclusione</h2>
      <p>
        Alpha e Beta sono due parametri chiave in finanza: il Beta quantifica l’esposizione al rischio di mercato di un
        investimento, mentre l’Alpha ne misura la capacità di generare extra-rendimento rispetto al mercato stesso. Per
        gli investitori in ETF passivi, Beta e Alpha aiutano a capire come combinare vari prodotti per costruire il
        profilo rischio/rendimento desiderato – sapendo che la maggior parte del rendimento deriverà dal Beta di
        mercato, mentre generare Alpha consistente è difficile e raro. Una conoscenza approfondita di questi concetti
        consente di valutare meglio le performance dei propri investimenti: ad esempio, distinguere se un fondo sta
        battendo il mercato grazie al Beta (magari perché è più rischioso) o grazie ad un vero Alpha (abilità
        gestionale, selezione titoli, ecc.). In un settore dove spesso si cercano “strategie attive miracolose”, Alpha
        e Beta riportano l’attenzione sui fondamentali: quanto del risultato è spiegabile dai movimenti di mercato? E
        quanto è frutto di vero valore aggiunto? La stragrande maggioranza dei rendimenti può essere ricondotta al Beta
        (ossia a fattori di mercato); l’Alpha genuino è raro e prezioso – ed è il motivo per cui si chiama “alpha”, la
        prima lettera dell’alfabeto greco, quasi a indicare qualcosa di speciale. Non a caso si parla di “caccia
        all’Alpha” nel gergo finanziario. Ma come investitori, bisogna essere consapevoli che questa caccia comporta
        costi e rischi, e che spesso una buona strategia è assicurarsi il Beta di mercato in modo efficiente (ad
        esempio con ETF a basso costo) e non inseguire a tutti i costi un Alpha sfuggente.
      </p>
      <p>
        In conclusione, Alpha e Beta sono strumenti concettuali che ci aiutano a navigare le acque dei mercati
        finanziari: conoscerli e saperli calcolare ci dà un vantaggio nel comprendere perché i nostri investimenti
        stanno andando bene o male, e nel prendere decisioni informate per il futuro. Sia che tu scelga la semplicità
        di un portafoglio passivo o che ti avventuri in strategie attive alla ricerca di Alpha, tenere d’occhio questi
        indicatori ti aiuterà a rimanere ancorato ai fondamentali rischio-rendimento.
      </p>

      <h3>Fonti utili</h3>
      <ul>
        <li>
          Investopedia — <em>Alpha and Beta for Beginners</em>
        </li>
        <li>
          Moneyfarm — <em>Beta e Alfa: Significato in Finanza e Investimenti</em>
        </li>
        <li>
          Corporate Finance Institute — <em>Alpha – How to Calculate and Use Alpha</em>
        </li>
        <li>
          PortfoliosLab — <em>ETF Comparison Tool</em> (dati storici XLK, XLU vs SPY):{" "}
          <a
            href="https://portfolioslab.com/tools/stock-comparison/XLK/SPY"
            target="_blank"
            rel="noopener noreferrer"
          >
            XLK vs SPY
          </a>{" "}
          •{" "}
          <a
            href="https://portfolioslab.com/tools/stock-comparison/XLU/SPY"
            target="_blank"
            rel="noopener noreferrer"
          >
            XLU vs SPY
          </a>
        </li>
        <li>
          Institute of Business &amp; Finance —{" "}
          <em>S&amp;P 500 Sectors: Beta, Correlation, R² &amp; Weightings</em>:{" "}
          <a
            href="https://icfs.com/financial-knowledge-center/sp-500-sectors-beta-correlation-r2-weightings"
            target="_blank"
            rel="noopener noreferrer"
          >
            icfs.com
          </a>
        </li>
      </ul>
    </div>
  ),
},


{
  slug: "guida-completa-esame-ocf-consulenti-finanziari",
  title: "Guida completa al test OCF per consulenti finanziari",
  metaDescription:
    "Cos’è il test OCF, come funziona, materie, costi, calendari e statistiche di successo. Strategia di studio, risorse utili e playlist YouTube per prepararsi in modo efficace.",
  tags: ["ocf", "esame", "consulenti finanziari", "guida", "formazione"],
  readTime: "12 min",
  author: "Redazione",
  datePublished: "2025-11-15",
  dateUpdated: "2025-11-15",
  coverImage: ocfcover,
  canonical: `${DOMAIN}/it/kb/guida-completa-esame-ocf-consulenti-finanziari`,
  content: (
    <div>
      <h1>Guida completa al test OCF per consulenti finanziari</h1>

      <h2>Introduzione</h2>
      <p>
        In Italia la professione di consulente finanziario è regolamentata da una legge specifica:
        per poter iscriversi all’albo unico dei consulenti finanziari occorre dimostrare di possedere
        requisiti di onorabilità e di professionalità. Il requisito di professionalità è accertato
        tramite la prova valutativa OCF, un esame gestito dall’Organismo di vigilanza e tenuta
        dell’albo unico dei consulenti finanziari (OCF). Tale obbligo deriva dal Testo Unico della
        Finanza (TUF), che all’art. 31, comma 5, prevede che gli aspiranti consulenti debbano sostenere
        un test per dimostrare la propria competenza<span aria-hidden="true">[1]</span>. L’OCF gestisce
        digitalmente ogni fase del processo: dalla prenotazione, alla somministrazione del test fino alla
        comunicazione degli esiti<span aria-hidden="true">[2]</span>.
      </p>

      <p>
        Questa guida risponde a diverse domande frequenti sul test: che cos’è, quali sono le materie
        oggetto d’esame, quanto costa, come sono andate le ultime sessioni (percentuale di promossi,
        punteggi medi e trend temporali) e come ci si può preparare efficacemente. Il tutto con
        l’obiettivo di fornire informazioni chiare e, al contempo, presentare il podcast gratuito che ho
        realizzato su YouTube per aiutare nella preparazione.
      </p>

      <h2>Struttura della prova valutativa</h2>

      <h3>Modalità di svolgimento</h3>
      <p>
        Dal 2020 la prova valutativa OCF si svolge a distanza, grazie all’esperienza maturata durante la
        pandemia e alle esigenze di economicità<span aria-hidden="true">[3]</span>. Il candidato sostiene
        l’esame su un computer dotato di webcam e microfono, mentre un dispositivo mobile aggiuntivo
        (tablet o smartphone) inquadra l’ambiente per tutta la durata della prova; l’OCF verifica in tempo
        reale l’identità e il comportamento del candidato.
      </p>

      <p>
        L’esame è un quiz teorico-pratico composto da <strong>60 quesiti a risposta multipla</strong>
        estratti in modo random da un database di circa <strong>5 000 domande</strong>
        <span aria-hidden="true">[4]</span>. Il questionario è diviso in:
      </p>
      <ul>
        <li>40 domande da 2 punti, fra cui 12 quesiti pratici;</li>
        <li>20 domande da 1 punto.</li>
      </ul>
      <p>
        Il tempo a disposizione è <strong>85 minuti</strong><span aria-hidden="true">[5]</span>. Ciascun
        quesito offre quattro opzioni di risposta; per superare la prova occorre totalizzare almeno
        <strong> 80/100</strong><span aria-hidden="true">[6]</span>. Al termine dell’esame la piattaforma
        trasmette i risultati alla commissione esaminatrice e l’esito viene pubblicato nell’area riservata
        del candidato<span aria-hidden="true">[7]</span>.
      </p>

      <h3>Materie d’esame e distribuzione dei quesiti</h3>
      <p>
        L’OCF definisce una tassonomia pubblica delle materie oggetto della prova. Ogni materia racchiude
        argomenti e riferimenti normativi; il database delle domande viene aggiornato annualmente da un
        comitato scientifico composto da professori universitari e consulenti finanziari
        <span aria-hidden="true">[8]</span>. Il <em>bando 2025</em> elenca le materie e la ripartizione dei
        quesiti<span aria-hidden="true">[9]</span>, riassunte nella tabella seguente.
      </p>

      <div style={{ overflowX: "auto" }}>
        <table className="kb-table">
          <thead>
            <tr>
              <th>Materia</th>
              <th>Argomenti principali (parole chiave)</th>
              <th>N. quesiti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Matematica finanziaria, mercati e strumenti; pianificazione; finanza comportamentale;
                investimenti ESG<span aria-hidden="true">[10]</span>
              </td>
              <td>
                analisi di scenario, costruzione del portafoglio, fondi comuni, futures e opzioni, derivati,
                strumenti di mercato monetario, titoli azionari/obbligazionari/strutturati, swap, valutazione
                delle obbligazioni<span aria-hidden="true">[10]</span>
              </td>
              <td>19<span aria-hidden="true">[11]</span></td>
            </tr>
            <tr>
              <td>
                Diritto del mercato finanziario e degli intermediari; disciplina dei consulenti finanziari
                <span aria-hidden="true">[12]</span>
              </td>
              <td>
                abusi di mercato, appello al pubblico risparmio, disciplina dell’albo, gestione collettiva del
                risparmio, normativa antiriciclaggio, mercati degli strumenti finanziari, servizi di
                investimento, promozione fuori sede, trasparenza nei contratti, vigilanza su mercati e
                intermediari<span aria-hidden="true">[13]</span>
              </td>
              <td>24<span aria-hidden="true">[14]</span></td>
            </tr>
            <tr>
              <td>Nozioni di diritto privato e commerciale<span aria-hidden="true">[15]</span></td>
              <td>
                contratti, beni e diritti reali, obbligazioni, società di persone e di capitali, scritture
                contabili, bilancio, titoli di credito e operazioni straordinarie
                <span aria-hidden="true">[15]</span>
              </td>
              <td>5<span aria-hidden="true">[16]</span></td>
            </tr>
            <tr>
              <td>Nozioni di diritto tributario sul mercato finanziario<span aria-hidden="true">[17]</span></td>
              <td>
                sistema tributario, tassazione degli strumenti del risparmio gestito, tassazione degli
                investimenti diretti, imposte indirette sui redditi finanziari
                <span aria-hidden="true">[17]</span>
              </td>
              <td>6<span aria-hidden="true">[18]</span></td>
            </tr>
            <tr>
              <td>Nozioni di diritto previdenziale e assicurativo<span aria-hidden="true">[19]</span></td>
              <td>
                previdenza pubblica e complementare, TFR, principi assicurativi, contratti di assicurazione,
                intermediari e vigilanza assicurativa, aspetti civilistici, tributari e attuariali
                <span aria-hidden="true">[19]</span>
              </td>
              <td>6<span aria-hidden="true">[20]</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        Le prime due materie coprono circa il <strong>72%</strong> del punteggio totale, perciò vanno
        affrontate con particolare attenzione. Il bando prevede anche una versione semplificata della
        prova, con 54 quesiti, dedicata ai candidati già iscritti nella sezione A del Registro Unico
        degli Intermediari Assicurativi e Riassicurativi (RUI)<span aria-hidden="true">[21]</span>.
      </p>

      <h2>Requisiti di accesso, costi e frequenza</h2>
      <p>
        Per sostenere la prova valutativa è richiesto un diploma di scuola superiore (quinquennale); non è
        obbligatoria la laurea. Ogni anno sono previste cinque sessioni, con appelli mensili da febbraio a
        dicembre (generalmente non si tengono prove in gennaio e agosto). L’OCF pubblica sul proprio sito
        il calendario e gli appelli disponibili. La domanda di partecipazione si inoltra esclusivamente
        online attraverso l’area riservata del portale OCF; è possibile prenotare solo un appello per
        volta e, qualora non si partecipi, occorre presentare una nuova domanda
        <span aria-hidden="true">[22]</span>.
      </p>

      <h3>Contributo per l’esame</h3>
      <p>
        Il bando stabilisce che la partecipazione alla prova è subordinata al pagamento di un contributo
        prova valutativa; l’ammontare è definito annualmente dal Comitato direttivo dell’OCF. Per il 2025
        il sito dell’associazione professionale ANASF (che collabora con l’OCF) conferma che per iscriversi
        all’esame sono necessari: un indirizzo di posta elettronica ordinario e il pagamento di un
        contributo di <strong>200 euro</strong><span aria-hidden="true">[23]</span>. La prova dura 85 minuti
        ed è composta da 60 domande<span aria-hidden="true">[24]</span>. Il pagamento non è rimborsabile in
        caso di rinuncia o assenza<span aria-hidden="true">[25]</span>, ma è dovuto nuovamente per ogni
        successivo appello in cui si desideri partecipare<span aria-hidden="true">[25]</span>.
      </p>

      <h2>Dopo l’esame</h2>
      <p>Superato l’esame, il candidato potrà scegliere in quale sezione dell’albo iscriversi:</p>
      <ul>
        <li>
          <strong>Consulenti finanziari abilitati all’offerta fuori sede</strong> (ex promotori finanziari),
          che operano con mandato di una banca o di una rete;
        </li>
        <li>
          <strong>Consulenti finanziari autonomi</strong>, professionisti indipendenti che non percepiscono
          retrocessioni da banche o società prodotto;
        </li>
        <li>
          <strong>Società di consulenza finanziaria</strong>*, società iscritte all’albo che offrono servizi
          di consulenza.
        </li>
      </ul>
      <p>
        L’iscrizione all’albo comporta il pagamento di un contributo annuale. Secondo le linee guida
        pubblicate a fine 2024, la quota base per i consulenti finanziari autonomi ammonta a{" "}
        <strong>515 €</strong>, mentre per i consulenti abilitati all’offerta fuori sede è più contenuta; la
        quota ridotta per i nuovi iscritti (se si presenta la domanda entro un anno dal superamento
        dell’esame) è di <strong> 350 €</strong> – importi che possono variare annualmente e vanno verificati
        sul sito dell’OCF.
      </p>

      <h2>Statistiche e trend: quanto è difficile il test OCF?</h2>
      <p>
        L’OCF pubblica ogni anno, nella propria Relazione annuale, i risultati delle prove svolte. Il
        portale EsameOCF – che riporta i dati ufficiali – ha riassunto le statistiche delle ultime
        sessioni. Di seguito sono riportati i principali indicatori utili per capire la difficoltà
        dell’esame.
      </p>

      <h3>Anno 2024</h3>
      <ul>
        <li>
          <strong>Numero di partecipanti</strong> – 6 047 candidati hanno sostenuto l’esame a fronte di
          6 670 domande di iscrizione (6 644 confermate)<span aria-hidden="true">[26]</span>; la percentuale
          di partecipazione effettiva è salita al <strong>91%</strong><span aria-hidden="true">[27]</span>.
        </li>
        <li>
          <strong>Tasso di successo</strong> – sono risultati idonei 2 648 candidati, pari a circa
          <strong> 44%</strong> dei partecipanti<span aria-hidden="true">[28]</span>.
        </li>
        <li>
          <strong>Voto medio</strong> – il punteggio medio complessivo dei partecipanti è stato 74,9/100,
          mentre i candidati idonei hanno conseguito in media 88,1/100<span aria-hidden="true">[29]</span>.
        </li>
        <li>
          <strong>Materia più ostica</strong> – l’analisi delle risposte errate mostra che le domande più
          difficili riguardano “Nozioni di matematica finanziaria e di economia del mercato finanziario;
          pianificazione finanziaria e finanza comportamentale”<span aria-hidden="true">[30]</span>; le
          percentuali di errore oscillano tra il <strong>22%</strong> e il <strong>26%</strong>
          <span aria-hidden="true">[31]</span>.
        </li>
        <li>
          <strong>Profilo dei candidati</strong> – l’età media è di circa 34 anni
          <span aria-hidden="true">[32]</span>; oltre il <strong>63%</strong> dei candidati possiede una
          laurea o diploma di laurea<span aria-hidden="true">[33]</span>. Il <strong>49%</strong> dei laureati
          risulta idoneo, contro il <strong>34,5%</strong> dei diplomati
          <span aria-hidden="true">[34]</span>, evidenziando l’elevata selettività.
        </li>
      </ul>

      <h3>Anno 2023</h3>
      <ul>
        <li>
          <strong>Partecipanti</strong> – 5 234 candidati hanno sostenuto la prova (su 5 912 iscrizioni),
          con un’affluenza effettiva dell’<strong>89,1%</strong><span aria-hidden="true">[35]</span>.
        </li>
        <li>
          <strong>Tasso di successo</strong> – sono stati dichiarati idonei 2 216 candidati, pari al
          <strong> 42,3%</strong><span aria-hidden="true">[36]</span>.
        </li>
        <li>
          <strong>Voto medio</strong> – i partecipanti hanno ottenuto in media 74/100; gli idonei hanno
          ottenuto 87,9/100<span aria-hidden="true">[37]</span>.
        </li>
        <li>
          <strong>Trend delle risposte errate</strong> – le domande con maggior tasso di errore appartengono
          ancora alla materia di matematica finanziaria e pianificazione
          <span aria-hidden="true">[38]</span>; le risposte errate oscillano fra il <strong>23%</strong> e il
          <strong>27%</strong><span aria-hidden="true">[39]</span>.
        </li>
        <li>
          <strong>Differenze per titolo di studio</strong> – il <strong>46,9%</strong> dei laureati ha
          superato l’esame, mentre fra i diplomati la percentuale scende al <strong>34,9%</strong>
          <span aria-hidden="true">[40]</span>.
        </li>
      </ul>

      <h3>Anni precedenti e trend complessivo</h3>
      <ul>
        <li>
          <strong>2022</strong> – su 7 444 iscritti hanno effettivamente sostenuto l’esame 6 011 candidati;
          i promossi sono stati 2 509, pari al <strong>41,7%</strong><span aria-hidden="true">[41]</span>.
        </li>
        <li>
          <strong>2021</strong> – 6 729 partecipanti, con 4 046 idonei, cioè <strong>60,1%</strong>
          <span aria-hidden="true">[41]</span>.
        </li>
        <li>
          <strong>2020</strong> – il tasso di successo ha raggiunto il <strong>64,1%</strong>
          <span aria-hidden="true">[41]</span>, probabilmente agevolato dal passaggio alla modalità a distanza
          e dal minor numero di candidati.
        </li>
        <li>
          <strong>2019</strong> – la percentuale di idonei era del <strong>41%</strong>
          <span aria-hidden="true">[41]</span>.
        </li>
      </ul>
      <p>
        L’analisi mostra dunque un trend altalenante: negli anni pre-pandemia il tasso di successo era
        intorno al 40%; nel 2020 è balzato al 64,1% per poi scendere al 41,7% nel 2022 e risalire al 44%
        nel 2024. Anche il punteggio medio dei promossi è rimasto alto (circa 88 punti), segno che chi
        supera la prova ottiene quasi sempre un ottimo risultato.
      </p>

      <h2>Materie più ostiche: perché la matematica finanziaria spaventa?</h2>
      <p>
        Le statistiche evidenziano come la materia “Matematica finanziaria, mercati e strumenti;
        pianificazione finanziaria e finanza comportamentale” sia la più impegnativa: nel 2024 la
        percentuale di risposte errate su queste domande oscillava tra il 22% e il 26%
        <span aria-hidden="true">[30]</span>, valori più elevati rispetto alle altre materie. Nel 2023 la
        situazione era simile, con errori tra il 23% e il 27%<span aria-hidden="true">[39]</span>.
      </p>
      <p><strong>Le ragioni sono intuibili:</strong></p>
      <ul>
        <li>
          <strong>Ampiezza degli argomenti</strong> – la materia combina nozioni di matematica finanziaria
          (interesse composto, sconti, valutazione dei titoli), teoria dei mercati e strumenti, portfolio
          management, finanza comportamentale e, da poco, gli investimenti ESG
          <span aria-hidden="true">[10]</span>. Coprire un ambito così vasto richiede studio approfondito e
          capacità di collegare concetti teorici a casi pratici.
        </li>
        <li>
          <strong>Domande pratiche</strong> – 12 dei 40 quesiti da 2 punti sono esercizi pratici
          <span aria-hidden="true">[5]</span>. Spesso richiedono calcoli rapidi (ad esempio, determinare il
          rendimento di un’obbligazione, il valore di un derivato o la composizione ottimale di un
          portafoglio) e la conoscenza di formule specifiche.
        </li>
        <li>
          <strong>Misurare il tempo</strong> – 85 minuti per 60 domande equivalgono a poco più di 1 minuto a
          domanda. Le domande di matematica, essendo più laboriose, possono mettere in difficoltà chi non è
          abituato a eseguire calcoli sotto pressione.
        </li>
      </ul>

      <h2>Strategie di preparazione: come massimizzare le possibilità di successo</h2>
      <p>
        La prova valutativa OCF può sembrare impegnativa, ma con il giusto metodo è possibile superarla in
        tempi relativamente brevi. Di seguito alcune strategie basate sulle mie esperienze e sui
        suggerimenti di formatori professionisti:
      </p>

      <h3>1. Studiare la tassonomia e le fonti normative</h3>
      <p>
        Il bando pubblica una tassonomia dettagliata delle materie<span aria-hidden="true">[9]</span>.
        Prima di immergersi nei quiz, è utile consultarla per avere un quadro generale degli argomenti. Per
        ogni tema individuare le fonti normative (leggi, decreti ministeriali, regolamenti Consob) e gli
        articoli più frequentemente citati. Durante lo studio, fate riferimento alle date di aggiornamento
        previste dal bando: ad esempio, per le sessioni I–III del 2025 gli argomenti di diritto fanno
        riferimento alla normativa in vigore al <strong>31 agosto 2024</strong>
        <span aria-hidden="true">[42]</span>.
      </p>

      <h3>2. Utilizzare il database ufficiale dei quiz</h3>
      <p>
        L’OCF mette a disposizione nell’area riservata un database di 5 000 domande
        <span aria-hidden="true">[4]</span>. Dopo aver studiato la teoria, allenatevi rispondendo ai quiz:
        le domande dell’esame vengono estratte proprio da questo archivio. Non limitatevi a leggere la
        risposta esatta; analizzate perché le alternative sono errate. Questo esercizio aiuta a fissare i
        concetti e a riconoscere domande simili con formulazioni diverse.
      </p>

      <h3>3. Pianificare il tempo e simulare l’esame</h3>
      <p>
        Eseguire simulazioni complete da 60 domande in 85 minuti è fondamentale per abituarsi al ritmo
        dell’esame. Cronometratevi e cercate di rispondere in meno di un minuto a quesito; se una domanda è
        troppo lunga, segnatevela e tornateci alla fine. Nei quesiti pratici, scrivete su un foglio le
        formule più usate (interesse composto, rendimenti, duration) e allenatevi con la calcolatrice
        consentita.
      </p>

      <h3>4. Dare priorità alle materie a maggior peso</h3>
      <p>
        Le prime due materie valgono <strong>43 dei 60 quesiti totali</strong>
        <span aria-hidden="true">[43]</span>. Dedicate ad esse la maggior parte del tempo di studio. Per la
        matematica finanziaria è utile esercitarsi con esercizi di scelta multipla su tassi, valore
        attuale, price/yield di obbligazioni e opzioni. Per il diritto del mercato finanziario concentrarsi
        su definizioni (consulente finanziario, promotore, intermediari, servizi di investimento), normative
        antiriciclaggio e responsabilità verso la clientela. Una buona padronanza di questi temi consente di
        ottenere un punteggio elevato anche se le domande di altre materie risultano difficili.
      </p>

      <h3>5. Affidarsi a risorse di qualità e al supporto di chi ha superato l’esame</h3>
      <p>
        Accanto ai materiali ufficiali esistono numerosi manuali, corsi online e podcast dedicati. Nel mio
        podcast gratuito su YouTube (
        <a
          href="/it/ocf"
          target="_blank"
          rel="noopener noreferrer"
        >
          playlist
        </a>
        ) condivido la mia esperienza: dopo due mesi di preparazione intensa ho superato l’esame e ho
        raccolto gli argomenti più ostici in episodi di 20–30 minuti. Ogni puntata affronta una materia
        (dalla matematica finanziaria alla disciplina degli intermediari, dalla fiscalità alla previdenza)
        e propone esempi di domande commentate.
        <br />
        <br />
        <strong>Video metodologia (extra, coerente con questa guida):</strong>{" "}
        <a href="https://youtu.be/HotLuRo9h_s" target="_blank" rel="noopener noreferrer">
          https://youtu.be/HotLuRo9h_s
        </a>{" "}
        — qui spiego passo-passo il metodo pratico che uso per arrivare rapidamente a stabilità nei quiz
        (routine, gestione errori, priorità per punteggio e simulazioni d’esame).
        <br />
        <br />
        Se preferite un approccio più strutturato, potete abbinare il podcast a manuali e corsi a pagamento
        per consolidare la preparazione.
      </p>

      <YouTubeEmbed
        playlistId="PL4Ivcohv28tLVwVkyMoHpeoH2815yOBBZ"
        title="Playlist Esame OCF — AlphaFrame"
        onPlay={(id) => trackVideoPlay(id, "article")}
      />

      <h3>Episodi del podcast disponibili</h3>
      <div
        style={{
          background: "#f8fafc",
          border: "1px solid #fcd34d",
          borderLeft: "4px solid #c9a24b",
          borderRadius: "10px",
          padding: "0.9rem 1.1rem",
          margin: "0 0 1rem",
        }}
      >
        <strong>Tutti gli episodi sono ora organizzati per materia nell’Hub Esame OCF.</strong>{" "}
        <a href="/it/ocf">Vai all’Hub Esame OCF →</a>: indice completo per materia, con pagine
        dedicate ai singoli episodi e player integrato.
      </div>
      <p>
        Di seguito un elenco di riferimento degli episodi pubblicati sul canale, con la durata
        indicativa di ogni puntata. Per navigare per materia e aprire i singoli episodi, usa
        l’Hub qui sopra.
      </p>

      <div style={{ overflowX: "auto" }}>
        <table className="kb-table">
          <thead>
            <tr>
              <th>N.</th>
              <th>Titolo dell’episodio (con link)</th>
              <th>Durata</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preparazione ESAME OCF – 1: Diritto dei Mercati Finanziari – Abusi, OPA, ESG &amp; Patti
                  Parasociali
                </a>
              </td>
              <td>56:20</td>
            </tr>
            <tr>
              <td>2</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preparazione ESAME OCF – 2: Gestione Collettiva, Antiriciclaggio &amp; TUF: Autorità e Regole
                </a>
              </td>
              <td>40:25</td>
            </tr>
            <tr>
              <td>3</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preparazione ESAME OCF – 3: SIM &amp; Condotta, ESG/Product Governance &amp; Vigilanza
                </a>
              </td>
              <td>53:27</td>
            </tr>
            <tr>
              <td>4</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preparazione ESAME OCF – 4: Politica Monetaria, Tassi &amp; Matematica Finanziaria di Base
                </a>
              </td>
              <td>1:06:13</td>
            </tr>
            <tr>
              <td>5</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preparazione ESAME OCF – 5: Mercato Monetario, OICR e Fondi
                </a>
              </td>
              <td>1:04:46</td>
            </tr>
            <tr>
              <td>6</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Preparazione ESAME OCF – 6: Swap su Tassi e Valute: IRS, Assegni e Cambiali, e obbligazioni
                </a>
              </td>
              <td>1:07:27</td>
            </tr>
            <tr>
              <td>7</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 7: Fondamenti Tributari, IRPEF e IRES, Regimi Fiscali e Redditi Finanziari
                </a>
              </td>
              <td>37:42</td>
            </tr>
            <tr>
              <td>8</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 8: Regime Dichiarazione, Amministrato e Gestito; Tassazione di Interessi e Dividendi
                </a>
              </td>
              <td>25:42</td>
            </tr>
            <tr>
              <td>9</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 9: PIR tradizionali e alternativi, e Gestione Patrimoniale: Limiti, Esenzioni
                </a>
              </td>
              <td>35:40</td>
            </tr>
            <tr>
              <td>10</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 10: IVASS, Intermediari, Previdenza, TFR e Fondi Pensione
                </a>
              </td>
              <td>26:09</td>
            </tr>
            <tr>
              <td>11</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 11: Assicurazioni Ramo Danni e Vita: sinistri, coassicurazione, polizze vita
                </a>
              </td>
              <td>21:03</td>
            </tr>
            <tr>
              <td>12</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 12: Principi generali del contratto di assicurazione
                </a>
              </td>
              <td>21:03</td>
            </tr>
            <tr>
              <td>13</td>
              <td>
                <a
                  href="/it/ocf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esame OCF – 13: Contratti – forma, interpretazione, invalidità, inadempimento
                </a>
              </td>
              <td>12:47</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        L’ordine numerico non rappresenta la sequenza di studio obbligatoria: puoi ascoltare gli episodi
        nell’ordine che preferisci in base alle tue esigenze. Ricorda però che alcune puntate (come quelle
        su matematica finanziaria e diritto dei mercati) affrontano argomenti centrali del test e meritano
        una particolare attenzione.
      </p>

      <h3>6. Mantenere la motivazione e la disciplina</h3>
      <p>
        La costanza è fondamentale. Programmate sessioni di studio quotidiane, alternate teoria e quiz e
        monitorate i vostri progressi. Condividere il percorso con altri candidati (tramite forum o gruppi
        social) aiuta a risolvere dubbi e a mantenere la motivazione. Ricordate che la prova si può ripetere
        quante volte necessario; tuttavia, ogni tentativo comporta una nuova quota di 200 €
        <span aria-hidden="true">[25]</span>, quindi conviene prepararsi al meglio prima di prenotare.
      </p>

      <h2>Conclusioni: l’esame OCF come opportunità professionale</h2>
      <p>
        Il test OCF non è solo un ostacolo burocratico: rappresenta una garanzia per i risparmiatori e
        un’opportunità per chi desidera diventare consulente finanziario in un mercato sempre più complesso.
        La professione richiede competenze trasversali – dalla matematica finanziaria al diritto, dalla
        pianificazione al comportamento degli investitori – e il test misura proprio queste capacità. Le
        statistiche mostrano che la prova è selettiva: negli ultimi anni il tasso di successo oscilla tra il
        <strong>40%</strong> e il <strong>44%</strong><span aria-hidden="true">[28][36]</span>, ma chi supera
        la prova ottiene in media punteggi elevati (circa <strong>88/100</strong>)
        <span aria-hidden="true">[29]</span>.
      </p>
      <p>
        Prepararsi al meglio richiede tempo, studio e il supporto di materiali adeguati. Il podcast che ho
        realizzato nasce con questo scopo: semplificare gli argomenti più complessi e rendere la preparazione
        meno dispersiva. Se desideri approfondire, visita la{" "}
        <a
          href="/it/ocf"
          target="_blank"
          rel="noopener noreferrer"
        >
          playlist
        </a>{" "}
        e consulta gli altri articoli sul mio sito: troverai ulteriori spunti, esercizi commentati e
        aggiornamenti normativi.
      </p>
      <p>
        Superare l’esame OCF apre le porte a una professione dinamica e in crescita. Inizia oggi la tua
        preparazione e trasforma la sfida dell’esame in un passo decisivo verso il futuro che desideri.
      </p>

      <h2>Fonti e collegamenti</h2>
      <ul>
        <li>
          [1] [2] [3] [4] [7] [8] [21] [26] [27] [28] [29] [30] [31] [32] [33] [34] — Esame OCF: nel 2024
          tasso di promossi in aumento al 43,8%. Tutte le informazioni sull’esame – Esame OCF —{" "}
          <a
            href="https://esameocf.it/2025/06/27/esame-ocf-nel-2024-tasso-di-promossi-in-aumento-al-438-tutte-le-informazioni-sullesame/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link
          </a>
        </li>
        <li>
          [5] [6] [9] [10] [11] [12] [13] [14] [15] [16] [17] [18] [19] [20] [25] [42] [43] — Bando OCF 2025
          (Delibera n. 2587) —{" "}
          <a
            href="https://www.organismocf.it/portal/documents/40504/1369638/Delibera%20n.%202587%20Bando%202025-signed.pdf/2e616c20-4204-fdec-9e0b-aab168b37534"
            target="_blank"
            rel="noopener noreferrer"
          >
            PDF
          </a>
        </li>
        <li>
          [22] — La Prova Valutativa – Consulenti Finanziari oGGi —{" "}
          <a
            href="https://consulentifinanziarioggi.it/la-prova-valutativa/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link
          </a>
        </li>
        <li>
          [23] [24] — Diventa Consulente Finanziario — ANASF —{" "}
          <a href="https://anasf.it/diventa-consulente-finanziario" target="_blank" rel="noopener noreferrer">
            Link
          </a>
        </li>
        <li>
          [35] [36] [37] [38] [39] [40] — Esame OCF: nel 2023 tasso di promossi al 42,3% – Esame OCF —{" "}
          <a
            href="https://esameocf.it/2024/06/28/esame-ocf-nel-2023-tasso-di-promossi-al-423/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link
          </a>
        </li>
        <li>
          [41] — Consulenti finanziari, quanti bocciati all’esame — Bluerating —{" "}
          <a
            href="https://www.bluerating.com/banche-e-reti/789692/consulenti-finanziari-quanti-bocciati-allesame"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link
          </a>
        </li>
      </ul>
    </div>
  ),
}



     



  
];

// ─────────────────────────────────────────────────────────────────────────────
// ARTICOLO: Analisi F.I.R.E. — la matematica dell'indipendenza finanziaria
// ─────────────────────────────────────────────────────────────────────────────

const fireArticleIT = {
  slug: "analisi-fire-matematica-indipendenza-finanziaria",
  title: "Analisi F.I.R.E.: la matematica dell'indipendenza finanziaria",
  metaDescription:
    "Guida quantitativa al movimento FIRE: regola del 4%, FIRE Number, Lean/Fat/Barista/Coast FIRE, Trinity Study, CAPE-SWR, Block Bootstrap Monte Carlo e Sequence of Returns Risk. Formule, assunzioni e limiti del modello.",
  tags: ["fire", "pianificazione", "quant", "educazione"],
  readTime: "18 min",
  author: "Redazione AlphaFrame",
  datePublished: "2026-04-11",
  dateUpdated: "2026-04-11",
  coverImage: IndFinCover,
  canonical: `${DOMAIN}/it/kb/analisi-fire-matematica-indipendenza-finanziaria`,
  content: (
    <div>
      <h1>Analisi F.I.R.E.: la matematica dell'indipendenza finanziaria</h1>

      <p>
        Il movimento <strong>F.I.R.E.</strong> (Financial Independence, Retire Early) ha trasformato
        la pianificazione finanziaria personale in una disciplina quantitativa rigorosa. Nata nelle
        comunità online anglosassoni agli inizi degli anni 2010 — con radici accademiche che risalgono
        almeno al 1994 — l'idea di fondo è semplice: accumulare un patrimonio sufficiente a sostenere
        il proprio stile di vita in modo indefinito tramite il prelievo periodico dai rendimenti.
        Questo articolo esamina i modelli matematici alla base del FIRE, le loro assunzioni, i loro
        limiti e come applicarli nella pratica con il{" "}
        <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
          Calcolatore F.I.R.E. di AlphaFrame
        </a>.
      </p>

      {/* ───────────────────────── 1. ORIGINI ───────────────────────── */}
      <h2>1. Origini: dalla regola del 4% al movimento FIRE</h2>
      <p>
        Il fondamento empirico del FIRE è il celebre lavoro di <strong>William Bengen (1994)</strong>,
        pubblicato sul <em>Journal of Financial Planning</em>. Analizzando i rendimenti storici di
        portafogli azionario-obbligazionari americani dal 1926 al 1992 su orizzonti di 30 anni,
        Bengen concluse che un tasso di prelievo del <strong>4% annuo</strong> del patrimonio iniziale,
        rivalutato annualmente per l'inflazione, non aveva mai esaurito il portafoglio in nessun
        periodo storico di 30 anni. Questo risultato divenne noto come la <em>regola del 4%</em>.
      </p>
      <p>
        Nel <strong>1998</strong>, Cooley, Hubbard e Walz — professori della Trinity University —
        pubblicarono lo studio diventato celebre come <em>Trinity Study</em>. Estesero l'analisi
        di Bengen introducendo il concetto di <em>tasso di successo del portafoglio</em>: la
        percentuale di periodi storici in cui il portafoglio non si sarebbe esaurito. Il Trinity
        Study è stato aggiornato molteplici volte (2009, 2011, 2021) incorporando dati più recenti.
      </p>
      <p>
        Negli anni 2010 ricercatori come <strong>Wade Pfau</strong> (2011) e{" "}
        <strong>Javier Estrada</strong> (2020) hanno raffinato il modello per tenere conto della
        valutazione del mercato (tramite il CAPE di Shiller) e di orizzonti superiori ai 30 anni —
        rilevanti per chi va in pensione a 35-45 anni. Parallelamente, <strong>Karsten Jeske</strong>{" "}
        (noto come <em>Early Retirement Now</em>, ERN) ha sviluppato dal 2018 una metodologia
        di simulazione basata su Block Bootstrap che costituisce oggi lo stato dell'arte per
        l'analisi del Sequence of Returns Risk.
      </p>

      {/* ───────────────────────── 2. FIRE NUMBER ───────────────────────── */}
      <h2>2. Il FIRE Number: quanto mi serve?</h2>
      <p>
        Il punto di partenza di qualsiasi analisi FIRE è il calcolo del patrimonio-obiettivo,
        detto <strong>FIRE Number</strong>. La formula è immediata:
      </p>
      <BM>{tex`FN = \frac{C}{SWR}`}</BM>
      <p>
        dove <IM>{tex`C`}</IM> sono le spese annuali sostenibili in pensione (in termini reali,
        cioè a parità di potere d'acquisto) e <IM>{tex`SWR`}</IM> è il Safe Withdrawal Rate,
        il tasso di prelievo sostenibile. Con <IM>{tex`SWR = 4\%`}</IM>:
      </p>
      <BM>{tex`FN = \frac{C}{0{,}04} = 25 \times C`}</BM>
      <p>
        Il "moltiplicatore 25" è diventato la regola empirica del FIRE: occorre un patrimonio pari
        a 25 volte le spese annuali. Con <IM>{tex`SWR = 3{,}5\%`}</IM> il moltiplicatore sale a
        circa 28,6 — più conservativo e indicato per orizzonti superiori a 40 anni.
      </p>
      <p>
        <strong>Assunzione critica:</strong> il FIRE Number presuppone che il portafoglio sia
        interamente investito in attività finanziarie con rendimento reale atteso positivo. Non
        include immobili a uso personale, redditi da lavoro, pensione pubblica o altri asset illiquidi.
        L'ignoring di queste fonti rende il FIRE Number conservativo — il che può essere desiderabile.
      </p>

      {/* ───────────────────────── 3. TRINITY ───────────────────────── */}
      <h2>3. Il Trinity Study: tassi di successo storici</h2>
      <p>
        Cooley, Hubbard e Walz (1998, aggiornato 2021) hanno sistematizzato il concetto di{" "}
        <strong>tasso di successo del portafoglio</strong>: su tutti i periodi storici di
        durata <IM>{tex`T`}</IM> anni disponibili, quale percentuale non ha esaurito il portafoglio?
        Il loro dataset copre il mercato azionario e obbligazionario americano dal 1926 a oggi
        (S&P 500 + bond governativi americani a lungo termine).
      </p>
      <p>
        I risultati principali per un portafoglio 50/50 azioni/bond con prelievo indicizzato
        all'inflazione mostrano tassi di successo dell'ordine del 95–98% per orizzonti di 30 anni
        con <IM>{tex`SWR \leq 4\%`}</IM>. Per orizzonti di 40 anni i risultati sono più incerti e
        dipendono fortemente dall'allocazione: un portafoglio 100% azionario performa meglio su
        lunghi orizzonti (Trinity Study 2021).
      </p>
      <p>
        <strong>Limiti del Trinity Study:</strong>
      </p>
      <ul>
        <li>Dataset esclusivamente americano: non cattura la diversificazione internazionale né
          i mercati meno sviluppati che hanno avuto performance peggiori.</li>
        <li>Periodi storici sovrapposti (overlapping periods) non sono statisticamente indipendenti:
          il tasso di successo non è una vera probabilità frequentista.</li>
        <li>Inflazione costante: il modello usa inflazione americana storica, non necessariamente
          applicabile a portafogli in euro.</li>
        <li>Nessuna modellazione di tasse, costi di transazione o variazioni di spesa nel tempo.</li>
      </ul>

      {/* ───────────────────────── 4. CAPE-SWR ───────────────────────── */}
      <h2>4. CAPE-SWR: valutazione del mercato e tasso di prelievo</h2>
      <p>
        Wade Pfau (2011) ha mostrato che il tasso di prelievo sicuro non è una costante: dipende
        dalla valutazione del mercato al momento del pensionamento. Pfau ha stimato un modello
        lineare che usa il <strong>CAPE</strong> di Shiller (Cyclically Adjusted Price-to-Earnings,
        media mobile decennale degli utili reali) come predittore:
      </p>
      <BM>{tex`SWR_t \;\approx\; \alpha + \beta\,\cdot\, \frac{1}{CAPE_t}`}</BM>
      <p>
        L'intuizione è diretta: mercati costosi al momento del pensionamento (CAPE elevato) implicano
        rendimenti futuri attesi più bassi, quindi un SWR più basso per garantire la sostenibilità.
        Con CAPE intorno a 30 (livello dell'S&P 500 nel 2024), il modello di Pfau suggerisce{" "}
        <IM>{tex`SWR \approx 3{,}0\%\text{–}3{,}5\%`}</IM>.
      </p>
      <p>
        <strong>Assunzione del modello:</strong> la relazione CAPE-SWR è stimata su dati storici
        americani. In un contesto europeo o globale, il CAPE ha un diverso potere predittivo.
        Il modello assume anche che il portafoglio sia ribilanciato periodicamente e che l'allocazione
        rimanga stabile nel tempo.
      </p>

      {/* ───────────────────────── 5. ESTRADA LONG HORIZONS ───────────────────────── */}
      <h2>5. Orizzonti lunghi: il contributo di Estrada (2020)</h2>
      <p>
        Javier Estrada (2020, <em>Journal of Financial Planning</em>) ha esteso l'analisi FIRE a
        orizzonti di 40, 50 e 60 anni usando un dataset internazionale di 21 paesi (1900–2019).
        Le conclusioni principali:
      </p>
      <ul>
        <li>Per orizzonti di <strong>40 anni</strong>, un SWR del 3,5% garantisce tassi di successo
          superiori al 90% nella grande maggioranza dei mercati analizzati.</li>
        <li>Per orizzonti di <strong>50+ anni</strong>, il 3,5% rimane ragionevole ma la dispersione
          tra paesi è elevata: mercati come il Giappone degli anni '90 mostrano tassi di successo
          molto inferiori.</li>
        <li>La diversificazione internazionale riduce significativamente il rischio di deplezione
          rispetto a portafogli nazionali.</li>
      </ul>
      <p>
        Il calcolatore AlphaFrame usa <strong>SWR = 3,5% come default</strong> per orizzonti di
        pensionamento lunghi, in linea con la letteratura di Estrada e Pfau.
      </p>

      {/* ───────────────────────── 6. CINQUE TIPI ───────────────────────── */}
      <h2>6. I cinque tipi di FIRE: definizioni matematiche</h2>
      <p>
        Il termine "FIRE" racchiude diversi obiettivi, tutti derivati dalla formula base ma
        con moltiplicatori o condizioni diverse sulle spese. In tutti i casi le spese
        <IM>{tex`C`}</IM> sono relative al proprio stile di vita effettivo — non soglie assolute.
      </p>

      <h3>6.1 Regular FIRE</h3>
      <p>
        Il caso base: mantenere esattamente le spese attuali in pensione.
      </p>
      <BM>{tex`FN_{\text{regular}} = \frac{C}{SWR}`}</BM>

      <h3>6.2 Lean FIRE</h3>
      <p>
        Stile di vita frugale in pensione, a spese ridotte del 30% rispetto alle attuali:
      </p>
      <BM>{tex`FN_{\text{lean}} = \frac{0{,}70 \cdot C}{SWR}`}</BM>
      <p>
        Lean FIRE richiede un patrimonio inferiore ma implica rinunce concrete. È adatto a chi
        ha spese basse già ora o prevede di ottimizzarle drasticamente (es. trasferimento in
        zone a basso costo della vita, riduzione abbonamenti, cambio stile di vita).
      </p>

      <h3>6.3 Fat FIRE</h3>
      <p>
        Stile di vita premium, a spese aumentate del 50% rispetto alle attuali:
      </p>
      <BM>{tex`FN_{\text{fat}} = \frac{1{,}50 \cdot C}{SWR}`}</BM>
      <p>
        Fat FIRE include un buffer significativo per spese discrezionali, viaggi, donazioni o
        imprevisti. Richiede un patrimonio 2,14 volte superiore a Lean FIRE, a parità di SWR.
      </p>

      <h3>6.4 Barista FIRE</h3>
      <p>
        Semi-pensionamento: l'individuo continua a lavorare part-time con un reddito{" "}
        <IM>{tex`I_{pt}`}</IM> annuale, coprendo solo la differenza con il portafoglio:
      </p>
      <BM>{tex`FN_{\text{barista}} = \frac{\max(0,\; C - I_{pt})}{SWR}`}</BM>
      <p>
        Se <IM>{tex`I_{pt} \geq C`}</IM>, il FIRE Number è zero: il reddito part-time copre
        interamente le spese. Barista FIRE è particolarmente attraente per chi vuole uscire
        dal lavoro a tempo pieno ma non dal lavoro in senso assoluto, preservando anche benefici
        come copertura sanitaria, stimolo intellettuale e relazioni sociali.
      </p>

      <h3>6.5 Coast FIRE</h3>
      <p>
        Il caso più matematicamente elegante: a quale patrimonio <IM>{tex`P_t`}</IM> devo
        arrivare <em>oggi</em> (all'età <IM>{tex`t`}</IM>) affinché, senza ulteriori contributi,
        il solo rendimento composto porti il portafoglio al FIRE Number entro l'età target{" "}
        <IM>{tex`T`}</IM>?
      </p>
      <BM>{tex`CoastFN = \frac{FN_{\text{regular}}}{(1+r)^{T-t}}`}</BM>
      <p>
        dove <IM>{tex`r`}</IM> è il rendimento reale annuo atteso e{" "}
        <IM>{tex`T - t`}</IM> sono gli anni rimanenti al pensionamento target. Una volta raggiunto
        il Coast FN, si può smettere di risparmiare (o ridurre drasticamente i contributi) e
        lasciare che la capitalizzazione faccia il lavoro.
      </p>
      <p>
        <strong>Esempio:</strong> con <IM>{tex`C = 30{.}000\;\text{€}`}</IM>,{" "}
        <IM>{tex`SWR = 3{,}5\%`}</IM>, <IM>{tex`r = 5\%`}</IM>, età attuale 30, età target 55:
      </p>
      <BM>{tex`FN = \frac{30{.}000}{0{,}035} = 857{.}143\;\text{€}`}</BM>
      <BM>{tex`CoastFN = \frac{857{.}143}{(1{,}05)^{25}} = \frac{857{.}143}{3{,}386} \approx 253{.}100\;\text{€}`}</BM>

      {/* ───────────────────────── 7. FORMULA ANNI ───────────────────────── */}
      <h2>7. La formula degli "Anni al FIRE"</h2>
      <p>
        Dati patrimonio attuale <IM>{tex`P`}</IM>, contributo mensile <IM>{tex`A`}</IM> e
        rendimento reale mensile <IM>{tex`r = (1+r_a)^{1/12} - 1`}</IM>, il valore futuro del
        patrimonio dopo <IM>{tex`n`}</IM> mesi è:
      </p>
      <BM>{tex`FV_n = P\,(1+r)^n \;+\; A\,\frac{(1+r)^n - 1}{r}`}</BM>
      <p>
        Ponendo <IM>{tex`FV_n = FN`}</IM> e risolvendo per <IM>{tex`n`}</IM>:
      </p>
      <BM>{tex`(1+r)^n \;=\; \frac{FN + A/r}{P + A/r}`}</BM>
      <BM>{tex`n \;=\; \frac{\displaystyle\ln\!\left(\frac{FN + A/r}{P + A/r}\right)}{\ln(1+r)}`}</BM>
      <p>
        Gli anni al FIRE sono quindi <IM>{tex`n/12`}</IM>. Questa è la formula esatta, valida
        per qualsiasi combinazione di patrimonio iniziale e contributo periodico. La formula
        degenera in due casi limite:
      </p>
      <ul>
        <li>
          <strong>A = 0 (nessun contributo, solo capitalizzazione):</strong>{" "}
          <IM>{tex`n = \ln(FN/P) / \ln(1+r)`}</IM>
        </li>
        <li>
          <strong>r = 0 (rendimento zero):</strong>{" "}
          <IM>{tex`n = (FN - P) / A`}</IM> (mesi)
        </li>
      </ul>
      <p>
        <strong>Nota:</strong> la formula presuppone contributi mensili costanti in termini reali.
        In pratica i contributi crescono con la carriera — questa semplificazione è conservativa
        (sovrastima il tempo necessario).
      </p>

      {/* ───────────────────────── 8. TASSO RISPARMIO ───────────────────────── */}
      <h2>8. Tasso di risparmio e accelerazione verso il FIRE</h2>
      <p>
        Il <strong>tasso di risparmio</strong> è la variabile più potente nel determinare la
        velocità di avvicinamento al FIRE. Definendo il reddito netto come{" "}
        <IM>{tex`Y = C + S`}</IM> (spese + risparmio mensile):
      </p>
      <BM>{tex`SR = \frac{S}{Y} = \frac{Y - C}{Y}`}</BM>
      <p>
        L'impatto del SR è duplice: un SR più alto aumenta il contributo mensile{" "}
        <IM>{tex`A = S`}</IM> <strong>e simultaneamente riduce le spese</strong>{" "}
        <IM>{tex`C`}</IM>, abbassando il FIRE Number. Un aumento del SR dal 20% al 50% può
        ridurre il tempo al FIRE da oltre 40 anni a circa 15–17 anni (a parità di rendimento
        reale), come hanno mostrato gli studi fondativi del blog <em>Mr. Money Mustache</em>{" "}
        (Adeney, 2012).
      </p>

      {/* ───────────────────────── 9. SORR ───────────────────────── */}
      <h2>9. Sequence of Returns Risk (SORR)</h2>
      <p>
        Il <strong>rischio di sequenza dei rendimenti</strong> è il fenomeno per cui la stessa
        media di rendimento produce esiti radicalmente diversi a seconda dell'ordine temporale
        dei rendimenti. Durante la fase di <em>prelievo</em> (decumulation), una sequenza di
        rendimenti negativi nei primi anni del pensionamento è devastante: si vende patrimonio
        a prezzi bassi per coprire le spese, riducendo permanentemente la base che beneficerà
        della successiva ripresa.
      </p>
      <p>
        Formalmente, sia <IM>{tex`W_t`}</IM> il patrimonio all'anno <IM>{tex`t`}</IM>:
      </p>
      <BM>{tex`W_{t+1} = W_t \cdot (1 + r_{t+1}) - C`}</BM>
      <p>
        Se <IM>{tex`r_1 = -30\%`}</IM> (anno 1 disastroso) e poi <IM>{tex`r = +8\%/\text{anno}`}</IM>
        per 29 anni, il portafoglio si comporta in modo drasticamente peggiore rispetto allo
        stesso scenario con i rendimenti invertiti (prima +8%, poi -30%). La media annua è
        identica, l'esito finale è completamente diverso.
      </p>
      <p>
        Il SORR è il motivo principale per cui:
      </p>
      <ul>
        <li>Il SWR del 4% è più basso del rendimento medio storico del mercato azionario (7–8% reale).</li>
        <li>È consigliato mantenere una quota obbligazionaria o cash durante la fase di prelievo.</li>
        <li>Strategie di "guardrail" e "bucket" sono state sviluppate per mitigarne l'impatto.</li>
      </ul>

      {/* ───────────────────────── 10. MONTE CARLO ───────────────────────── */}
      <h2>10. Simulazione Monte Carlo e Block Bootstrap</h2>
      <p>
        Le simulazioni Monte Carlo permettono di quantificare la distribuzione degli esiti possibili,
        superando i limiti dell'analisi deterministica. Il calcolatore AlphaFrame implementa
        il metodo <strong>Block Bootstrap</strong>, sviluppato e divulgato da Karsten Jeske
        (ERN, 2018–2024).
      </p>
      <h3>10.1 Metodo Naive Monte Carlo (e perché non usiamo questo)</h3>
      <p>
        Il metodo più semplice è campionare rendimenti da una distribuzione normale:
      </p>
      <BM>{tex`r_t \sim \mathcal{N}(\mu,\, \sigma^2)`}</BM>
      <p>
        Il problema è che i rendimenti azionari reali <strong>non sono gaussiani</strong>: hanno
        code grasse (fat tails), asimmetria negativa (skewness) e autocorrelazione di breve periodo.
        Una distribuzione normale sottostima significativamente la probabilità di anni come il
        2008 (−40%) o il 2022 (−18%), che sono cruciali per il SORR.
      </p>
      <h3>10.2 Block Bootstrap</h3>
      <p>
        Il Block Bootstrap risolve questi problemi campionando blocchi contigui di rendimenti
        storici reali anziché rendimenti sintetici. Per ogni simulazione:
      </p>
      <ol>
        <li>Si divide la serie storica in blocchi di lunghezza <IM>{tex`L`}</IM> (nel nostro
          caso <IM>{tex`L = 3`}</IM> anni).</li>
        <li>Si campionano blocchi con reinserimento fino a coprire l'orizzonte desiderato.</li>
        <li>Si applica la sequenza di rendimenti al patrimonio, includendo contributi/prelievi mensili.</li>
      </ol>
      <BM>{tex`W_{t+1} = W_t \cdot (1 + r_{t+1}^{*}) + A`}</BM>
      <p>
        dove <IM>{tex`r_{t+1}^{*}`}</IM> è il rendimento campionato dal bootstrap. Il blocco
        di lunghezza 3 garantisce che crisi correlate (es. 2000–2002, 2008–2009) appaiano
        congiuntamente nelle simulazioni, preservando la struttura di correlazione temporale.
      </p>
      <p>
        Il dataset embedded nel calcolatore AlphaFrame comprende i rendimenti reali annui del
        MSCI World dal <strong>1970 al 2024</strong> (55 osservazioni), includendo:
        crisi petrolifera (1973–1974), Black Monday (1987), dot-com crash (2000–2002),
        Grande Recessione (2008–2009), bear market 2022. Con <IM>{tex`N = 2{.}000`}</IM>{" "}
        simulazioni e blocchi da 3 anni, il metodo cattura sia la volatilità media che
        le code grasse della distribuzione dei rendimenti azionari globali.
      </p>

      {/* ───────────────────────── 11. ASSUNZIONI E LIMITI ───────────────────────── */}
      <h2>11. Assunzioni del modello e limiti</h2>
      <p>
        Ogni modello FIRE si regge su un insieme di assunzioni che è essenziale comprendere
        prima di prendere decisioni importanti:
      </p>
      <ul>
        <li>
          <strong>Rendimento reale costante</strong> — Il modello deterministico usa un rendimento
          reale annuo fisso. Il Monte Carlo rilassa questa assunzione ma usa dati storici che
          potrebbero non replicarsi nel futuro (problema del "questa volta è diverso").
        </li>
        <li>
          <strong>Spese costanti in termini reali</strong> — In realtà le spese cambiano con
          l'età (decrescono nella terza età, aumentano per le spese sanitarie). Il modello
          non cattura questa dinamica.
        </li>
        <li>
          <strong>Nessuna modellazione di tasse</strong> — In Italia, i capital gain su ETF
          sono tassati al 26% (salvo eccezioni). Un SWR nominale del 3,5% diventa circa
          2,6% effettivo al netto di imposte — occorre un FIRE Number più elevato o un SWR
          lordo più generoso per compensare.
        </li>
        <li>
          <strong>Nessun reddito alternativo</strong> — Pensione pubblica, immobili a reddito
          o lavoro part-time possono ridurre significativamente il FIRE Number. Ignorarli è
          conservativo ma non sempre realistico.
        </li>
        <li>
          <strong>Dataset storico limitato</strong> — 55 anni di dati MSCI World sono pochi
          per stimare code grasse con precisione. Il Block Bootstrap mitiga il problema ma
          non lo elimina.
        </li>
        <li>
          <strong>Orizzonte incerto</strong> — Non è possibile conoscere a priori la durata
          della vita. Per un pensionamento a 40 anni, un orizzonte di 60+ anni è realistico;
          il modello FIRE classico (30 anni) potrebbe essere insufficiente.
        </li>
      </ul>

      {/* ───────────────────────── 12. COME USARE IL CALCOLATORE ───────────────────────── */}
      <h2>12. Come usare il Calcolatore F.I.R.E. di AlphaFrame</h2>
      <p>
        Il{" "}
        <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
          Calcolatore F.I.R.E.
        </a>{" "}
        implementa tutti i modelli discussi in questo articolo. Segui questi passaggi:
      </p>
      <ol>
        <li>
          <strong>Scegli la valuta</strong> — EUR, USD o GBP. L'inflazione di default si adatta
          automaticamente (2% per EUR, 2,5% per USD/GBP).
        </li>
        <li>
          <strong>Inserisci età e patrimonio attuale</strong> — L'età target determina
          l'orizzonte per il Coast FIRE Number.
        </li>
        <li>
          <strong>Stima le spese</strong> — Usa l'inserimento diretto oppure il wizard per
          categoria (casa, cibo, trasporti, ecc.) che calcola automaticamente il totale annuale.
        </li>
        <li>
          <strong>Seleziona il tipo di FIRE</strong> — Regular, Lean, Fat, Barista o Coast.
          Per Barista inserisci il reddito part-time mensile atteso.
        </li>
        <li>
          <strong>Parametri avanzati</strong> — Modifica SWR (default 3,5%), rendimento reale
          atteso (default 5%) e inflazione se hai stime diverse.
        </li>
        <li>
          <strong>Esegui il Monte Carlo</strong> — Il Block Bootstrap genera 2.000 percorsi
          possibili. Il grafico mostra i percentili 5°, 25°, 50°, 75° e 95° del patrimonio
          nel tempo.
        </li>
      </ol>
      <p>
        I risultati mostrano FIRE Number, anni stimati al FIRE, età prevista e tasso di risparmio
        implicito, oltre alla tabella comparativa di tutti e cinque i tipi FIRE.
      </p>

      {/* ───────────────────────── 13. BIBLIOGRAFIA ───────────────────────── */}
      <h2>13. Riferimenti bibliografici</h2>
      <ul>
        <li>Bengen, W. P. (1994). "Determining Withdrawal Rates Using Historical Data."
          <em> Journal of Financial Planning</em>, 7(4), 171–180.</li>
        <li>Cooley, P. L., Hubbard, C. M., &amp; Walz, D. T. (1998). "Retirement Savings:
          Choosing a Withdrawal Rate That Is Sustainable."
          <em> AAII Journal</em>, 20(2), 16–21. [Trinity Study]</li>
        <li>Cooley, P. L., Hubbard, C. M., &amp; Walz, D. T. (2011). "Portfolio Success
          Rates: Where to Draw the Line."
          <em> Journal of Financial Planning</em>, 24(4), 48–60.</li>
        <li>Pfau, W. D. (2011). "Safe Savings Rates: A New Approach to Retirement Planning
          Over the Life Cycle."
          <em> Journal of Financial Planning</em>, 24(5), 42–50.</li>
        <li>Estrada, J. (2020). "Managing to Target: Dynamic Asset Allocation for Goal-Based
          Investing." <em>Journal of Financial Planning</em>, 33(2), 38–50. Vedi anche:
          Estrada, J. (2018). "Replacing the Failure Rate: A New Success Metric for
          Retirement Portfolios."
          <em> Journal of Wealth Management</em>.</li>
        <li>Karsten, K. (ERN). (2018–2024). "Safe Withdrawal Rate Series."
          <em> Early Retirement Now Blog</em>.{" "}
          <a href="https://earlyretirementnow.com/safe-withdrawal-rate-series/" target="_blank" rel="noopener noreferrer">
            earlyretirementnow.com
          </a></li>
        <li>Shiller, R. J. (1981). "Do Stock Prices Move Too Much to Be Justified by
          Subsequent Changes in Dividends?" <em>American Economic Review</em>, 71(3), 421–436.
          [CAPE ratio]</li>
        <li>Adeney, P. (Mr. Money Mustache). (2012). "The Shockingly Simple Math Behind
          Early Retirement." <em>mrmoneymustache.com</em>.</li>
      </ul>

      {/* ───────────────────────── 14. DISCLAIMER ───────────────────────── */}
      <h2>Disclaimer e avvertenze</h2>
      <p>
        <strong>Questo articolo e il calcolatore associato hanno esclusivamente scopo educativo
        e illustrativo.</strong> I modelli presentati si basano su dati storici e assunzioni
        che potrebbero non replicarsi in futuro. I rendimenti passati non sono garanzia di
        risultati futuri. Il FIRE Number calcolato non costituisce raccomandazione di investimento
        né consulenza finanziaria, legale o fiscale personalizzata.
      </p>
      <p>
        L'applicazione dei modelli FIRE alla propria situazione patrimoniale richiede la
        valutazione di variabili individuali — orizzonte temporale, tolleranza al rischio,
        situazione fiscale, copertura previdenziale, obblighi familiari — che esulano dalla
        portata di qualsiasi simulazione automatizzata. La pianificazione previdenziale è una
        materia complessa; prima di prendere decisioni rilevanti è opportuno confrontarsi con
        un consulente finanziario indipendente abilitato.
      </p>
      <p>
        AlphaFrame Analytics non si assume alcuna responsabilità per decisioni prese sulla
        base degli output del calcolatore. Le simulazioni Monte Carlo sono strumenti probabilistici:
        anche un percorso al 95° percentile può rivelarsi insufficiente in scenari storicamente
        inediti.
      </p>
    </div>
  ),
};

// ─────────────────────────────────────────────────────────────────────────────
// ARTICOLO: Interesse composto e tassazione italiana
// ─────────────────────────────────────────────────────────────────────────────

const compoundArticleIT = {
  slug: "interesse-composto-tassazione-italiana",
  title: "Interesse composto e tassazione italiana: la guida completa con numeri reali",
  metaDescription:
    "Guida completa all'interesse composto applicato al contesto italiano: formula matematica, confronto Conto Deposito vs BTP vs ETF, tassazione 26% e 12.5%, regime amministrato e simulazioni numeriche su orizzonti 5-20 anni.",
  tags: ["educazione", "finanza", "etf", "quant"],
  readTime: "12 min",
  author: "Redazione AlphaFrame",
  datePublished: "2026-04-16",
  dateUpdated: "2026-09-29",
  coverImage: IndFinCover,
  canonical: `${DOMAIN}/it/kb/interesse-composto-tassazione-italiana`,
  content: (
    <div>
      <h1>Interesse composto e tassazione italiana: la guida completa con numeri reali</h1>

      <p>
        L'interesse composto è la forza più silenziosa della finanza personale. Albert Einstein —
        secondo una citazione apocrifa ma efficace — lo avrebbe definito «l'ottava meraviglia del
        mondo». Al di là della paternità della frase, il concetto è reale e misurabile: ogni euro
        di rendimento reinvestito genera a sua volta rendimento, creando una crescita esponenziale
        nel tempo. Questa guida analizza l'interesse composto nel contesto specifico italiano,
        dove la tassazione differenziata tra strumenti finanziari cambia significativamente
        l'equazione. Puoi esplorare tutti i calcoli in modo interattivo con il{" "}
        <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
          Calcolatore Obiettivi di AlphaFrame
        </a>.
      </p>

      <h2>1. La matematica dell'interesse composto</h2>
      <p>
        La formula del valore futuro di un capitale con contributi periodici è la base di ogni
        analisi di pianificazione finanziaria. Per un capitale iniziale{" "}
        <BM>{tex`P`}</BM> con versamento mensile{" "}
        <BM>{tex`A`}</BM>, tasso mensile{" "}
        <BM>{tex`r = r_{\text{annuo}}/12`}</BM> e orizzonte di{" "}
        <BM>{tex`n`}</BM> mesi, il valore finale lordo è:
      </p>
      <BM>{tex`FV = P \cdot (1+r)^n + A \cdot \frac{(1+r)^n - 1}{r}`}</BM>
      <p>
        Il primo termine è il compounding del capitale iniziale, il secondo è il valore futuro
        della serie di versamenti (rendita in rate posticipate). Questa formula presuppone un
        tasso costante — una semplificazione che nella pratica va corretta con il fatto che i
        rendimenti variano anno per anno.
      </p>
      <p>
        Il tasso mensile <IM>{tex`r`}</IM> è derivato dal tasso annuo lordo{" "}
        <IM>{tex`r_{\text{lordo}}`}</IM> al netto dei costi annui{" "}
        <IM>{tex`c`}</IM>:
      </p>
      <BM>{tex`r = \frac{r_{\text{lordo}} - c}{12 \cdot 100}`}</BM>
      <p>
        La separazione tra rendimento lordo e costo è fondamentale: un fondo con rendimento lordo
        del 7% e costi dell'1.5% non è equivalente a un fondo al 5.5% lordo — la differenza
        compone nel tempo producendo scarti significativi su orizzonti lunghi.
      </p>

      <h2>2. Il regime amministrato italiano e la tassazione</h2>
      <p>
        La tassazione degli strumenti finanziari in Italia è regolata dal{" "}
        <strong>Testo Unico delle Imposte sui Redditi (TUIR)</strong> e distingue due grandi
        categorie di reddito finanziario: i <em>redditi di capitale</em> (interessi, dividendi) e
        i <em>redditi diversi</em> (plusvalenze da cessione). Nel regime amministrato — quello
        tipico degli investitori retail che si affidano a un intermediario bancario — le imposte
        sono applicate e versate automaticamente dalla banca, senza necessità di dichiarazione
        fiscale per questi redditi.
      </p>
      <p>
        Le aliquote attualmente in vigore sono:
      </p>
      <ul>
        <li>
          <strong>26%</strong> sui proventi di ETF armonizzati, azioni, fondi comuni e conti
          deposito: è l'aliquota standard per la maggior parte degli strumenti finanziari.
        </li>
        <li>
          <strong>12.5%</strong> sui proventi di titoli di Stato italiani (BTP, BOT, CTZ, CCT)
          e titoli di Stato di Paesi UE e whitelist OCSE con aliquota analoga: l'agevolazione
          riflette la funzione di finanziamento del debito pubblico.
        </li>
      </ul>
      <p>
        Una peculiarità importante del regime amministrato: <strong>non è possibile compensare
        le minusvalenze tra redditi diversi e redditi di capitale</strong>. Le perdite realizzate
        su ETF (redditi diversi) non compensano i guadagni da dividendi o cedole (redditi di
        capitale). Questo asimmetria fiscale è uno dei motivi per cui la pianificazione
        dell'asset allocation deve tenere conto della struttura fiscale degli strumenti.
      </p>
      <p>
        Ai fini del Calcolatore Obiettivi, la tassazione è applicata in modo semplificato
        seguendo il momento in cui l'imposta è dovuta: per il conto deposito il 26% è trattenuto
        sugli interessi quando maturano; per il BTP a tasso fisso il 12,5% è trattenuto sulle
        cedole quando vengono pagate (acquisto alla pari e detenzione fino a scadenza); per l'ETF
        ad accumulazione il 26% colpisce solo la plusvalenza alla vendita
        (<IM>{tex`FV_{\text{lordo}} - \text{totale versato}`}</IM>), perché non ci sono
        distribuzioni intermedie e l'imposta è effettivamente differita.
      </p>

      <h2>3. I tre scenari a confronto: numeri reali</h2>
      <p>
        Confrontiamo i tre strumenti più accessibili all'investitore italiano su un orizzonte
        di 10 anni, con capitale iniziale di €10.000 e versamento mensile di €300.
      </p>

      <h3>Conto deposito vincolato</h3>
      <p>
        I conti deposito vincolati offrono attualmente rendimenti lordi nell'intervallo 3.0-4.5%.
        I costi sono contenuti: sulle somme vincolate l'imposta di bollo è dello 0,20% annuo; sui
        conti deposito liberi si applica invece l'imposta fissa di €34,20/anno sopra €5.000 di
        giacenza media (circa 0,10% su €34.000, il valore usato come ipotesi predefinita nel
        calcolatore). La tassazione è del 26% sugli interessi, trattenuta quando maturano.
        Caratteristica fondamentale: <strong>assenza di rischio di mercato</strong> — il capitale
        nominale è garantito entro i limiti del FITD (€100.000 per depositante per banca).
      </p>

      <h3>BTP e titoli di Stato a tasso fisso</h3>
      <p>
        I BTP offrono rendimenti a scadenza attorno al 3.5-4.5% lordo (ottobre 2025) con
        aliquota agevolata al 12.5%. Rispetto al conto deposito, il vantaggio fiscale è
        significativo: su una plusvalenza di €10.000 la differenza tra 26% e 12.5% è €1.350
        di tasse in meno. Il rischio è il <em>rischio di tasso</em>: se i tassi salgono dopo
        l'acquisto, il valore di mercato del BTP scende. Per chi detiene fino a scadenza,
        questo rischio non si materializza. I costi includono commissioni di intermediazione
        e imposta di bollo sui titoli (0.20% annuo del controvalore).
      </p>

      <h3>ETF azionario globale</h3>
      <p>
        ETF su indici globali come MSCI World o FTSE All-World hanno prodotto rendimenti
        nominali lordi storici intorno al 9-10% annuo negli ultimi 50 anni (fonte: MSCI).
        Al netto di inflazione (2.0-2.5%), il rendimento reale è stato circa 6-7%. I TER
        degli ETF indicizzati sono scesi drasticamente nell'ultimo decennio: gli ETF più
        efficienti si attestano a 0.07-0.20%. Aggiungendo imposta di bollo (0.20%) e
        commissioni broker annualizzate (0.05-0.15%), il costo totale raggiunge 0.30-0.55%.
      </p>
      <p>
        Esempio numerico su 10 anni, capitale €10.000, PAC €300/mese (totale versato €46.000;
        deposito e BTP con imposta trattenuta ogni anno, ETF con imposta alla vendita):
      </p>
      <ul>
        <li>Conto deposito 3,0% lordo, costi 0,10%: netto finale circa <strong>€52.500</strong></li>
        <li>BTP 4,2% lordo, costi 0,25%: netto finale circa <strong>€57.100</strong></li>
        <li>ETF 7,0% lordo, costi 0,40%: netto finale circa <strong>€64.000</strong></li>
      </ul>
      <p>
        La differenza tra BTP e ETF in questo scenario è circa €7.000 su 10 anni, generata dalla
        combinazione di maggiore rendimento lordo ipotizzato e compounding del differenziale. Il
        confronto usa però rendimenti costanti: non rappresenta il rischio, molto più alto per un
        ETF azionario, che può perdere valore anche per anni.
      </p>

      <h2>4. Il costo dei costi: il drag composto</h2>
      <p>
        I costi non sono lineari: si moltiplicano sul rendimento composto e creano un
        <em>drag composto</em>. Formalmente, ogni anno il capitale cresce di{" "}
        <IM>{tex`(1 + r_{\text{lordo}})`}</IM> ma deve anche assorbire il costo{" "}
        <IM>{tex`c`}</IM>, riducendo il tasso effettivo di accumulazione a{" "}
        <IM>{tex`(1 + r_{\text{lordo}} - c)`}</IM>.
      </p>
      <p>
        Su 20 anni, la differenza tra un ETF con TER 0.20% e uno con TER 1.50% su un
        capitale di €50.000 senza ulteriori versamenti (rendimento 7%, capitalizzazione mensile) è di circa <strong>€44.000</strong>.
        Il TER non è l'unico costo da considerare: il <em>tracking error</em> (scostamento
        dall'indice di riferimento), le commissioni di transazione e lo spread bid-ask
        contribuiscono al costo totale di possesso (TCO — Total Cost of Ownership).
      </p>
      <BM>{tex`\text{Danno da costi} = FV(r_{\text{lordo}}) - FV(r_{\text{lordo}} - c)`}</BM>
      <p>
        Dove <IM>{tex`FV(r)`}</IM> è il valore futuro calcolato con tasso <IM>{tex`r`}</IM>.
        Il danno cresce con il quadrato del tempo per orizzonti lunghi, rendendo la minimizzazione
        dei costi uno dei fattori più importanti nella pianificazione a lungo termine.
      </p>

      <h2>5. Tassazione e orizzonte temporale: interazione</h2>
      <p>
        Una proprietà poco discussa della tassazione al realizzo è il suo effetto di{" "}
        <strong>leva sul tempo</strong>. Poiché la tassa è pagata solo alla vendita finale,
        tutta la plusvalenza intermedia compone senza imposte durante l'orizzonte. Questo
        crea un vantaggio implicito rispetto a strumenti dove la tassazione avviene annualmente
        (come i conti deposito, dove l'imposta sugli interessi è applicata ogni anno).
      </p>
      <p>
        Confronto su 20 anni tra tassazione annuale e tassazione al realizzo, stesso rendimento
        lordo 5%, stesso capitale iniziale €20.000:
      </p>
      <ul>
        <li>Tassazione annuale al 26%: tasso netto effettivo = 5% × (1 − 0.26) = <strong>3.70%</strong>/anno</li>
        <li>Tassazione al realizzo: tasso lordo 5% compone per 20 anni, imposta pagata solo a fine periodo</li>
      </ul>
      <p>
        La differenza tra i due approcci su €20.000 in 20 anni è circa €3.100 a favore della
        tassazione differita — pur con la stessa aliquota del 26%. Questo spiega in parte la
        preferenza degli ETF ad <em>accumulo</em> (che reinvestono dividendi senza distribuirli)
        rispetto a quelli a <em>distribuzione</em>, che generano dividendi tassati annualmente.
      </p>

      <h2>6. Pianificare obiettivi concreti: casa, università, emergenza</h2>
      <p>
        L'interesse composto non è solo un concetto astratto: è lo strumento per pianificare
        obiettivi finanziari concreti con una data e un importo definiti.
      </p>
      <h3>Anticipo acquisto casa (7 anni, target €60.000)</h3>
      <p>
        Per accumulare €60.000 netti in 7 anni a partire da €5.000 di capitale iniziale,
        la rata mensile necessaria varia significativamente per scenario:
      </p>
      <ul>
        <li>Conto deposito 3,0%: circa <strong>€598/mese</strong></li>
        <li>BTP 4,2%: circa <strong>€565/mese</strong></li>
        <li>ETF 7,0%: circa <strong>€524/mese</strong></li>
      </ul>
      <p>
        Nelle ipotesi di rendimento costante, la differenza di €74/mese tra deposito ed ETF su
        84 mesi equivale a circa €6.200 di versamenti aggiuntivi per raggiungere lo stesso
        obiettivo — circa 10 rate del deposito. Su un orizzonte di 7 anni, però, un ETF azionario
        può trovarsi in perdita proprio alla scadenza: il confronto non misura questo rischio.
      </p>
      <h3>Fondo universitario figlio (15 anni, target €50.000)</h3>
      <p>
        Su un orizzonte di 15 anni l'effetto del compounding è molto più pronunciato.
        Con capitale iniziale €3.000 e target €50.000 netti:
      </p>
      <ul>
        <li>Conto deposito: circa <strong>€217/mese</strong></li>
        <li>BTP: circa <strong>€191/mese</strong></li>
        <li>ETF: circa <strong>€158/mese</strong></li>
      </ul>
      <p>
        La differenza di €59/mese tra deposito ed ETF su 180 mesi diventa circa €10.600 di
        versamenti in meno con l'ETF per lo stesso risultato finale, sempre con rendimenti
        costanti e senza tenere conto della diversa rischiosità.
      </p>

      <h2>7. Inflazione e rendimento reale</h2>
      <p>
        Tutti i numeri riportati sopra sono <em>nominali</em>: non tengono conto della perdita
        di potere d'acquisto causata dall'inflazione. Il rendimento reale è approssimato da:
      </p>
      <BM>{tex`r_{\text{reale}} \approx r_{\text{nominale}} - \pi`}</BM>
      <p>
        Dove <IM>{tex`\pi`}</IM> è il tasso di inflazione atteso (2.0-2.5% per l'area euro
        nel medio termine secondo le proiezioni BCE). Con un ETF globale al 7% lordo nominale
        e inflazione al 2.5%, il rendimento reale atteso è circa 4.5% al lordo di costi.
      </p>
      <p>
        L'implicazione pratica è che fissare un obiettivo nominale oggi (es. €60.000 per la
        casa in 7 anni) implica accettare che il valore reale di quel capitale sarà circa
        l'84% di €60.000 in euro odierni (<IM>{tex`60.000 / (1.025)^7 \approx 50.500`}</IM>).
        Per pianificare in termini reali, l'obiettivo nominale dovrebbe essere rivalutato
        per l'inflazione attesa: €60.000 × (1.025)⁷ ≈ <strong>€71.300</strong>.
      </p>

      <h2>8. Come usare il Calcolatore Obiettivi</h2>
      <p>
        Il <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
          Calcolatore Obiettivi
        </a> di AlphaFrame applica la matematica descritta in questo articolo in modo interattivo:
      </p>
      <ol>
        <li>
          <strong>Scegli un preset</strong> (Casa, Università, Matrimonio, Auto, Emergenza)
          o inserisci importo e orizzonte personalizzati.
        </li>
        <li>
          <strong>Seleziona la modalità:</strong>
          <ul>
            <li>"Dato il mio versamento" → vedi cosa accumuli in ogni scenario</li>
            <li>"Dato il mio obiettivo" → vedi la rata mensile richiesta per scenario</li>
          </ul>
        </li>
        <li>
          <strong>Impostazioni avanzate</strong>: modifica il rendimento lordo assunto e i
          costi per ogni scenario; attiva l'aggiustamento per inflazione per vedere il
          valore reale del capitale finale.
        </li>
        <li>
          <strong>Interpreta la tabella</strong>: la riga "Imposte pagate" mostra il costo
          fiscale per ogni scenario. Il riquadro di confronto riassume la differenza di rata
          mensile (o di capitale finale) tra lo scenario migliore e il peggiore nelle ipotesi
          impostate, ricordando che il confronto non misura il rischio.
        </li>
      </ol>
      <p>
        Nota: il calcolatore utilizza il tasso mensile composto per simulare i versamenti
        mensili (PAC), applica l'imposta ogni anno su interessi del deposito e cedole del BTP e,
        per l'ETF ad accumulazione, solo sulla plusvalenza alla vendita (regime amministrato);
        non modella gli ETF a distribuzione. Per un'analisi che include simulazioni stocastiche sull'orizzonte
        previdenziale, usa il{" "}
        <a href="https://alphaweb-93f02.web.app/it/tools" target="_blank" rel="noopener noreferrer">
          Calcolatore FIRE
        </a>.
      </p>

      <h2>9. Limiti del modello e assunzioni</h2>
      <ul>
        <li>
          <strong>Rendimento costante:</strong> il modello usa un tasso fisso per ogni scenario.
          Nella realtà i rendimenti di mercato variano anno per anno (volatilità). Per scenari
          stocastici, il Calcolatore FIRE con Block Bootstrap è più appropriato.
        </li>
        <li>
          <strong>Tassazione semplificata:</strong> imposta annuale su interessi e cedole per
          deposito e BTP (BTP acquistato alla pari e tenuto a scadenza), imposta sulla plusvalenza
          totale alla vendita per l'ETF. Per vendite parziali, BTP acquistati sopra o sotto la pari
          o ETF a distribuzione, la logica fiscale è più complessa.
        </li>
        <li>
          <strong>Costi fissi:</strong> i costi annui sono assunti costanti. In realtà i TER
          degli ETF possono variare nel tempo (tendenzialmente in riduzione); le commissioni di
          negoziazione dipendono dal broker scelto.
        </li>
        <li>
          <strong>Inflazione:</strong> il valore reale è un'approssimazione. L'inflazione
          effettiva dipende dal paniere di spesa personale, non dall'indice generale IPCA/CPI.
        </li>
        <li>
          <strong>Rischio:</strong> ETF e BTP comportano rischi di mercato non catturati dal
          modello deterministico. Un crollo del mercato azionario nell'anno di liquidazione
          può ridurre significativamente il valore finale rispetto alla proiezione.
        </li>
      </ul>

      <h2>Riferimenti bibliografici</h2>
      <ol>
        <li>
          Brealey, R., Myers, S., Allen, F. (2020). <em>Principles of Corporate Finance</em>,
          13th ed. McGraw-Hill. — Capitolo sul valore temporale del denaro.
        </li>
        <li>
          Agenzia delle Entrate (2024). <em>Redditi di capitale e redditi diversi di natura
          finanziaria: guida alla fiscalità</em>. Circolare n. 165/E e successive.
        </li>
        <li>
          ESMA (2022). <em>Costs and Performance of EU Retail Investment Products</em>. European
          Securities and Markets Authority. — Analisi comparativa dei costi degli strumenti
          finanziari retail in Europa.
        </li>
        <li>
          Vanguard Research (2023). <em>Putting a Value on Your Value: Quantifying Vanguard
          Advisor's Alpha</em>. Vanguard Group. — Sezione sul costo del TER nel lungo periodo.
        </li>
        <li>
          Bogle, J.C. (2010). <em>Common Sense on Mutual Funds</em>. John Wiley & Sons. —
          Analisi dell'impatto dei costi sui rendimenti composti di lungo periodo.
        </li>
        <li>
          MSCI (2024). <em>MSCI World Index Performance Analytics 1970–2023</em>. MSCI Inc.
          — Dati storici di rendimento nominale e reale dell'indice azionario globale.
        </li>
      </ol>

      <h2>Disclaimer legale</h2>
      <p>
        I contenuti di questo articolo hanno finalità esclusivamente educative e informative.
        I rendimenti e i calcoli presentati si basano su ipotesi semplificate e su dati storici
        che non garantiscono risultati futuri. La tassazione descritta riflette la normativa
        italiana vigente alla data di pubblicazione e può essere soggetta a variazioni legislative.
      </p>
      <p>
        Questo articolo non costituisce consulenza finanziaria personalizzata, raccomandazione
        di investimento, sollecitazione all'acquisto o alla vendita di strumenti finanziari
        ai sensi del D.Lgs. 58/1998 (TUF) e della Direttiva MiFID II. Le simulazioni numeriche
        sono scenari ipotetici elaborati a scopo illustrativo.
      </p>
      <p>
        Prima di prendere decisioni di investimento rilevanti è opportuno confrontarsi con un
        consulente finanziario indipendente abilitato, che possa tenere conto della situazione
        fiscale, patrimoniale e degli obiettivi personali. AlphaFrame Analytics non si assume
        alcuna responsabilità per decisioni prese sulla base dei contenuti di questo articolo
        o degli output del calcolatore.
      </p>
    </div>
  ),
};

// ─────────────────────────────────────────────────────────────────────────────
// NUOVI ARTICOLI KB — batch: cluster Derivati (pillar + 3 spoke) + Metriche + Market Update
// (Serie/indice "Serie" volutamente NON creata: parcheggiata.)
// ─────────────────────────────────────────────────────────────────────────────
const KB_DISC = {
  fontSize: "0.9rem",
  color: "#475569",
  borderLeft: "3px solid #cbd5e1",
  padding: "0.5rem 0 0.5rem 0.85rem",
  margin: "0 0 1.25rem",
};
const KB_FIG = { margin: "1.5rem 0" };
const KB_IMG = { width: "100%", height: "auto", borderRadius: "10px", border: "1px solid #e2e8f0" };
const KB_CAP = { fontSize: "0.88rem", color: "#475569", marginTop: "0.5rem", lineHeight: 1.5 };

const newKbArticlesIT = [
  {
    slug: "derivati-spiegati-semplice",
    title: "Derivati: cosa sono e come funzionano (guida completa)",
    metaDescription:
      "Cosa sono i derivati finanziari, come funzionano forward, future, opzioni e swap, la differenza fra mercati regolamentati e OTC, e i tre scopi: copertura, speculazione, arbitraggio. Guida educativa con video.",
    tags: ["derivati", "future", "opzioni", "educazione", "mercati"],
    readTime: "11 min",
    author: "Redazione",
    datePublished: "2026-06-25",
    dateUpdated: "2026-10-15",
    coverImage: CoverDerivatiPillar,
    canonical: `${DOMAIN}/kb/derivati-spiegati-semplice`,
    content: (
      <div>
        <h1>Derivati: cosa sono e come funzionano (guida completa)</h1>

        <p style={KB_DISC}>
          Contenuto a scopo esclusivamente educativo e informativo. Non costituisce consulenza
          personalizzata, raccomandazione né sollecitazione all'investimento. I derivati sono
          strumenti complessi e possono comportare perdite anche superiori al capitale investito.
        </p>

        <h2>Introduzione: cosa significa "derivato"</h2>
        <p>
          Un derivato è un contratto il cui valore <strong>deriva</strong> dall'andamento di
          un'altra grandezza, il <em>sottostante</em>: un'azione, un indice, una materia prima, un
          tasso d'interesse, una valuta. Non si compra il bene: si compra (o si vende) un accordo su
          come si comporterà il suo prezzo entro una certa data. È questa la natura comune a tutti i
          derivati — forward, future, opzioni, swap — al di là delle differenze tecniche.
        </p>
        <p>
          Perché esistono? In origine per un motivo solo: <strong>trasferire un rischio</strong> da
          chi non lo vuole a chi è disposto ad assumerlo. L'agricoltore che fissa oggi il prezzo del
          grano del prossimo raccolto si protegge da un calo; chi gli sta dall'altra parte si assume
          quel rischio. Da questo nucleo nascono i tre usi che vedremo: copertura, speculazione,
          arbitraggio.
        </p>

        <YouTubeEmbed
          videoId="L3JzHjZ6X2Q"
          title="Derivati spiegati semplice: hedging, speculazione, arbitraggio"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <YouTubeEmbed
          playlistId="PL4Ivcohv28tL4Y3JRgC9L6NsQElpKSyQH"
          title="Strumenti derivati — la serie completa (playlist)"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />
        <p>
          Tutti gli episodi pubblicati, ciascuno con una scheda (concetti chiave, esempio numerico,
          rischi), sono nella pagina della serie{" "}
          <a href="/it/series/derivati">Strumenti derivati</a>.
        </p>

        <h2>I quattro mattoni</h2>
        <ul>
          <li>
            <strong>Forward</strong> — accordo privato per comprare/vendere il sottostante a un
            prezzo e a una data futuri fissati oggi. Flessibile ma "su misura": lo paghi in rischio
            di controparte. Come si forma il suo prezzo → vedi{" "}
            <a href="/it/series/derivati#ep-5">episodio 5, il cost of carry</a>.
          </li>
          <li>
            <strong>Future</strong> — è il forward <em>standardizzato</em> e quotato in borsa, con
            una stanza di compensazione (clearing house) che si interpone e azzera il rischio che la
            controparte non paghi. → vedi{" "}
            <a href="/it/kb/derivati-futures-come-funzionano">Futures — Parte 1: come funzionano</a>.
          </li>
          <li>
            <strong>Opzione</strong> — dà il <em>diritto</em>, non l'obbligo, di comprare (call) o
            vendere (put) il sottostante a un prezzo prefissato. Chi la compra paga un premio; chi la
            vende incassa il premio ma assume l'obbligo. → vedi gli{" "}
            <a href="/it/series/derivati#ep-8">episodi 8, 9 e 10</a> della serie.
          </li>
          <li>
            <strong>Swap</strong> — scambio di flussi nel tempo (es. tasso fisso contro variabile, o
            due valute). È il mattone alla base di molta finanza d'impresa e bancaria. → vedi l'
            <a href="/it/series/derivati#ep-7">episodio 7</a>.
          </li>
        </ul>

        <h2>Dove si scambiano: mercati regolamentati vs OTC</h2>
        <ul>
          <li>
            <strong>Mercato regolamentato (exchange):</strong> contratti standardizzati, prezzi
            trasparenti, clearing house che garantisce le posizioni. È il mondo dei future e di molte
            opzioni.
          </li>
          <li>
            <strong>OTC (over-the-counter):</strong> contratti bilaterali "su misura" negoziati fuori
            borsa. Massima flessibilità, ma il rischio che la controparte salti è in capo a te — la
            lezione di Lehman Brothers (2008) nasce proprio qui. Ne parla l'
            <a href="/it/series/derivati#ep-1">episodio 1</a> della serie.
          </li>
        </ul>

        <h2>A cosa servono davvero: i tre scopi</h2>
        <ol>
          <li>
            <strong>Copertura (hedging)</strong> — ridurre un rischio che già hai. Esempio: un
            esportatore europeo che incasserà dollari fra sei mesi può fissare oggi il cambio con un
            forward, eliminando l'incertezza valutaria. (Stesso meccanismo dietro gli ETF "hedged" →
            vedi{" "}
            <a href="/it/kb/copertura-valutaria-etf-hedged-vs-unhedged">
              Copertura valutaria: ETF hedged vs unhedged
            </a>
            .)
          </li>
          <li>
            <strong>Speculazione</strong> — assumere un rischio per cercare un profitto da un
            movimento atteso. La leva amplifica guadagni <em>e</em> perdite: è qui che i derivati
            diventano pericolosi se usati senza capirne il funzionamento.
          </li>
          <li>
            <strong>Arbitraggio</strong> — sfruttare disallineamenti di prezzo fra mercati per un
            profitto teoricamente senza rischio. In pratica le finestre sono minime e si chiudono in
            fretta.
          </li>
        </ol>

        <h2>Prodotti derivati per il risparmiatore: certificati e covered warrant</h2>
        <p>
          Sul mercato retail i derivati arrivano "impacchettati": <strong>certificati</strong> e{" "}
          <strong>covered warrant</strong> sono strumenti cartolarizzati emessi da banche, con
          profili di rischio, fiscalità ed efficienza molto diversi fra loro. Vanno capiti prima di
          toccarli. → vedi{" "}
          <a href="/it/kb/certificati-covered-warrant">
            Certificati e covered warrant: cosa sono e come si tassano
          </a>
          .
        </p>

        <h2>Errori e rischi da conoscere</h2>
        <ul>
          <li>
            <strong>Leva</strong> = un piccolo movimento del sottostante diventa un grande movimento
            sul tuo capitale, in entrambe le direzioni.
          </li>
          <li>
            <strong>Rischio di controparte</strong> (soprattutto OTC) = il contratto vale quanto vale
            chi te lo ha venduto.
          </li>
          <li>
            <strong>Complessità</strong> = un derivato mal compreso è un rischio mal compreso. Regola
            educativa: se non sai spiegarne il payoff, non sei pronto a usarlo.
          </li>
        </ul>

        <h2>Conclusione</h2>
        <p>
          I derivati non sono né buoni né cattivi: sono strumenti di trasferimento del rischio. Lo
          stesso future che protegge un'azienda può rovinare uno speculatore in leva. La differenza è
          la comprensione.
        </p>

        <h3>Continua nella serie sui derivati</h3>
        <ul>
          <li>
            <a href="/it/series/derivati">La serie video completa</a>, con una scheda per episodio
          </li>
          <li>
            <a href="/it/kb/derivati-concetti-chiave">Gli otto passaggi chiave della serie</a>, dal
            future a Black-Scholes
          </li>
          <li>
            <a href="/it/kb/derivati-futures-come-funzionano">Futures — Parte 1: come funzionano</a>{" "}
            (margini, mark-to-market, leva)
          </li>
          <li>
            <a href="/it/kb/derivati-futures-coperture-hedge-ratio">
              Futures — Parte 2: coprirsi davvero
            </a>{" "}
            (hedge ratio e basis risk)
          </li>
          <li>
            <a href="/it/kb/certificati-covered-warrant">Certificati e covered warrant</a>
          </li>
        </ul>

        <h2>Fonti</h2>
        <p>
          Borsa Italiana — Glossario · CONSOB — area educativa derivati · J. Hull, <em>Options,
          Futures and Other Derivatives</em> · BIS — statistiche mercato OTC.
        </p>

        <p style={KB_DISC}>
          Le informazioni hanno scopo esclusivamente educativo. Non costituiscono raccomandazione né
          consulenza personalizzata. Le performance passate non garantiscono risultati futuri.
        </p>
      </div>
    ),
  },

  {
    slug: "derivati-futures-come-funzionano",
    title: "Futures — Parte 1: come funzionano (margini, mark-to-market, consegna)",
    metaDescription:
      "Come funziona un future: standardizzazione, margine come performance bond, mark-to-market giornaliero, leva (esempio reale) e da dove nasce il prezzo (cash-and-carry). Parte 1 di 2.",
    tags: ["derivati", "future", "margini", "leva", "educazione"],
    readTime: "10 min",
    author: "Redazione",
    datePublished: "2026-06-25",
    dateUpdated: "2026-06-25",
    coverImage: CoverFutures1,
    canonical: `${DOMAIN}/kb/derivati-futures-come-funzionano`,
    content: (
      <div>
        <h1>Futures — Parte 1: come funzionano (margini, mark-to-market, consegna)</h1>

        <p style={KB_DISC}>
          Contenuto educativo. I future sono strumenti a leva: possono comportare perdite superiori
          al capitale versato. Nessuna raccomandazione.
        </p>

        <p>
          ⟵ Parti dal <a href="/it/kb/derivati-spiegati-semplice">pillar sui derivati</a> · Vai alla{" "}
          <a href="/it/kb/derivati-futures-coperture-hedge-ratio">Parte 2: coprirsi con i futures</a> ⟶
        </p>

        <h2>Non un investimento, uno strumento</h2>
        <p>
          Un derivato non è un investimento "primario": è uno <strong>strumento</strong> per tre
          scopi — esposizione, trasferimento del rischio, leva. Il future è il più lineare di questi
          strumenti, e capirne la meccanica è il prerequisito per tutto il resto.
        </p>

        <YouTubeEmbed
          videoId="zvbVoKEoZIY"
          title="Futures: margini, mark-to-market e consegna"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>Standardizzazione = liquidità + efficienza operativa</h2>
        <p>
          Il future è un forward <strong>standardizzato</strong>: dimensione del contratto, modalità
          di consegna (o regolamento in contanti) e scadenza sono fissi. È proprio questa uniformità
          a renderlo scambiabile su borse organizzate (CME, CBOE, CBT) con <strong>scala e
          liquidità</strong>. Per chi gestisce portafogli grandi è un vantaggio enorme: per
          modificare l'esposizione azionaria di un fondo, invece di muovere migliaia di posizioni in
          singoli titoli, si usa un future — <strong>stessa esposizione, costi di transazione minimi,
          regolamento in giornata</strong>, senza toccare le posizioni di lungo periodo. È
          "ingegneria di portafoglio": si modula duration o beta senza smontare nulla.
        </p>

        <h2>L'obbligazione reciproca (e perché serve il mark-to-market)</h2>
        <p>
          La differenza chiave dei future rispetto alle opzioni è una sola parola:{" "}
          <strong>obbligazione</strong>. In un future <em>entrambe</em> le parti sono vincolate — il
          compratore a ritirare/regolare, il venditore a consegnare/regolare. Questo vincolo reciproco
          rende il <strong>rischio di default</strong> centrale, e si gestisce con il{" "}
          <strong>mark-to-market giornaliero</strong>: profitti e perdite vengono realizzati e
          trasferiti tra le parti <em>ogni giorno</em>. Se il mercato si muove contro di te, devi
          versare subito; non esiste un debito che si accumula in silenzio fino a scadenza.
        </p>

        <h2>Il margine come "performance bond", e la leva</h2>
        <p>
          Aprendo una posizione non versi il valore pieno del contratto, ma un{" "}
          <strong>margine iniziale</strong>: una cauzione, tipicamente il <strong>2-10%</strong> del
          valore. È qui che nasce la leva. Esempio: un contratto da <strong>$200.000</strong> con
          margine <strong>$6.000</strong> → un movimento dell'<strong>1%</strong> del sottostante
          (±$2.000) vale circa <strong>±17-18% sul margine</strong>; il fattore di leva può superare{" "}
          <strong>35:1</strong>. Efficienza di capitale enorme, ma a una condizione: il monitoraggio
          quotidiano dei flussi. Nel momento in cui non rispondi a una <strong>margin call</strong>,
          la posizione viene liquidata d'ufficio, senza discussioni.
        </p>

        <h2>Da dove nasce il prezzo: il "cost of carry"</h2>
        <p>Il prezzo di un future non è arbitrario: è il <strong>costo di portare</strong> l'asset fino a scadenza.</p>
        <p><code>F = S + interessi (costo opportunità) − redditi (dividendi/cedole)</code></p>
        <p>
          Se il costo di carry è positivo, il future quota <em>sopra</em> lo spot (situazione detta{" "}
          <strong>contango</strong>). A tenere il prezzo allineato è l'<strong>arbitraggio
          cash-and-carry</strong>: se il future è troppo caro, un operatore compra l'asset a pronti,
          vende il future e finanzia l'acquisto al tasso privo di rischio, incassando un profitto
          certo finché la pressione non riporta i prezzi in equilibrio. È questo meccanismo, attivo
          ogni secondo, che impedisce profitti "gratis" e rende il mercato efficiente.
        </p>

        <h2>Il cost of carry per classe di attivo</h2>
        <p>La formula generale resta, ma cambia secondo il tipo di sottostante:</p>
        <ul>
          <li>
            <strong>Indici azionari:</strong> <code>F = indice + interessi − dividendi attesi</code> —
            i dividendi del paniere riducono il costo di carry e possono portare il future <em>sotto</em>
            lo spot.
          </li>
          <li>
            <strong>Titoli di Stato:</strong> entra la logica del <em>cheapest-to-deliver</em> — fra i
            titoli consegnabili, chi vende sceglie il più conveniente, e questo guida il prezzo del
            future.
          </li>
          <li>
            <strong>Valute:</strong> il carry è il <em>differenziale dei tassi</em> tra le due divise
            (parità coperta dei tassi d'interesse): il future sul cambio sconta il vantaggio o lo
            svantaggio di tasso.
          </li>
          <li>
            <strong>Materie prime:</strong> agli interessi si aggiungono i costi di stoccaggio e
            l'eventuale <em>convenience yield</em> del detenere il bene fisico.
          </li>
        </ul>

        <h2>La margin call, in pratica</h2>
        <p>
          Riprendiamo l'esempio: contratto da $200.000, margine iniziale $6.000. Il broker fissa anche
          un <strong>margine di mantenimento</strong> (poniamo $4.500). Se alcune sedute storte erodono
          il margine sotto quella soglia — diciamo a $4.200 — scatta la <strong>margin call</strong>:
          devi riportare il conto al margine iniziale (versare circa $1.800), <em>subito</em>. Se non
          lo fai, la posizione viene chiusa d'ufficio al prezzo di mercato, cristallizzando la perdita.
          È il motivo per cui la leva richiede <strong>liquidità di riserva</strong>, non solo una tesi
          corretta: puoi avere ragione sul lungo periodo ed essere comunque liquidato nel breve.
        </p>

        <h2>In sintesi</h2>
        <p>
          Standardizzazione (liquidità + efficienza), obbligazione reciproca (gestita col
          mark-to-market), margine come cauzione che genera <strong>leva</strong> (e margin call che
          liquida), prezzo = cost of carry. Capito <em>come</em> funziona, nella{" "}
          <a href="/it/kb/derivati-futures-coperture-hedge-ratio">Parte 2</a> vediamo l'uso che
          conta: <strong>coprire un rischio</strong> — e perché nessuna copertura è perfetta.
        </p>

        <h2>Fonti</h2>
        <p>
          J. Hull, <em>Options, Futures and Other Derivatives</em> · CME Group — education · Borsa
          Italiana — glossario.
        </p>

        <p style={KB_DISC}>
          Contenuto educativo, non raccomandazione. La leva può comportare perdite eccedenti il
          capitale.
        </p>
      </div>
    ),
  },

  {
    slug: "derivati-futures-coperture-hedge-ratio",
    title: "Futures — Parte 2: coprirsi davvero (hedge ratio e basis risk)",
    metaDescription:
      "Coprire con i futures: la base e la convergenza, il rapporto di copertura a varianza minima, cross-hedging, controllo sintetico di beta e duration, e la scelta tra stack e strip hedge. Parte 2 di 2.",
    tags: ["derivati", "future", "hedging", "rischio", "educazione"],
    readTime: "11 min",
    author: "Redazione",
    datePublished: "2026-06-25",
    dateUpdated: "2026-06-25",
    coverImage: CoverFutures2,
    canonical: `${DOMAIN}/kb/derivati-futures-coperture-hedge-ratio`,
    content: (
      <div>
        <h1>Futures — Parte 2: coprirsi davvero (hedge ratio e basis risk)</h1>

        <p style={KB_DISC}>
          Contenuto educativo. La copertura riduce un rischio ma ne introduce altri (base, leva).
          Nessuna raccomandazione.
        </p>

        <p>
          ⟵ <a href="/it/kb/derivati-futures-come-funzionano">Parte 1: come funzionano i futures</a> ·
          Torna al <a href="/it/kb/derivati-spiegati-semplice">pillar</a>
        </p>

        <h2>Coprire trasforma il rischio, non lo elimina</h2>
        <p>
          Nella <a href="/it/kb/derivati-futures-come-funzionano">Parte 1</a> abbiamo visto{" "}
          <em>come</em> funziona un future. Qui l'uso che conta: la <strong>copertura</strong>.
          Quando copri un'esposizione con un future di segno opposto, <strong>blocchi</strong> un
          prezzo di vendita futuro pari a <em>prezzo del future iniziale + base finale</em>. Detto
          altrimenti: non azzeri il rischio, lo <strong>trasformi</strong> da rischio di prezzo pieno
          (ingestibile) a <strong>basis risk</strong> (piccolo e gestibile).
        </p>

        <YouTubeEmbed
          videoId="tc4Jq1dK9fI"
          title="Coprirsi davvero con i futures: hedge ratio e basis risk"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>La base e la convergenza</h2>
        <p>
          La <strong>base</strong> è la differenza tra prezzo a pronti e prezzo del future:{" "}
          <code>base = S − F</code>. Non è casuale: è il <strong>costo di carry</strong> (Parte 1).
          Il principio chiave per chi copre è la <strong>convergenza</strong>: avvicinandosi alla
          scadenza la base si restringe a zero — a scadenza <code>S = F</code>. Nel frattempo, però,
          la base oscilla, ed è qui il rischio residuo. In senso rigoroso <em>coprire è una scommessa
          sulla base</em>: stai speculando sul modo in cui il cost of carry si muoverà nel tempo.
          Questo è il <strong>basis risk</strong>: il motivo per cui nessuna copertura è perfetta.
        </p>

        <h2>L'hedge ratio a varianza minima: quanti contratti</h2>
        <p>
          Una copertura "uno a uno" presume che il tuo asset e il future si muovano identici
          (correlazione = 1): quasi mai vero. Il <strong>rapporto di copertura a varianza
          minima</strong> corregge per questo:
        </p>
        <p><code>h = ρ · (σ_S / σ_F)</code> — (posizione di segno opposto all'esposizione)</p>
        <p>
          dove <code>ρ</code> è la correlazione tra le variazioni del tuo asset (S) e del future (F).
          È, di fatto, il <strong>beta</strong> della tua esposizione rispetto al future.{" "}
          <strong>Esempio:</strong> asset meno volatile del future (σ_S/σ_F = 0,8) e correlazione 0,9
          → <code>h = 0,72</code>: copri il <strong>72%</strong> del nozionale, non il 100%. Quando{" "}
          <code>ρ &lt; 1</code> resta un rischio residuo (la varianza non coperta) pari a{" "}
          <code>σ_S² · (1 − ρ²)</code>: la copertura ha <em>minimizzato</em>, non cancellato, il
          rischio.
        </p>

        <h2>Cross-hedging: quando il future esatto non esiste</h2>
        <p>
          Spesso non c'è un future sul tuo asset specifico: si copre con un sottostante{" "}
          <strong>correlato ma di classe diversa</strong> — es. un portafoglio di obbligazioni
          corporate coperto con future su titoli di Stato. Funziona quanto è alta e stabile la
          correlazione; è esattamente lì che vive il basis risk.
        </p>

        <h2>Controllare beta e duration senza toccare il portafoglio</h2>
        <p>
          La stessa logica permette il <strong>controllo sintetico</strong> del rischio. Per
          l'azionario, l'hedge ratio si aggiusta per il <strong>beta</strong> del portafoglio
          rispetto al future sull'indice: calcoli il numero esatto di contratti per portare il rischio
          dal profilo attuale a quello desiderato — senza vendere un solo titolo. Per il reddito fisso
          si ragiona in <strong>duration</strong>: per ridurre la duration a un target, calcoli quanti
          future su obbligazioni servono ad accorciare la sensibilità ai tassi.
        </p>

        <h2>La scelta operativa: stack hedge vs strip hedge</h2>
        <ul>
          <li>
            <strong>Stack hedge</strong> — apri tutta la posizione sul contratto più{" "}
            <strong>lontano</strong> e la tieni. Semplice; ti espone <em>solo</em> al basis risk a
            scadenza. Ma il contratto lontano è spesso meno liquido.
          </li>
          <li>
            <strong>Strip hedge</strong> — parti dal contratto <strong>vicino</strong> e poi{" "}
            <strong>rolli</strong> (chiudi il vicino, apri il successivo), ripetendo fino
            all'orizzonte. Più aderente, ma ti espone al <strong>rollover risk</strong>: il prezzo
            finale dipende dal <em>calendar spread</em> al momento del roll.
          </li>
        </ul>
        <p>
          Non c'è una risposta giusta: scegli tra la <strong>certezza di un basis risk noto</strong>{" "}
          (stack) e il <strong>rischio di tassi futuri ignoti sul costo del roll</strong> (strip). È
          un giudizio sul tuo scenario.
        </p>

        <h2>In sintesi</h2>
        <p>
          Coprire = trasformare il rischio in <strong>basis risk</strong>; la base converge a zero a
          scadenza; l'<strong>hedge ratio a varianza minima</strong> (<code>ρ·σ_S/σ_F</code>) dice{" "}
          <em>quanto</em> coprire; il <strong>cross-hedge</strong> serve quando il future esatto non
          c'è; beta e duration si controllano <strong>sinteticamente</strong>; stack vs strip è la
          scelta operativa. La copertura non elimina il rischio: lo <strong>riduce e lo rende
          gestibile</strong>. Tutto parte dal{" "}
          <a href="/it/kb/derivati-spiegati-semplice">pillar sui derivati</a>.
        </p>

        <h2>Fonti</h2>
        <p>
          J. Hull, <em>Options, Futures and Other Derivatives</em> (minimum-variance hedge ratio,
          basis) · CME Group — education · Borsa Italiana — glossario.
        </p>

        <p style={KB_DISC}>
          Contenuto educativo, non raccomandazione. Le performance passate non garantiscono risultati
          futuri.
        </p>
      </div>
    ),
  },

  {
    slug: "certificati-covered-warrant",
    title: "Certificati e covered warrant: cosa sono e come funzionano",
    metaDescription:
      "Cosa sono i certificati (e perché sono obbligazioni con un rischio emittente), l'efficienza fiscale delle minusvalenze, e i covered warrant spiegati con le greche delta e theta. Guida educativa con video.",
    tags: ["derivati", "certificati", "covered warrant", "fiscalità", "educazione"],
    readTime: "12 min",
    author: "Redazione",
    datePublished: "2026-06-25",
    dateUpdated: "2026-06-25",
    coverImage: CoverCertificati,
    canonical: `${DOMAIN}/kb/certificati-covered-warrant`,
    content: (
      <div>
        <h1>Certificati e covered warrant: cosa sono e come funzionano</h1>

        <p style={KB_DISC}>
          Contenuto educativo e informativo. Gli esempi numerici (incluso il caso AXA) provengono da
          documentazione tecnica di settore e servono a illustrare un meccanismo: non sono
          raccomandazioni né previsioni. Certificati e covered warrant sono strumenti complessi.
        </p>

        <h2>Due strumenti per due problemi diversi</h2>
        <p>
          Davanti a un portafoglio con posizioni in rosso, o alla paura di una correzione,
          l'investitore evoluto apre la cassetta degli attrezzi. Dentro ci sono due famiglie spesso
          confuse: i <strong>certificati</strong>, strumenti di <em>precisione</em> per costruire un
          risultato su misura, e i <strong>covered warrant</strong>, strumenti di <em>potenza</em>{" "}
          per esposizione a leva e coperture. Non è questione di quale sia migliore: è questione di
          quale sia giusto per il lavoro da fare.
        </p>

        <YouTubeEmbed
          videoId="ZiyVLk1EPCI"
          title="Certificati vs Covered Warrant: gestione rischio ed efficienza fiscale"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>Certificati: prima di tutto, sono obbligazioni</h2>
        <p>
          La cosa più importante da mettere a fuoco non è il rendimento, ma la{" "}
          <strong>natura giuridica</strong>: un certificato è un'<strong>obbligazione senior non
          garantita</strong> dell'emittente. Tradotto: il primo rischio non è il mercato, è il{" "}
          <strong>rischio emittente</strong> — se la banca che lo emette fallisce, l'investimento è a
          rischio, a prescindere da come va il sottostante.
        </p>
        <p>
          <strong>Il mercato è cambiato.</strong> Tra il 2010 e il 2021 (dati ACEPI) i certificati{" "}
          <em>Express</em> — che nel 2013 erano quasi l'<strong>80%</strong> del collocato — sono
          crollati al <strong>36%</strong> nel 2021, mentre i <em>Cash Collect</em> sono passati
          quasi dal nulla a circa <strong>metà</strong> del mercato. In pratica gli investitori hanno
          scambiato il "jackpot" di un Express per lo "stipendio periodico" di un Cash Collect:{" "}
          <strong>la certezza è diventata il nuovo oro</strong>.
        </p>

        <h2>L'arma nascosta: l'efficienza fiscale</h2>
        <p>
          I proventi dei certificati (cedole <em>e</em> guadagni in conto capitale) sono classificati
          come <strong>redditi diversi</strong>. L'aliquota è il 26% come altrove, ma — a differenza
          di dividendi azionari e cedole obbligazionarie, che sono <em>redditi da capitale</em> — i
          redditi diversi <strong>compensano le minusvalenze pregresse</strong> (lo "zainetto
          fiscale") generate da azioni, ETF, derivati, altri certificati. Per chi ha perdite
          accumulate, un certificato che genera plusvalenze diventa uno <strong>strumento
          tattico</strong> per recuperare quelle perdite a fine anno.
        </p>

        <h2>Perché la paura sul mercato "aiuta" l'emittente</h2>
        <p>
          Il prezzo di un certificato nasce dalle opzioni che lo compongono, e il loro costo dipende
          dalla <strong>volatilità</strong>. Quando la volatilità esplode — i picchi del VIX — il
          costo delle opzioni sale, e per chi <em>vende</em> opzioni all'investitore (l'emittente) è
          un'opportunità: può offrire <strong>cedole più ricche o barriere di protezione più
          profonde</strong>. Un momento di panico può quindi essere il momento migliore per emettere
          certi prodotti. (Per gestire l'incertezza dei dividendi sono nati gli <strong>indici{" "}
          <em>decrement</em></strong>: un dividendo sintetico fisso sottratto ogni giorno, così il
          pricing è prevedibile.)
        </p>

        <h2>Il caso AXA: ristrutturare una posizione in perdita</h2>
        <p>
          La documentazione ACEPI propone un esempio concreto. Un investitore ha azioni AXA con una
          perdita del <strong>−9%</strong>: per tornare in pari il titolo dovrebbe risalire di quasi
          il 10%. La strategia <em>recovery</em>: vendere l'azione (cristallizzando la minusvalenza,
          che potrà essere compensata) e comprare un <strong>Cash Collect Memory</strong> sulla stessa
          AXA — prezzo €91,16, sottostante a €15,02, <strong>barriera a €10,33</strong> (un cuscinetto
          di oltre il <strong>31%</strong>), premio <strong>5,85%</strong> con effetto memoria. Lo
          scenario chiave: se a scadenza AXA è fermo <em>o anche sceso ma sopra la barriera</em>, il
          certificato rimborsa 100 più tutte le cedole → rendimento del <strong>41,78%</strong> su un
          titolo che non si è mosso.
        </p>
        <p>
          <strong>Il compromesso è il cuore di tutto:</strong> si rinuncia ai dividendi e a{" "}
          <em>qualsiasi</em> rialzo oltre il rendimento predeterminato. Si scambia un{" "}
          <strong>upside illimitato ma incerto</strong> con un <strong>rendimento definito ad alta
          probabilità</strong>. È questo il senso del certificato: strutturare un risultato specifico.
        </p>

        <h2>Covered warrant: opzioni cartolarizzate, leva pura</h2>
        <p>
          A differenza dei warrant classici, i <strong>covered warrant</strong> sono creati da
          istituzioni finanziarie su attività già quotate: in sostanza <strong>opzioni
          cartolarizzate</strong> accessibili a tutti — un <em>call</em> dà il diritto di comprare, un{" "}
          <em>put</em> di vendere. Per non schiantarsi servono due "comandi":
        </p>
        <ul>
          <li>
            <strong>Delta = il tachimetro.</strong> Quanto si muove il warrant al variare del
            sottostante. Delta 0,5: l'azione sale di €1, il call sale di €0,50.
          </li>
          <li>
            <strong>Theta = il carburante.</strong> Quanto valore il warrant <strong>brucia ogni
            giorno</strong> solo per il passare del tempo. Puoi avere ragione sulla direzione, ma se
            il movimento è troppo lento il theta ti mangia il guadagno.
          </li>
        </ul>
        <p>
          Due greche di secondo livello completano il quadro: il <strong>gamma</strong>{" "}
          (l'accelerazione, massimo <em>at-the-money</em>) e il <strong>vega</strong> (la sensibilità
          alla volatilità). Attenzione alla leva: il <em>gearing</em> è un dato grezzo; la misura vera
          è l'<strong>elasticità = gearing × delta</strong>.
        </p>

        <h2>Usarli per difendersi: il protective put</h2>
        <ul>
          <li>
            <strong>Statico</strong> — la "polizza taglia unica": su un portafoglio da €650.000
            servono ~1.000 warrant per una copertura 1:1 a scadenza. Semplice, ma imprecisa lungo la
            vita.
          </li>
          <li>
            <strong>Dinamico (delta hedging)</strong> — copertura calcolata col delta (es. delta 0,4 →
            ~2.500 warrant): più precisa, ma richiede monitoraggio e aggiustamenti costanti.
          </li>
        </ul>

        <h2>In sintesi</h2>
        <ul>
          <li>
            <strong>Certificati</strong> = precisione: recupero, reddito, efficienza fiscale.
            Costruiscono un <em>payoff specifico</em>.
          </li>
          <li>
            <strong>Covered warrant</strong> = potenza: leva e coperture, ma vanno capiti nelle loro
            dinamiche per non farsi male.
          </li>
        </ul>
        <p>
          Riparti dalle basi nel{" "}
          <a href="/it/kb/derivati-spiegati-semplice">pillar sui derivati</a>, o vedi come la
          copertura entra negli ETF in{" "}
          <a href="/it/kb/copertura-valutaria-etf-hedged-vs-unhedged">hedged vs unhedged</a>.
        </p>

        <h2>Fonti</h2>
        <p>
          ACEPI — presentazione tecnica e caso studio · Goldman Sachs — manuale operativo sui covered
          warrant · Borsa Italiana — glossario.
        </p>

        <p style={KB_DISC}>
          Esempi illustrativi a scopo educativo, non raccomandazioni. Il rischio emittente e la leva
          possono comportare perdite, anche totali. Le performance passate non garantiscono risultati
          futuri.
        </p>
      </div>
    ),
  },

  {
    slug: "metriche-di-portafoglio",
    title: "Come si misura un investimento: rendimento, rischio e metriche di portafoglio",
    metaDescription:
      "CAGR, drawdown, Sharpe, Sortino, Calmar, capture ratio, alfa e beta, backtest onesto e rendimento netto: ogni metrica con formula, significato ed esempio numerico. Guida quantitativa per investitori.",
    tags: ["metriche", "rischio", "sharpe", "backtest", "quant", "educazione"],
    readTime: "15 min",
    author: "Redazione",
    datePublished: "2026-06-25",
    dateUpdated: "2026-06-25",
    coverImage: CoverMetriche,
    canonical: `${DOMAIN}/kb/metriche-di-portafoglio`,
    content: (
      <div>
        <h1>Come si misura un investimento: rendimento, rischio e metriche di portafoglio</h1>

        <p style={KB_DISC}>
          Contenuto educativo e metodologico. Le formule e gli esempi servono a spiegare <em>come si
          misura</em> un investimento, non a raccomandarne alcuno. Le performance passate non
          garantiscono risultati futuri.
        </p>

        {/* TODO: quando uscirà, embeddare la playlist "Metriche Finanziarie di Portfolio Management" (IT) / "Portfolio Financial Metrics" (EN) con <YouTubeEmbed playlistId="..." /> */}

        <h2>Perché le metriche, e perché queste</h2>
        <p>
          Un rendimento da solo non dice quasi nulla: +30% ottenuto rischiando di perdere metà del
          capitale non è lo stesso +30% ottenuto con oscillazioni modeste. Misurare bene significa
          separare il <strong>rendimento</strong>, il <strong>rischio</strong>, e la{" "}
          <strong>qualità del processo</strong> che li ha prodotti. Sono anche le metriche che usiamo
          negli aggiornamenti mensili e nel monitoraggio dei modelli.
        </p>

        <h2>1. CAGR vs media aritmetica — il rendimento che conta davvero</h2>
        <p>La media aritmetica dei rendimenti <strong>inganna</strong>. Il <strong>CAGR</strong> (tasso di crescita composto) è l'unico che riflette la ricchezza reale:</p>
        <p><code>CAGR = (V_finale / V_iniziale)^(1/n) − 1</code></p>
        <p>
          <strong>Esempio:</strong> +50% un anno, −50% l'anno dopo. Media aritmetica = 0%. Ma 100 →
          150 → 75: hai <strong>perso il 25%</strong>. Il CAGR è <code>(0,75)^(1/2) − 1 ≈ −13,4%</code>.
          La differenza è il <em>drag da volatilità</em>.
        </p>

        <h2>2. Drawdown, semivarianza, tempo di recupero — quanto male può andare</h2>
        <ul>
          <li>
            <strong>Massimo drawdown (MDD):</strong> la peggior caduta da un picco a una valle. Da 100
            a 60 → MDD = <strong>−40%</strong>.
          </li>
          <li>
            <strong>Semivarianza / downside deviation:</strong> misura solo gli scarti{" "}
            <strong>sotto</strong> una soglia: <code>σ_down = √( media( min(r − MAR, 0)² ) )</code>.
          </li>
          <li>
            <strong>Tempo di recupero (TTR):</strong> un −50% richiede un <strong>+100%</strong> per
            recuperare; al 7% annuo composto sono circa <strong>10 anni</strong>. La perdita è
            asimmetrica.
          </li>
        </ul>

        <h2>3. Sharpe, Sortino, Calmar — il rendimento aggiustato per il rischio</h2>
        <ul>
          <li><strong>Sharpe</strong> = <code>(R_p − R_f) / σ_p</code>. Con rendimento 8%, risk-free 2%, volatilità 12% → Sharpe = <strong>0,5</strong>.</li>
          <li><strong>Sortino</strong> = come lo Sharpe, ma al denominatore solo la <em>downside deviation</em>: <code>(R_p − R_f) / σ_down</code>.</li>
          <li><strong>Calmar</strong> = <code>CAGR / |MDD|</code>. Con CAGR 12% e MDD −40% → Calmar = <strong>0,3</strong>.</li>
          <li><strong>Insidia:</strong> lo Sharpe presuppone rendimenti ~normali; con code grasse e asimmetria può ingannare. Tre lenti, non una.</li>
        </ul>

        <h2>4. Capture ratio, alfa e beta — abilità o solo esposizione al mercato?</h2>
        <p>Il modello CAPM scompone il rendimento: <code>R_p = R_f + β·(R_m − R_f) + α</code>.</p>
        <ul>
          <li><strong>Beta (β)</strong> = sensibilità al mercato: <code>β = Cov(R_p, R_m) / Var(R_m)</code>. β = 1,2 → ti muovi il 20% più del mercato.</li>
          <li><strong>Alfa (α)</strong> = il rendimento <em>non</em> spiegato dal mercato. È la (presunta) abilità.</li>
          <li><strong>Capture ratio:</strong> una buona strategia ha <em>up-capture</em> &gt; 100% e <em>down-capture</em> &lt; 100%.</li>
          <li>
            <strong>Significato:</strong> non pagare commissioni da "alfa" per qualcosa che è solo{" "}
            <strong>beta</strong>. Approfondisci in{" "}
            <a href="/it/kb/alpha-e-beta-negli-investimenti-come-calcolarli">Alpha e Beta</a>.
          </li>
        </ul>

        <h2>5. Backtest onesto — out-of-sample, walk-forward, capacità</h2>
        <ul>
          <li><strong>Out-of-sample:</strong> testa su dati non usati per costruire la strategia.</li>
          <li><strong>Walk-forward:</strong> ri-stima e testa "in avanti" a finestre mobili.</li>
          <li><strong>Multiple testing / deflated Sharpe:</strong> se provi 100 strategie, alcune sembreranno ottime <em>per fortuna</em>; lo Sharpe va "deflazionato" (López de Prado; Harvey-Liu-Zhu).</li>
          <li><strong>Capacità:</strong> una strategia che funziona su 100.000 € può rompersi su 100 milioni. Un backtest senza costi e capacità è un disegno, non una prova.</li>
        </ul>

        <h2>6. Tasse, costi e capacità — il vero nemico del rendimento netto</h2>
        <p>
          Costi (TER, spread, commissioni) e tasse (in Italia 26% sulle plusvalenze){" "}
          <strong>compongono contro di te</strong> anno dopo anno. Un <strong>turnover</strong> alto
          realizza plusvalenze e anticipa l'imposta. Misura sempre <strong>al netto</strong>.
        </p>

        <h2>In sintesi</h2>
        <p>
          Rendimento (CAGR), rischio (MDD, semivarianza, TTR), rendimento aggiustato (Sharpe, Sortino,
          Calmar), abilità vs mercato (alfa/beta, capture), onestà del processo e rendimento netto.
          Prova i concetti con il{" "}
          <a href="/it/kb/simulatore-portafoglio-etf-guida-metodologica">
            Simulatore di Portafoglio ETF
          </a>{" "}
          o vai direttamente agli{" "}
          <a href={withUtm("/it/tools", { source: "site", medium: "article", campaign: "metriche-portafoglio" })}>
            strumenti gratuiti
          </a>
          .
        </p>

        <h2>Fonti</h2>
        <p>
          López de Prado (2018), <em>Advances in Financial Machine Learning</em> · Harvey, Liu, Zhu
          (2016) · Sharpe (1966) · Sortino &amp; van der Meer (1991) · C. Bacon, <em>Practical
          Portfolio Performance Measurement</em> · report SPIVA (S&amp;P).
        </p>

        <p style={KB_DISC}>
          Contenuto educativo, non consulenza né raccomandazione. Le performance passate e i backtest
          non garantiscono risultati futuri.
        </p>
      </div>
    ),
  },

  {
    slug: "analisi-mercati-mensile",
    title: "Cosa guardiamo nei mercati ogni mese: la mappa dell'analisi macro",
    metaDescription:
      "Macro, regime dei tassi, rotazioni geografiche e settoriali, rischio: che cosa contiene l'aggiornamento mensile sui mercati di AlphaFrame, con le metriche spiegate ed esempi reali.",
    tags: ["mercati", "macro", "asset allocation", "tassi", "educazione"],
    readTime: "10 min",
    author: "Redazione",
    datePublished: "2026-06-25",
    dateUpdated: "2026-06-25",
    coverImage: CoverMarketUpdate,
    canonical: `${DOMAIN}/kb/analisi-mercati-mensile`,
    content: (
      <div>
        <h1>Cosa guardiamo nei mercati ogni mese: la mappa dell'analisi macro</h1>

        <p style={KB_DISC}>
          Contenuto educativo. L'analisi mensile legge ciò che è <em>già</em> accaduto e il regime{" "}
          <em>attuale</em>; non contiene previsioni né raccomandazioni. I dati provengono da fonti
          pubbliche (FRED, BCE, Eurostat). Le performance passate non garantiscono risultati futuri.
        </p>

        <h2>Non "dove va il mercato", ma "dove siamo"</h2>
        <p>
          Ogni mese pubblichiamo un aggiornamento sui mercati. Non promette di indovinare il futuro:
          fotografa il <strong>presente</strong> in modo strutturato, perché la maggior parte degli
          errori nasce dal leggere un solo dato (l'azionario che sale) ignorando ciò che gli altri
          mercati segnalano sotto la superficie. Qui spieghiamo le <strong>cinque lenti</strong> con
          cui lo facciamo.
        </p>

        <YouTubeEmbed
          playlistId="PL4Ivcohv28tKGuIwkYbI-RLKsNNOIihUE"
          title="Aggiornamenti mensili sui mercati — AlphaFrame"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>Le cinque lenti</h2>
        <p>
          <strong>1. Macro a confronto — crescita, inflazione, tassi reali.</strong> Il punto non è
          il dato isolato ma il <em>confronto</em>. Esempio reale (maggio 2026): USA con PIL reale
          ~+2,6% e inflazione core ~2,7% mentre i Fed Funds restano sopra (~3,6%) →{" "}
          <strong>tassi reali positivi senza recessione</strong>. L'Europa al contrario: crescita ~+1%
          ma inflazione ~+3% con depositi BCE al 2% → il manuale chiama questo{" "}
          <strong>stagflazione strisciante</strong>. <em>(Tasso reale ≈ tasso nominale − inflazione.)</em>
        </p>
        <p>
          <strong>2. Il regime e la curva dei tassi.</strong> Lo spread tra rendimento a 10 anni e a 2
          anni è il barometro. Un'<strong>inversione</strong> (10y &lt; 2y) storicamente anticipa
          recessione; un ritorno alla parità (esempio maggio 2026: spread ~0,00%) segnala un{" "}
          <strong>regime shift</strong>: estendere la duration non viene più ricompensato.
        </p>
        <p>
          <strong>3. Rotazioni geografiche.</strong> Confrontiamo gli indici per area (performance a 1
          anno). Esempio: S&amp;P 500 ~+24,7% vs MSCI Europe ~+5,8%. Ma il numero va{" "}
          <strong>contestualizzato</strong> (valuta, composizione settoriale).
        </p>
        <p>
          <strong>4. Rotazioni settoriali.</strong> Chi guida e chi resta indietro, e a che prezzo di
          rischio — guardando lo <strong>Sharpe</strong> di settore e il livello del{" "}
          <strong>VIX</strong>. Uno Sharpe settoriale che "sfida la statistica" è un segnale di
          concentrazione, non solo di forza.
        </p>
        <p>
          <strong>5. Implicazioni per il rischio.</strong> È il "e quindi?": con una curva piatta la
          gestione attiva della duration perde efficacia come fonte di alfa, e l'attenzione si sposta
          su selezione del credito o strategie <em>barbell</em>.
        </p>

        <h2>Le metriche, in una riga ciascuna</h2>
        <ul>
          <li><strong>Tasso reale</strong> = nominale − inflazione: quanto "morde" la politica monetaria.</li>
          <li><strong>Spread di curva (10y−2y)</strong> = tensione sul ciclo: inversione → timore recessione; piatta → regime shift.</li>
          <li><strong>Sharpe</strong> = rendimento extra per unità di volatilità.</li>
          <li><strong>VIX</strong> = volatilità attesa: il "termometro della paura".</li>
          <li><strong>Performance valutaria-aggiustata</strong> = confronto onesto tra aree con valute diverse.</li>
        </ul>

        <h2>Nota di metodo</h2>
        <p>
          Leggiamo sempre <strong>al passato/presente</strong>, mai in previsione certa; usiamo dati
          pubblici (FRED, BCE, Eurostat, ISTAT) e li mettiamo a confronto invece di isolarli. È lo
          stesso rigore che applichiamo ai modelli — vedi le{" "}
          <a href="/it/kb/metriche-di-portafoglio">metriche di portafoglio</a>.
        </p>

        <h2>Gli output del report: esempi reali, commentati</h2>
        <p>
          Di seguito alcune slide tratte da un'edizione reale del report mensile (la serie video{" "}
          <strong>T8</strong>, mese di esempio: aprile 2026). Sono esempi illustrativi del{" "}
          <em>tipo</em> di analisi che condividiamo, non raccomandazioni: indici e settori sono
          riportati con nomi descrittivi, non come suggerimenti d'acquisto.
        </p>

        <figure style={KB_FIG}>
          <img
            src={MktMacro}
            alt="Contesto macroeconomico Eurozona: PIL reale, inflazione HICP e tasso di deposito BCE con i rispettivi trend"
            style={KB_IMG}
          />
          <figcaption style={KB_CAP}>
            <strong>1 · Macro a confronto (Eurozona).</strong> Le tre carte in alto fissano i numeri
            chiave del mese — PIL reale, inflazione HICP, tasso BCE — ognuno con la{" "}
            <em>variazione</em> rispetto al periodo precedente; i mini-grafici sotto mostrano il
            trend. Il valore non è il singolo dato ma la <strong>direzione combinata</strong>:
            crescita debole con inflazione ancora sopra l'obiettivo è il quadro che leggiamo come
            pressione di tipo stagflattivo. Fonte: FRED / Eurostat.
          </figcaption>
        </figure>

        <figure style={KB_FIG}>
          <img
            src={MktGeo}
            alt="Mercati geografici: andamento cumulato a 12 mesi (base 100) di S&P 500, MSCI World, MSCI Europe e Mercati Emergenti"
            style={KB_IMG}
          />
          <figcaption style={KB_CAP}>
            <strong>2 · Rotazioni geografiche.</strong> Quattro grandi aree normalizzate a base 100
            sull'ultimo anno (S&amp;P 500, MSCI World, MSCI Europe, Mercati Emergenti). Si legge a
            colpo d'occhio chi guida e chi resta indietro, e soprattutto lo <strong>scarto</strong>:
            qui gli Emergenti staccano e l'Europa resta dietro al mercato globale. Da contestualizzare
            sempre con la valuta — parte dello scarto è effetto cambio, non solo forza dei sottostanti.
          </figcaption>
        </figure>

        <figure style={KB_FIG}>
          <img
            src={MktSectors}
            alt="Settori USA: ritorni a 1 mese (barre) e a 1 anno (rombi) per i principali settori"
            style={KB_IMG}
          />
          <figcaption style={KB_CAP}>
            <strong>3 · Rotazioni settoriali.</strong> I settori USA ordinati per ritorno: le barre
            sono l'ultimo mese, i rombi l'ultimo anno. La lettura interessante è lo{" "}
            <strong>scollamento</strong> tra i due orizzonti — un settore forte sull'anno ma debole
            sul mese segnala una rotazione in corso. Una concentrazione estrema in un'area (qui la
            tecnologia, molto avanti sull'anno) è un segnale di rischio, non solo di forza.
          </figcaption>
        </figure>

        <figure style={KB_FIG}>
          <img
            src={MktBonds}
            alt="Obbligazionario in euro: performance multi-orizzonte di titoli di Stato Eurozona, corporate e Treasury USA"
            style={KB_IMG}
          />
          <figcaption style={KB_CAP}>
            <strong>4 · Il lato obbligazionario.</strong> Performance multi-orizzonte (1M/3M/6M/1A) di
            titoli di Stato Eurozona, corporate in euro e Treasury USA 7-10 anni. È la lente sui{" "}
            <strong>tassi</strong>: quando la duration "morde", il segno può cambiare tra orizzonti
            vicini. Il confronto Eurozona vs Treasury USA mostra anche l'effetto del differenziale di
            tasso e del cambio — lo stesso tema della{" "}
            <a href="/it/kb/copertura-valutaria-etf-hedged-vs-unhedged">copertura valutaria</a>.
          </figcaption>
        </figure>

        <p>
          Nessuno di questi grafici dice "compra": dicono <em>dove siamo</em> e <em>com'è distribuito
          il rischio</em>. Tradurre questa fotografia in decisioni richiede il contesto del singolo
          investitore — ed è un passo separato dall'analisi.
        </p>

        <h2>Fonti</h2>
        <p>FRED (Federal Reserve di St. Louis) · BCE · Eurostat · ISTAT.</p>

        <p style={KB_DISC}>
          Contenuto educativo, non consulenza né raccomandazione. Le performance passate non
          garantiscono risultati futuri.
        </p>
      </div>
    ),
  },

  {
    slug: "etf-race-1000-euro-2006",
    title: "€1.000 nel 2006: 20 anni di mercato in una corsa di ETF",
    metaDescription:
      "$1.000 investiti nel 2006 su 13 ETF, dividendi reinvestiti, nessun ribilanciamento: dove finiscono in 20 anni? Il podio nominale, e la sorpresa quando si guarda al netto dell'inflazione.",
    tags: ["etf", "rendimenti", "inflazione", "lungo periodo", "educazione"],
    readTime: "9 min",
    author: "Redazione",
    datePublished: "2026-06-26",
    dateUpdated: "2026-06-26",
    coverImage: CoverEtfRace,
    canonical: `${DOMAIN}/kb/etf-race-1000-euro-2006`,
    content: (
      <div>
        <h1>€1.000 nel 2006: 20 anni di mercato in una corsa di ETF</h1>

        <p style={KB_DISC}>
          Contenuto educativo. È un esperimento storico su dati passati, non una raccomandazione né
          una previsione. Il passato non è garanzia di futuro.
        </p>

        <h2>L'esperimento, in una riga</h2>
        <p>
          Gennaio 2006: <strong>$1.000</strong> sullo stesso giorno su <strong>13 ETF</strong> — 8
          settori USA (Tech, Salute, Energia, Industria, Beni di consumo, Immobiliare, Telecom,
          Utility), Europa, Mercati Emergenti, Oro, Treasury 20+ anni, TIPS. <strong>Dividendi
          reinvestiti, nessun ribilanciamento, nessun timing.</strong> Solo prezzi di chiusura
          mensili — 245 punti dati — trasformati in una corsa animata di 80 secondi.
        </p>

        <YouTubeEmbed
          videoId="QNgwJP7lx94"
          title="$1.000 nel 2006: 20 anni di mercato in 80 secondi"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>Il podio (in termini nominali)</h2>
        <div style={{ overflowX: "auto" }}>
          <table className="kb-table">
            <thead><tr><th></th><th>ETF</th><th>Valore finale</th><th>CAGR</th></tr></thead>
            <tbody>
              <tr><td>🥇</td><td>Tech (USA)</td><td><strong>$21.544</strong></td><td>16,27%</td></tr>
              <tr><td>🥈</td><td>Oro</td><td>$7.856</td><td>10,65%</td></tr>
              <tr><td>🥉</td><td>Industria (USA)</td><td>$6.935</td><td>9,98%</td></tr>
              <tr><td>14°</td><td>TIPS</td><td>$1.960</td><td>3,36%</td></tr>
              <tr><td>15°</td><td>Treasury 20y+ (TLT)</td><td>$1.741</td><td>2,76%</td></tr>
            </tbody>
          </table>
        </div>
        <p><strong>Tre cose che la corsa mostra meglio di qualunque tabella:</strong></p>
        <ol>
          <li><strong>Il distacco del Tech non è lineare:</strong> si stabilizza intorno al 2010 e diventa incolmabile. Restare ancorati ai settori "difensivi" ha significato rinunciare a un multiplo 3-4×.</li>
          <li><strong>L'oro batte 11 ETF azionari su 12.</strong> L'etichetta di "asset morto" non regge contro $7.856 partiti da $1.000.</li>
          <li><strong>Il "porto sicuro" è la barca più lenta:</strong> Treasury lunghi e TIPS, in 20 anni, hanno poco più che raddoppiato — in termini <em>nominali</em>.</li>
        </ol>

        <h2>La svolta: gli stessi numeri, al netto dell'inflazione</h2>
        <p>
          L'inflazione USA dal 2006 al 2026 è stata <strong>+66,8%</strong> (un dollaro di allora vale
          circa 60 centesimi oggi). Deflazionando, <strong>ogni ETF perde circa il 40%</strong> del
          valore apparente. Il podio <em>reale</em>:
        </p>
        <div style={{ overflowX: "auto" }}>
          <table className="kb-table">
            <thead><tr><th></th><th>ETF</th><th>Valore reale</th><th>CAGR reale</th></tr></thead>
            <tbody>
              <tr><td>🥇</td><td>Tech (USA)</td><td><strong>$12.668</strong></td><td>13,30%</td></tr>
              <tr><td>🥈</td><td>Oro</td><td>$4.413</td><td>7,58%</td></tr>
              <tr><td>🥉</td><td>Industria (USA)</td><td>$4.131</td><td>7,23%</td></tr>
              <tr><td>…</td><td>Treasury 20y+ (TLT)</td><td>~$1.057</td><td>+0,27%</td></tr>
              <tr><td>…</td><td>TIPS</td><td>~$1.177</td><td>+0,81%</td></tr>
            </tbody>
          </table>
        </div>
        <p>
          Il dato che resta impresso: <strong>TLT e TIPS, i "porti sicuri", in 20 anni reali sono
          praticamente fermi.</strong> Non hanno protetto, hanno solo <em>tenuto</em> il valore.
          L'inflazione è la marea che muove tutte le barche — e va misurata sempre.
        </p>

        <h2>Cosa portarsi a casa</h2>
        <ul>
          <li><strong>Misura sempre in termini reali.</strong> Un rendimento nominale a doppia cifra può nascondere un reale modesto: solo il <strong>CAGR reale positivo</strong> costruisce ricchezza.</li>
          <li><strong>"Safe haven" è un'etichetta nominale.</strong> In reale, il porto sicuro può essere quasi piatto.</li>
          <li><strong>I dividendi contano:</strong> è un esperimento <em>total return</em>. Senza, i numeri sarebbero altri.</li>
          <li><strong>Concentrazione ≠ garanzia:</strong> il Tech ha vinto <em>in questo</em> ventennio. Il passato non è garanzia di futuro.</li>
        </ul>

        <h2>Metodologia</h2>
        <p>
          Total return (dividendi reinvestiti), nessun ribilanciamento, prezzi mensili, periodo
          2006→2026, confronto nominale <strong>e</strong> reale (deflatore CPI USA). La stessa
          disciplina che usiamo sui modelli: dati datati, ipotesi esplicite, niente cherry-picking
          della data di partenza.
        </p>

        <h2>Continua</h2>
        <ul>
          <li>Rifai l'esperimento sui tuoi parametri con il <a href="/it/kb/simulatore-portafoglio-etf-guida-metodologica">Simulatore di Portafoglio ETF</a>.</li>
          <li>Perché "reale" batte "nominale": <a href="/it/kb/metriche-di-portafoglio">come si misura un investimento</a>.</li>
          <li>Tutte le corse dei dati: <a href="https://youtube.com/playlist?list=PLOnGySAJa_74" target="_blank" rel="noopener noreferrer">playlist "La corsa dei dati"</a>.</li>
        </ul>

        <p style={KB_DISC}>
          Esperimento educativo su dati storici. Non è consulenza né raccomandazione. Le performance
          passate non garantiscono risultati futuri.
        </p>
      </div>
    ),
  },

  {
    slug: "magnifici-7-concentrazione-mercato",
    title: "I Magnifici 7 e la concentrazione del mercato",
    metaDescription:
      "La corsa alla capitalizzazione dei 7 colossi tech e cosa significa per chi investe in indici: quanto sei davvero diversificato quando compri 'il mercato'?",
    tags: ["azioni", "indici", "concentrazione", "rischio", "educazione"],
    readTime: "8 min",
    author: "Redazione",
    datePublished: "2026-06-26",
    dateUpdated: "2026-06-26",
    coverImage: FactorCover,
    canonical: `${DOMAIN}/kb/magnifici-7-concentrazione-mercato`,
    content: (
      <div>
        <h1>I Magnifici 7 e la concentrazione del mercato</h1>

        <p style={KB_DISC}>
          Contenuto educativo. Nessun nome è una raccomandazione. Le performance passate non
          garantiscono risultati futuri.
        </p>

        <h2>La corsa dei giganti</h2>
        <p>
          Apple, Microsoft, Alphabet, Amazon, Nvidia, Meta, Tesla: i <strong>"Magnifici 7"</strong>.
          La corsa alla capitalizzazione di mercato di questi sette nomi racconta una delle storie più
          importanti — e meno capite — per chi investe oggi: la <strong>concentrazione</strong>.
        </p>
        <p><em>(Video dedicato in arrivo.)</em> Intanto, guarda la serie completa:</p>

        <YouTubeEmbed
          playlistId="PLOnGySAJa_74"
          title="La corsa dei dati — AlphaFrame"
          onPlay={(id) => trackVideoPlay(id, "article")}
        />

        <h2>Perché conta, anche se non possiedi quei titoli</h2>
        <p>
          La maggior parte degli investitori "passivi" pensa di comprare <em>il mercato</em> con un
          ETF sull'indice. Ma quando 7 titoli arrivano a pesare una quota enorme dell'indice, "il
          mercato" diventa, di fatto, <strong>una scommessa concentrata su 7 aziende dello stesso
          settore</strong>. Non è sbagliato di per sé — ma è bene <strong>sapere cosa si
          possiede</strong>:
        </p>
        <ul>
          <li>La diversificazione <em>apparente</em> (centinaia di titoli) può nascondere una concentrazione <em>effettiva</em> altissima ai vertici.</li>
          <li>Il rendimento dell'indice negli ultimi anni è stato trainato in larga parte da quei pochi nomi: è <strong>beta concentrato</strong>, non un'ampia esposizione bilanciata.</li>
          <li>Quando la leadership si inverte, la stessa concentrazione che ha spinto al rialzo amplifica al ribasso.</li>
        </ul>

        <h2>Il legame con alfa, beta e rischio</h2>
        <p>
          Comprare l'indice oggi significa, in buona parte, comprare l'andamento di quei 7 titoli —
          cioè <strong>beta</strong> verso un cluster ristretto. Capire quanto del tuo "mercato" è
          concentrato è il primo passo per decidere se ti basta. Approfondisci in{" "}
          <a href="/it/kb/alpha-e-beta-negli-investimenti-come-calcolarli">Alpha e Beta</a> e in{" "}
          <a href="/it/kb/metriche-di-portafoglio">come si misura un investimento</a>.
        </p>

        <h2>Metodologia</h2>
        <p>
          Capitalizzazione di mercato nel tempo (fonte dati di mercato), confronto a barre che si
          riordinano. Periodo dichiarato nel video; nessuna proiezione.
        </p>

        <p style={KB_DISC}>
          Contenuto educativo, non raccomandazione. Le performance passate non garantiscono risultati
          futuri.
        </p>
      </div>
    ),
  },
  {
    slug: "tolleranza-al-rischio-cosa-misura-un-questionario",
    title: "Tolleranza al rischio: cosa misura davvero un questionario (e cosa no)",
    metaDescription:
      "Perché banche e consulenti fanno compilare un questionario prima di investire, cosa misura (tolleranza, capacità, orizzonte), perché la tolleranza dichiarata è diversa da quella vissuta, e come provare la logica con il Risk Lab, un esercizio educativo gratuito.",
    tags: ["rischio", "tolleranza al rischio", "drawdown", "educazione", "tools"],
    readTime: "9 min",
    author: "Redazione",
    datePublished: "2026-07-12",
    dateUpdated: "2026-07-12",
    coverImage: CoverRiskLab,
    canonical: `${DOMAIN}/kb/tolleranza-al-rischio-cosa-misura-un-questionario`,
    content: (
      <div>
        <h1>Tolleranza al rischio: cosa misura davvero un questionario (e cosa no)</h1>

        <p style={KB_DISC}>
          Contenuto a scopo esclusivamente educativo. Non costituisce consulenza personalizzata,
          raccomandazione né valutazione di adeguatezza. Il Risk Lab citato è un esercizio didattico:
          non raccoglie né salva dati e non produce raccomandazioni.
        </p>

        <h2>Perché ti fanno compilare un questionario</h2>
        <p>
          Chiunque abbia aperto un conto titoli lo ha incontrato: prima di investire, banche e
          consulenti devono farti domande su obiettivi, orizzonte, esperienza e reazione alle perdite.
          Non è burocrazia decorativa: le regole europee sui servizi di investimento (la direttiva
          nota come MiFID II) impongono agli intermediari di <strong>valutare l'adeguatezza</strong>{" "}
          di ciò che propongono rispetto a chi hanno davanti. L'idea di fondo è semplice e seria: un
          investimento può essere ottimo in astratto e sbagliato <em>per una persona specifica</em>,
          se la costringe a vendere nel momento peggiore.
        </p>

        <h2>Le tre dimensioni (e quella che il questionario misura peggio)</h2>
        <p>Un buon processo di profilazione guarda almeno tre cose diverse:</p>
        <ul>
          <li>
            <strong>Tolleranza al rischio</strong> (willingness): quanta perdita <em>psicologicamente</em>{" "}
            sopporti senza cambiare piano. È un tratto personale, non un dato di bilancio.
          </li>
          <li>
            <strong>Capacità di rischio</strong> (ability): quanta perdita il tuo <em>bilancio</em>{" "}
            può assorbire senza compromettere obiettivi essenziali — dipende da reddito, riserve,
            debiti, spese.
          </li>
          <li>
            <strong>Orizzonte temporale</strong>: per quanto tempo puoi non toccare il capitale. È
            ciò che trasforma una caduta temporanea in un problema permanente, o viceversa.
          </li>
        </ul>
        <p>
          Il punto debole è il primo: la tolleranza viene <strong>dichiarata</strong> a mercati
          tranquilli, davanti a un modulo, e <strong>vissuta</strong> a mercati in caduta, davanti a
          un saldo in rosso. Le due cose spesso non coincidono.
        </p>

        <h2>Il numero che collega dichiarato e vissuto: il drawdown</h2>
        <p>
          La misura più concreta di "quanto fa male" è il <strong>maximum drawdown</strong> (MDD): la
          distanza tra il punto più alto toccato dal portafoglio e il minimo successivo. Ha due
          proprietà che ogni investitore dovrebbe conoscere. Primo, è <em>asimmetrico</em>: dopo un
          −20% serve +25% per tornare pari; dopo un −50% serve <strong>+100%</strong>. Secondo, ha
          una durata: non conta solo quanto scendi, ma per quanti anni resti sotto il massimo
          precedente. Trovi le altre metriche in{" "}
          <a href="/it/kb/metriche-di-portafoglio">come si misura un investimento</a>.
        </p>

        <h2>Dichiarato vs vissuto: tre date da ricordare</h2>
        <ul>
          <li>
            <strong>2008</strong>: l'azionario globale perse circa un terzo del valore nell'anno; dal
            picco 2007 al minimo 2009, oltre metà. Chi aveva dichiarato "sopporto il −15%" scoprì
            cosa significa vederne il doppio.
          </li>
          <li>
            <strong>Marzo 2020</strong>: circa −30% in un mese, con recupero rapidissimo. Chi guardava
            solo i dati di fine anno non lo vide nemmeno — ma chi era investito lo visse eccome.
          </li>
          <li>
            <strong>2022</strong>: l'anno che ha sorpreso i prudenti. Anche le obbligazioni persero
            (circa −17% per l'aggregato euro): il rifugio tradizionale non riparò, e i portafogli
            difensivi soffrirono quanto e più dei bilanciati.
          </li>
        </ul>

        <h2>Prova la logica dall'interno: il Risk Lab</h2>
        <p>
          Per rendere tutto questo tangibile abbiamo costruito il{" "}
          <a href="/it/tools?tool=risk">
            <strong>Risk Lab</strong>
          </a>
          , un esercizio educativo gratuito che replica la <em>logica</em> della profilazione: sette
          domande producono un punteggio e un <strong>profilo-tipo didattico</strong> (da Difensivo ad
          Aggressivo, ciascuno con un mix illustrativo azioni/obbligazioni); l'ottava domanda fissa la
          tua soglia di sopportazione; poi l'esercizio confronta quella soglia con{" "}
          <strong>25 anni di storia stilizzata</strong> del mix: caduta massima, anni per rivedere il
          massimo, valore finale di 10.000 €.
        </p>
        <p>
          La parte interessante è quando i due numeri litigano: se la storia del mix ha superato la
          soglia dichiarata, l'esercizio lo dice — con le cifre — e mostra per confronto il
          profilo-tipo che sarebbe rimasto entro la soglia, e il suo costo in crescita mancata. Con le
          soglie più prudenti (−5%, −15%) scoprirai una lezione che vale da sola l'esercizio: su
          quei 25 anni <strong>nessun</strong> mix illustrativo, nemmeno il più difensivo, è rimasto
          entro la soglia — colpa soprattutto del 2022. La sicurezza assoluta, nei mercati, non è in
          listino.
        </p>

        <h2>Cosa il Risk Lab NON è (importante)</h2>
        <ul>
          <li>
            <strong>Non è un questionario di adeguatezza</strong>: non considera la tua situazione
            patrimoniale complessiva, i tuoi obiettivi reali né la tua capacità di sostenere perdite.
          </li>
          <li>
            <strong>Non produce raccomandazioni</strong>: i profili-tipo e i mix sono categorie
            didattiche su serie stilizzate, non proposte di investimento.
          </li>
          <li>
            <strong>Non salva nulla</strong>: risposte e risultato restano nel tuo browser.
          </li>
          <li>
            I dati sono <strong>chiusure annuali</strong>: le cadute reali infra-anno sono più
            profonde di quelle mostrate (marzo 2020 non appare proprio) — l'esercizio lo dichiara.
          </li>
        </ul>
        <p>
          Per decisioni reali serve una valutazione completa presso un soggetto autorizzato: il
          questionario vero, con tutte e tre le dimensioni.
        </p>

        <p style={KB_DISC}>
          Contenuto educativo, non raccomandazione né consulenza. I rendimenti passati non sono
          indicativi di quelli futuri. Le serie citate sono stilizzate, al lordo di costi, imposte e
          inflazione.
        </p>
      </div>
    ),
  },
  {
    slug: "derivati-concetti-chiave",
    title: "Derivati: gli otto passaggi chiave della serie, dal future a Black-Scholes",
    metaDescription:
      "I concetti che reggono tutta la serie video sui derivati: margini e mark-to-market, hedge ratio, cost of carry, DV01 e swap, payoff delle opzioni, put-call parity, albero binomiale, Black-Scholes e volatilità implicita. Con formule ed esempi.",
    tags: ["derivati", "future", "opzioni", "black-scholes", "educazione"],
    readTime: "12 min",
    author: "Redazione",
    datePublished: "2026-10-15",
    dateUpdated: "2026-10-15",
    coverImage: CoverDerivatiPillar,
    canonical: `${DOMAIN}/it/kb/derivati-concetti-chiave`,
    content: (
      <div>
        <h1>Derivati: gli otto passaggi chiave della serie, dal future a Black-Scholes</h1>

        <p style={KB_DISC}>
          Contenuto a scopo esclusivamente educativo e informativo. Non costituisce consulenza in
          materia di investimenti, raccomandazione né sollecitazione. I derivati sono strumenti
          complessi e possono comportare perdite anche superiori al capitale investito. Gli esempi
          numerici sono ipotetici.
        </p>

        <p>
          La serie video sui derivati conta ormai una dozzina di episodi, e non serve riassumerli
          tutti. Qui ci sono gli otto passaggi che reggono il resto: quelli da avere chiari prima di
          guardare un modello di prezzo o di leggere il prospetto di un prodotto strutturato. Ogni
          passaggio rimanda all'episodio che lo tratta per esteso, con video e scheda, nella{" "}
          <a href="/it/series/derivati">pagina della serie</a>.
        </p>

        <h2>1. Il future funziona senza fiducia</h2>
        <p>
          Un contratto a termine privato regge finché la controparte resta solvibile. Il future
          parte dal presupposto opposto: la fiducia non serve. Tra compratore e venditore si mette
          una clearing house, e ogni sera la posizione viene rivalutata al prezzo di chiusura. Chi
          ha perso versa, chi ha guadagnato incassa. Se il conto scende sotto il margine di
          mantenimento arriva la richiesta di reintegro.
        </p>
        <p>
          La conseguenza è curiosa. Il sistema nel suo insieme diventa più sicuro, perché nessuna
          perdita si accumula per mesi senza essere pagata; il singolo operatore invece è più
          esposto, perché con un margine del 10% un calo del 3% del sottostante si porta via il 30%
          di quanto ha versato. → <a href="/it/series/derivati#ep-2">Episodio 2</a>
        </p>

        <h2>2. Coprirsi riduce il rischio, non lo cancella</h2>
        <p>
          Chi copre un'esposizione con un future scambia il rischio di prezzo con un rischio più
          piccolo e diverso, il rischio di base: la differenza tra prezzo a pronti e prezzo del
          future nel giorno in cui la copertura si chiude. Il numero di contratti che rende minima
          la varianza della posizione coperta dipende da correlazione e volatilità:
        </p>
        <BM>{tex`h^{*} = \rho\,\frac{\sigma_S}{\sigma_F}`}</BM>
        <p>
          Con una correlazione di 0,9 e volatilità del 2% e del 2,5%, il rapporto ottimo è 0,72, non
          1. Per un portafoglio azionario lo stesso ruolo lo gioca il beta rispetto all'indice. In
          entrambi i casi le stime vengono dal passato e possono tradire proprio quando la copertura
          serve di più. → <a href="/it/series/derivati#ep-3">Episodio 3</a>
        </p>

        <h2>3. Il prezzo a termine è un conto, non una previsione</h2>
        <p>
          Comprare il sottostante oggi e tenerlo fino alla scadenza deve costare quanto comprarlo a
          termine. Se non fosse così, qualcuno comprerebbe dove costa meno e venderebbe dove costa di
          più fino a chiudere la differenza. Da qui la formula del cost of carry:
        </p>
        <BM>{tex`F_0 = S_0\, e^{(r-q)T}`}</BM>
        <p>
          dove <IM>{tex`q`}</IM> è il rendimento da dividendi per un indice, il tasso estero per una
          valuta, oppure il convenience yield al netto dei costi di stoccaggio per una materia prima.
          Con l'indice a 100, il tasso al 4% e i dividendi al 2%, il prezzo a un anno è circa 102,02.
          Un future più alto dello spot non dice che il mercato si aspetta un rialzo: dice che il
          denaro costa più di quanto rendano i dividendi. →{" "}
          <a href="/it/series/derivati#ep-5">Episodio 5</a>
        </p>

        <h2>4. Il rischio di tasso si misura in euro per punto base</h2>
        <p>
          Per un portafoglio obbligazionario la domanda utile è concreta: quanti euro si perdono se i
          rendimenti salgono di un punto base? È il DV01.
        </p>
        <BM>{tex`\text{DV01} = P \cdot D_{mod} \cdot 0{,}0001`}</BM>
        <p>
          Dieci milioni con duration modificata 6 fanno 6.000 € per punto base; se un future sui
          titoli di Stato ha un DV01 di 90 €, la copertura richiede circa 67 contratti. Vale per
          piccoli spostamenti paralleli della curva, e solo per quelli. Lo swap su tassi lavora sulla
          stessa leva: chi paga fisso e riceve variabile ha in mano, di fatto, un'obbligazione a tasso
          variabile comprata e una a tasso fisso venduta, e il valore dello swap è la differenza tra le
          due. → <a href="/it/series/derivati#ep-6">Episodio 6</a> ·{" "}
          <a href="/it/series/derivati#ep-7">Episodio 7</a>
        </p>

        <h2>5. Un'opzione è un'asimmetria, e l'asimmetria si paga</h2>
        <p>
          Il future guadagna e perde in linea retta. L'opzione comprata no: sopra lo strike la call
          segue il sottostante, sotto si ferma al premio pagato.
        </p>
        <BM>{tex`\text{call} = \max(S_T - K,\,0) \qquad \text{put} = \max(K - S_T,\,0)`}</BM>
        <p>
          Quella forma piegata ha un prezzo. Il premio contiene il valore intrinseco e un valore
          temporale che paga la possibilità di movimenti favorevoli prima della scadenza, e che si
          consuma giorno dopo giorno. Dall'altra parte, chi vende l'opzione incassa il premio e si
          prende il rischio che il compratore ha scaricato. Le strategie con più gambe (covered call,
          protective put, spread, straddle) non creano valore dal nulla: spostano guadagni e perdite
          da una zona all'altra del grafico, e quelle che sembrano quasi sicure di solito nascondono
          una perdita rara ma ampia. → <a href="/it/series/derivati#ep-8">Episodio 8</a> ·{" "}
          <a href="/it/series/derivati#ep-10">Episodio 10</a>
        </p>

        <h2>6. Call e put sono legate da un vincolo</h2>
        <p>
          Prima di qualsiasi modello esiste una relazione che non lascia margini di opinione. Una
          call più un deposito pari allo strike attualizzato rendono a scadenza esattamente quanto una
          put più il sottostante, quindi oggi devono costare uguale:
        </p>
        <BM>{tex`c + K e^{-rT} = p + S_0`}</BM>
        <p>
          Con sottostante e strike a 100, tasso al 3% e un anno di vita, se la call vale 10 la put
          deve valere 7,04. Se i prezzi in una catena di opzioni non rispettano la parità, al netto di
          costi e dividendi, c'è un errore da qualche parte. →{" "}
          <a href="/it/series/derivati#ep-9">Episodio 9</a>
        </p>

        <h2>7. Si prezza replicando</h2>
        <p>
          Il passaggio concettuale più importante della serie è anche il più semplice da vedere
          sull'albero binomiale. Se il sottostante a 100 può salire a 110 o scendere a 90, mezza
          azione meno una call con strike 100 vale 45 in entrambi i casi. Un portafoglio senza rischio
          deve rendere il tasso privo di rischio; con il 5% vale oggi 42,81, e la call vale quindi 50
          meno 42,81, cioè 7,19.
        </p>
        <p>
          Nel calcolo non entra mai la probabilità che il prezzo salga. Entra solo ciò che si può
          comprare e vendere oggi. È la stessa idea che regge i modelli più complessi, e spiega perché
          il prezzo di un'opzione non dipende dall'ottimismo di chi la compra. Il numero di azioni che
          rende il portafoglio senza rischio, qui 0,5, è il delta. →{" "}
          <a href="/it/series/derivati#ep-11">Episodio 11</a>
        </p>

        <h2>8. Black-Scholes e la volatilità implicita</h2>
        <p>
          Se i passi dell'albero diventano infinitesimi, il sottostante segue un moto browniano
          geometrico: l'incertezza cresce con la radice del tempo e il logaritmo del prezzo ha
          distribuzione normale. Una volatilità annua del 20% diventa circa il 5,8% su un mese. Dal
          lemma di Itô si arriva alla formula di Black-Scholes:
        </p>
        <BM>{tex`c = S_0 N(d_1) - K e^{-rT} N(d_2)`}</BM>
        <p>
          Dei cinque ingredienti, quattro si osservano sul mercato; la volatilità no. Per questo il
          mercato usa la formula al contrario: parte dal prezzo e ricava la volatilità implicita. Con
          sottostante e strike a 100, tasso al 3% e volatilità al 20%, la call vale circa 9,41; se
          quota 10,50, il mercato sta prezzando una volatilità vicina al 22,8%. Che la volatilità
          implicita cambi da uno strike all'altro, lo smile, è il segno più visibile dei limiti del
          modello: salti, code spesse, volatilità che non resta ferma. →{" "}
          <a href="/it/series/derivati#ep-12">Episodio 12</a> ·{" "}
          <a href="/it/series/derivati#ep-13">Episodio 13</a>
        </p>

        <h2>Il filo che li lega</h2>
        <p>
          Gli otto passaggi raccontano la stessa idea da angoli diversi. Il prezzo di un derivato non
          dipende da quello che pensiamo succederà, ma da quello che si può replicare oggi con
          strumenti già quotati, e l'arbitraggio è il meccanismo che tiene insieme i prezzi. Capirlo
          non rende i derivati meno rischiosi. Aiuta però a riconoscere quando un prodotto promette
          qualcosa che i conti non permettono.
        </p>
        <p>
          Gli episodi completi, con una scheda per ciascuno, sono nella{" "}
          <a href="/it/series/derivati">serie Strumenti derivati</a>. Per le basi:{" "}
          <a href="/it/kb/derivati-spiegati-semplice">Derivati: cosa sono e come funzionano</a>.
        </p>

        <h2>Fonti</h2>
        <p>
          J. C. Hull, <em>Options, Futures and Other Derivatives</em>, 10ª ed., capp. 2-7 e 10-15 ·
          Borsa Italiana, glossario dei derivati.
        </p>

        <p style={KB_DISC}>
          Le informazioni hanno scopo esclusivamente educativo. Non costituiscono raccomandazione né
          consulenza personalizzata. Le performance passate non garantiscono risultati futuri.
        </p>
      </div>
    ),
  },
];

// Aggiungo l'articolo FIRE e i nuovi articoli KB all'array
const allArticlesIT = [...articles.slice(0, articles.length), fireArticleIT, compoundArticleIT, ...newKbArticlesIT];

export const getArticleBySlug = (slug) => allArticlesIT.find((a) => a.slug === slug);

export default allArticlesIT;
